import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import Axios from 'axios';
import Modal from 'react-modal';
import Switch from 'react-switch';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import ReactGA from 'react-ga4';

import SubPeopleMatching from '../Subcomponents/PeopleMatching';
import SubCourses from '../Subcomponents/CoursesTwo';
import SubCareers from '../Subcomponents/Careers';
import SubOpportunities from '../Subcomponents/Opportunities';
import SubCreatePost from '../Common/CreatePost';
import SubAssistantWidget from '../Common/AssistantWidget';
import SubRenderSuggestion from '../Common/RenderSuggestion';
import {
  EmailShareButton,FacebookShareButton,LinkedinShareButton, PinterestShareButton,RedditShareButton,
  TwitterShareButton,WhatsappShareButton,WorkplaceShareButton,

  EmailIcon,FacebookIcon,LinkedinIcon, PinterestIcon,RedditIcon,TwitterIcon,WhatsappIcon, WorkplaceIcon
} from "react-share";
import withRouter from '../Functions/WithRouter';
import {convertDateToString} from '../Functions/ConvertDateToString';
import {toggleVars} from '../Functions/ToggleVars';
// import {convertStringToDate} from '../Functions/ConvertStringToDate';

const deniedIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/denied-icon.png";
const addCircleOutlineIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/add-circle-outline-icon.png";
const addIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/add-icon.png";
const addIconBlue = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/add-icon-blue.png";
const exitIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/exit-icon.png";
const loadingGIF = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/loading-gif.gif';
const experienceIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/experience-icon.png";
const skillsIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/skills-icon.png";
const profileIconDark = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/profile-icon-dark.png";
const closeIcon = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/close-icon.png";
const questionMarkBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/question-mark-blue.png';
const shareIconDark = "https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/share-icon-dark.png";
const sendIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/send-icon-dark.png';
const newsFeedIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/news-feed-icon-dark.png';
const targetIconOrange = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/target-icon-orange.png';

const arrowIndicatorIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/arrow-indicator-icon.png';
const linkIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/link-icon.png';
const opportunitiesIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/opportunities-icon-dark.png';
const projectsIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/projects-icon-dark.png';
const calendarIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/calendar-icon-dark.png';
const pathsIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/paths-icon-dark.png';
const checkboxEmpty = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/checkbox-empty.png';
const checkboxChecked = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/checkbox-checked.png';
const xIcon = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/x-icon.png';
const editIconBlue = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/edit-icon-blue.png';
const editIconWhite = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/edit-icon-white.png';
const saveIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/save-icon-dark.png';
const trashIconDark = 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/trash-icon-dark.png';

class EditLog extends Component {
    constructor(props) {
        super(props)

        this.state = {
            prefix: '/app',
            goalType: { name: ''},
            pollConnections: true,
            showCompassAssistant: true,
            ignoreWorkLogs: true,
            permissionToShare: true,
            showModule: true,

            creditsUsed: 0,
            startingCredits: 100,

            minTargetDate: new Date(),
            maxTargetDate: null,
            forceSelection: false,

            tags: [],
            selectedPathways: [],
            selectedPathwayDetails: [],
            selectedCareers: [],
            selectedCareerDetails: [],
            selectedOpportunities: [],
            selectedOpportunityDetails: [],
            selectedSkills: [],
            selectedSkillDetails: [],
            selectedCompetencyDetails: [],
            selectedMembers: [],
            selectedMemberDetails: [],
            selectedAdvisees: [],
            selectedAdviseeDetails: [],
            selectedSchools: [],
            selectedMajors: [],

            firstName: '',
            lastName: '',
            email: '',
            sessionDate: '',
            category: '',
            notes: '',
            sessionMethod: '',

            logId: '',

            goalId: '',
            goalTitle: '',
            goalDescription: '',
            goalDeadline: '',
            tasks: [],
            requestedMentorSupport: '',
            goalStatus: '',
            goalNotes: '',

            taskId: '',
            taskName: '',
            taskDeadline: '',
            associatedGoal: '',

            applicationId: '',
            employerName: '',
            employerURL: '',
            employerType: '',
            employerIndustry: '',
            employeeCount: '',
            positionTitle: '',
            workType: '',
            positionFunction: '',
            positionLink: '',
            timeframe: '',
            applicationDeadline: '',
            reviewedMaterials: '',

            interviewId: '',
            associatedApplication: { name: 'Attach a Saved Application'},
            positionRating: '',
            companyRating: '',
            fitRating: '',

            offerId: '',
            offerAssociatedApplication: { name: 'Attach a Saved Application'},
            offerPayType: 'Hourly',
            offerPay: '',
            hasBonus: false,
            bonusDescription: '',
            offerBenefits: '',
            offeredEquity: false,
            equityPercentage: '',
            companyValuation: '',
            offerStartDate: '',
            offerDecision: '',
            decisionReason: '',

            passionId: '',
            passionTitle: '',
            passionReason: '',

            interviews: [],
            editExisting: false,

            mcPracticedInterviewing: false,
            wasPrepared: false,
            passed: false,
            interviewDate: '',
            repeats: 'Every Week',

            logType: 'Goal',
            questionsAsked: [],
            questionsAnswered: [],

            logTypeOptions: [],
            employerTypeOptions: [],
            industryOptions: [],
            employeeCountOptions: [],
            functionOptions: [],
            binaryOptions: ['','Yes','No'],
            applicationOptions: [],
            ratingOptions: ['','1','2','3','4','5'],
            payTypeOptions: [],
            hourlyPayOptions: [],
            annualPayOptions: [],
            equityPercentageOptions: [],
            valuationOptions: [],
            workTypeOptions: [],
            timeframeOptions: ['','Summer','Fall','Winter','Spring'],
            interviewRoundOptions: ['','Round 1','Round 2','Round 3','Round 4 or More'],
            numberOfInterviewsOptions: ['','1','2','3','4','5 or More'],
            interviewLengthOptions: ['','Fewer than 15 Minutes','15 Minutes','30 Minutes','45 Minutes','60 Minutes','More than 60 Minutes'],
            entrepreneurshipStageOptions: ['','Idea','Development','Early','Growth','Expansion','Maturity'],
            projectOptions: [{ name: '' }],
            entrepreneurshipProject: { name: '' },
            goalTypeOptions: [{ name: ''}],
            optimizeOptions: ['','Stability','Mission','Interest / Passion','Prestige / Recognition','Pay'],
            hoursPerWeekOptions: [],
            degreeOptions: [],
            skillPreferenceOptions: [],
            societalProblemOptions: [],
            comparisonTypeOptions: ['','Careers','Competencies','Projects','Jobs'],
            repeatOptions: ['Never','Every Day','Every Week','Every 2 Weeks','Every Month','Every Year'],
            reminderOptions: ['None','At time of event','5 minutes before','10 minutes before','15 minutes before','30 minutes before','1 hour before','2 hous before','1 day before','2 days before','1 week before'],
            tagTypeOptions: ['','General Careers','Opportunities','Functions','Industries','Hours per Week','Pay Range','Optimizations','Competencies'],
            goalOptions: [],
            meetingCategoryOptions: ['','General','Career Exploration','Goal Specification','Achievement Strategy','Resume Review','Mock Interview','Other'],
            checklistCategoryOptions: [],

            repeat: 'Never',
            reminder: 'None',
            currentPage: 'Details',
            // subNavCategories: ['Details','Suggestions','People','Courses','Careers','Events','Projects','Work'],
            subNavCategories: ['Details','Suggestions','People','Courses','Events','Projects','Work'],

            selectedFunctions: [],
            selectedIndustries: [],
            selectedHours: [],
            selectedPayRanges: [],
            selectedOptimizeOptions: [],

            recipients: [],
            competencies: [],

            stageIndex: 1,
            stageCount: 20,

            clientErrorMessage: '',
            serverPostSuccess: true,
            serverSuccessMessage: '',
            serverErrorMessage: ''

        }

        this.retrieveData = this.retrieveData.bind(this)
        this.formChangeHandler = this.formChangeHandler.bind(this)
        this.saveLog = this.saveLog.bind(this)
        this.deleteLog = this.deleteLog.bind(this)
        this.addRemoveItems = this.addRemoveItems.bind(this)
        this.toggleEditMode = this.toggleEditMode.bind(this)

        this.renderItems = this.renderItems.bind(this)

        this.renderTags = this.renderTags.bind(this)
        this.addItem = this.addItem.bind(this)
        this.removeTag = this.removeTag.bind(this)

        this.searchItems = this.searchItems.bind(this)
        this.searchItemClicked = this.searchItemClicked.bind(this)
        this.adjustCoreCompetencies = this.adjustCoreCompetencies.bind(this)
        this.subNavClicked = this.subNavClicked.bind(this)
        this.closeModal = this.closeModal.bind(this)
        this.renderDetails = this.renderDetails.bind(this)
        this.renderShareButtons = this.renderShareButtons.bind(this)
        this.pullCourses = this.pullCourses.bind(this)
        this.editItem = this.editItem.bind(this)
        this.renderChecklistIcon = this.renderChecklistIcon.bind(this)
        this.commandClicked = this.commandClicked.bind(this)

    }

    componentDidMount(){
      console.log('just mouted subeditlog')
      this.retrieveData()
    }

    componentDidUpdate(prevProps) {
      console.log('componentDidUpdate called in subeditlog', this.props, prevProps)

      if (this.props.activeOrg !== prevProps.activeOrg || this.props.accountCode !== prevProps.accountCode) {
        this.retrieveData()
      } else if (this.props.log !== prevProps.log || this.props.logId !== prevProps.logId) {
        this.retrieveData()
      } else if (this.props.modalIsOpen !== prevProps.modalIsOpen || this.props.modalIsOpen !== prevProps.modalIsOpen) {
        this.retrieveData()
      }
    }

    retrieveData() {
      console.log('retrieveData called in editLog')
      // console.log('23489384h3', logId, editExisting)
      let today = new Date()
      let dd = today.getDate()
      let mm = today.getMonth()+1
      let yyyy = today.getFullYear()

      if (dd<10) {
          dd = '0'+dd
      }

      if(mm<10) {
          mm = '0'+mm
      }

      let dateString = today.toString()
      let formattedToday = yyyy + '-' + mm + '-' + dd + 'T' + dateString.substring(29,31) + ':' + dateString.substring(31,33);

      //obtain email id from localStorage
      const email = localStorage.getItem('email');
      const username = localStorage.getItem('username');
      const cuFirstName = localStorage.getItem('firstName');
      const cuLastName = localStorage.getItem('lastName');
      // const pictureURL = localStorage.getItem('pictureURL');
      const activeOrg = localStorage.getItem('activeOrg');
      const remoteAuth = localStorage.getItem('remoteAuth');
      const roleName = localStorage.getItem('roleName');
      const orgFocus = localStorage.getItem('orgFocus');
      let accountCode = localStorage.getItem('accountCode');

      let employerAccount = false
      if (roleName === 'Employee' && accountCode) {
        employerAccount = true
        // accountCode = null
      } else {
        accountCode = null
      }

      let logType = 'Goal'
      if (this.props.passedLogType) {
        logType = this.props.passedLogType
      }
      if (window.location.pathname.includes('/organizations/')) {
        logType = 'Session'
      }

      let logTypeOptions = ['Goal','Session','Application','Interview','Offer','Passion']
      if (this.state.ignoreWorkLogs) {
        logTypeOptions = ['Goal','Session','Passion','Notes']
      }
      if (employerAccount) {
        logTypeOptions = ['Goal','Session','Passion']
      }

      const editExisting = this.props.editExisting
      let log = this.props.log
      const logs = this.props.logs
      const selectedAdvisor = this.props.selectedAdvisor

      const logId = this.props.logId
      const modalIsOpen = this.props.modalIsOpen
      const selectedGroup = this.props.selectedGroup
      const selectedPathway = this.props.selectedPathway
      const selectedCareer = this.props.selectedCareer
      // console.log('111188***')
      if (email) {
        // console.log('t1', editExisting)
        // console.log('8888***')
        let applicationOptions = ['']
        if (logs) {
          for (let i = 1; i <= logs.length; i++) {
            // console.log('show the count', logs[i - 1].logType)
            if (logs[i - 1].logType === 'Application') {
              applicationOptions.push(logs[i - 1].positionTitle + " | " + logs[i - 1].employerName )
            }
          }
        }

        const payTypeOptions = ['Hourly','Annual']
        const equityPercentageOptions = ['< 0.1%','0.1% - 0.5%','0.5% - 1%','1% - 5%','5% - 10%',
          '10% - 20%','20% - 30%','30% - 50%','> 50%'
        ]
        const valuationOptions = ['< $1MM','$1MM - $5MM','$5MM - $10MM','$10MM - $50MM','$50MM - $100MM',
          '$100MM - $500MM','$500MM - $1B','$1B - $10B','$10B - $100B','> $100B'
        ]

        let tempRecipients = []
        if (selectedAdvisor) {
          // console.log('show advisor: ', selectedAdvisor)
          tempRecipients.push({ firstName: selectedAdvisor.advisorFirstName, lastName: selectedAdvisor.advisorLastName, email: selectedAdvisor.advisorEmail })
        }

        const skillPreferenceOptions = ['','Basics','Stability','Pay','Your Interests']

        const entrepreneurshipGoalOptions = [
          '','Overall Skills','Legal Formation','Market Research','Building a Team','Building an App MVP',
          'Selling Goods / Services Online','Marketing Your Product','Selling Your Product','Raising Funding',
          'Product Design','Forecasting and Budgeting','Other'
        ]

        const intensityOptions =  ['','Aggressive (> 40 hrs / week)','Moderately Aggressive (20 - 40 hrs / week)','Moderate (10 - 20 hrs / week)','Moderately Passive (4 - 10 hrs / week)','Passive (1 - 4 hrs / week)']

        let meetingCategoryOptions = ['','General','Career Exploration','Goal Specification','Achievement Strategy','Resume Review','Mock Interview','Other']
        if (employerAccount) {
          meetingCategoryOptions = ['','General','Career Pathway Exploration','Goal Specification','Achievement Strategy','Other']
        }

        let advisorFirstName = ''
        let advisorLastName = ''
        let advisorEmail = ''
        let hiddenToCareerSeeker = false
        if (window.location.pathname.includes('/organizations')) {
          advisorFirstName = cuFirstName
          advisorLastName = cuLastName
          advisorEmail = email
          hiddenToCareerSeeker = true
        }

        let goalType = { name: ''}
        let tags = []
        let selectedPathways = []
        let selectedPathwayDetails = []
        let goalTitle = ''
        let goalDescription = ''
        let checklist = []
        if (selectedPathway) {
          goalType = { name: 'Career', description: 'Complete a career path' }
          tags.push({ name: 'pathway', value: selectedPathway })
          selectedPathways = [{ _id: selectedPathway._id, title: selectedPathway.title }]
          selectedPathwayDetails = [{selectedPathway}]
          goalTitle = "Complete " + selectedPathway.title + " Path"
          goalDescription = "Complete the " + selectedPathway.title + " career pathway."
          checklist = selectedPathway.checklist
        }

        let selectedCareers = []
        let selectedCareerDetails = []
        if (selectedCareer) {
          goalType = { name: 'Career', description: 'Complete a career path' }
          tags.push({ name: 'career', value: selectedCareer })
          selectedCareers = [{ _id: selectedCareer._id, title: selectedCareer.name }]
          selectedCareerDetails = [{selectedCareer}]
          goalTitle = "Complete " + selectedCareer.name + " Path"
          goalDescription = "Complete the " + selectedCareer.name + " career pathway."
          checklist = selectedCareer.checklist
        }

        let goalStartDate = convertDateToString(new Date(),'rawDateTimeForInput')

        let prefix = '/app'
        if (window.location.pathname.includes('/advisor')) {
          prefix = '/advisor'
        } else if (window.location.pathname.startsWith('/organizations')) {
          prefix = '/organizations/' + activeOrg
        } else if (window.location.pathname.startsWith('/employers')) {
          prefix = '/advisor'
        }

        let goalCommands = []
        if (log) {
          goalCommands = [
            'What are some strategies and tactics to achieve my goal of ' + log.title + ' in 12 months?',
            'What are the key competencies I need to achieve my goal of ' + log.title + '?',
            'What are some great resources to help me achieve my goal of ' + log.title + '?',
            'Create a checklist of tasks to complete with deadlines to achieve my goal of ' + log.title + '?',
            'What are some independent projects I can work on to gain advocates for achieving my goal of ' + log.title + '?',
          ]
        }

        this.setState({
            emailId: email, cuFirstName, cuLastName, username,
            roleName, remoteAuth, modalIsOpen, selectedGroup,
            sessionDate: formattedToday, activeOrg, logType, logTypeOptions,
            applicationOptions, payTypeOptions, equityPercentageOptions, valuationOptions,
            editExisting, log, logs, recipients: tempRecipients,
            advisorFirstName, advisorLastName, advisorEmail, hiddenToCareerSeeker,
            entrepreneurshipGoalOptions, intensityOptions, skillPreferenceOptions, meetingCategoryOptions,
            accountCode, employerAccount, goalType, tags,
            selectedPathways, selectedPathwayDetails, selectedCareers, selectedCareerDetails,
            goalTitle, goalDescription, checklist,
            goalStartDate, prefix, goalCommands
        });

        Axios.get('/api/assessment/results', { params: { emailId: email } })
         .then((response2) => {
           console.log('query for assessment results worked');

           if (response2.data.success) {

             console.log('actual assessment results', response2.data)

             let profile = { firstName: cuFirstName, lastName: cuLastName, email }
             profile['workPreferences'] = response2.data.results.workPreferenceAnswers
             profile['interests'] = response2.data.results.interestScores
             profile['personality'] = response2.data.results.personalityScores
             profile['skills'] = response2.data.results.newSkillAnswers
             profile['gravitateValues'] = response2.data.results.topGravitateValues
             profile['employerValues'] = response2.data.results.topEmployerValues

             this.setState({ profile })

           } else {
             console.log('no assessment results', response2.data)
           }

       }).catch((error) => {
         console.log('query for assessment results did not work', error);
       })

        Axios.get('/api/projects', { params: { emailId: email, includeCollaborations: true } })
        .then((response) => {
          console.log('Projects query attempted', response.data);

            if (response.data.success) {
              console.log('successfully retrieved projects')

              if (response.data.projects) {

                const projects = response.data.projects
                const projectOptions = [{ name: 'Select a project' }].concat(projects)

                this.setState({ projectOptions })

              }

            } else {
              console.log('no project data found', response.data.message)
            }

        }).catch((error) => {
            console.log('Project query did not work', error);
        });

        if (activeOrg) {
          Axios.get('/api/pathways', { params: { isActive: true, orgCode: activeOrg } })
          .then((response) => {
            console.log('Pathways query attempted no 1', response.data);

            if (response.data.success) {
              console.log('pathway query worked no 1')

              if (response.data.pathways.length !== 0) {

                // const pathwayOptions = response.data.pathways
                let tagTypeOptions = ['','Community Career Paths','General Careers','Opportunities','Functions','Industries','Hours per Week','Pay Range','Optimizations','Competencies']
                this.setState({ tagTypeOptions });

              }

            } else {
              console.log('pathway query did not work', response.data.message)
            }

          }).catch((error) => {
              console.log('Pathway query did not work for some reason', error);
          });

          Axios.get('/api/org', { params: { orgCode: activeOrg } })
          .then((response) => {
            console.log('Org info query attempted', response.data);

            if (response.data.success) {
              console.log('org info query worked in editLog')

              const orgName = response.data.orgInfo.orgName
              const orgContactEmail = response.data.orgInfo.contactEmail

              let meetingTagOptions = []
              if (response.data.orgInfo.meetingTagOptions) {
                meetingTagOptions = [{ name: '' }].concat(response.data.orgInfo.meetingTagOptions)
              }

              let meetingPurposeOptions = []
              let meetingOutcomeOptions = []
              if (response.data.orgInfo.meetingPurposeOptions && response.data.orgInfo.meetingPurposeOptions.length > 0) {
                meetingPurposeOptions = [{ name: '' }].concat(response.data.orgInfo.meetingPurposeOptions)
                if (log && log.meetingPurpose) {
                  // console.log('there an existing meeting purpose')
                  for (let i = 1; i <= response.data.orgInfo.meetingPurposeOptions.length; i++) {
                    if (response.data.orgInfo.meetingPurposeOptions[i - 1].name === log.meetingPurpose) {
                      meetingOutcomeOptions = [''].concat(response.data.orgInfo.meetingPurposeOptions[i - 1].meetingOutcomeOptions)
                    }
                  }
                }
              }

              const disableChatbotPrompts = response.data.orgInfo.disableChatbotPrompts
              // console.log('askfajldkfajsldkfaldsf', disableChatbotPrompts)
              this.setState({ orgName, orgContactEmail, meetingTagOptions,
                meetingPurposeOptions, meetingOutcomeOptions, disableChatbotPrompts
              });

              // opportunities,
              let postType = null
              let postTypes = []
              const placementPartners = response.data.orgInfo.placementPartners
              const recent = true
              const active = true
              const pullPartnerPosts = true
              let targetRole = null

              const pathway = null
              const resLimit = 4

              //only schools see this screen
              Axios.get('/api/postings/user', { params: { orgCode: activeOrg, placementPartners,
                postType, postTypes, pathway, recent, active,
                pullPartnerPosts, csWorkflow: true,
                roleName, targetRole, resLimit
              }})
              .then((response) => {
                console.log('Posted postings query attempted within subcomponent', response.data);

                if (response.data.success) {
                  console.log('posted postings query worked')

                  if (response.data.postings.length !== 0) {

                    // let useFunction = true

                    const relatedOpportunities = response.data.postings
                    this.setState({ relatedOpportunities })
                  }

                } else {
                  console.log('posted postings query did not work', response.data.message)
                }

              }).catch((error) => {
                  console.log('Posted postings query did not work for some reason', error);
              });

            } else {
              console.log('org info query did not work', response.data.message)
            }

          }).catch((error) => {
              console.log('Org info query did not work for some reason', error);
          });
        }

        Axios.get('/api/users/profile/details', { params: { email } })
        .then((response) => {
          console.log('User profile query attempted', response.data);

          if (response.data.success) {
            console.log('successfully retrieved profile')

            const pictureURL = response.data.user.pictureURL
            const headline = response.data.user.headline
            const publicProfile = response.data.user.publicProfile
            const publicProfileExtent = response.data.user.publicProfileExtent
            const publicPreferences = response.data.user.publicPreferences
            let creditsUsed = 0
            if (response.data.user.assistantChatCount) {
              creditsUsed = response.data.user.assistantChatCount
            }

            this.setState({ pictureURL, headline, publicProfile, publicProfileExtent, publicPreferences, creditsUsed })

          } else {
            console.log('user profile data found', response.data.message)
          }

        }).catch((error) => {
            console.log('User profile query did not work', error);
        });

        Axios.get('/api/workoptions')
       .then((response) => {
         console.log('Work options query tried', response.data);

         if (response.data.success) {
           console.log('Work options query succeeded')

           let functionOptions = ['']
           for (let i = 1; i <= response.data.workOptions[0].functionOptions.length; i++) {
             if (i > 1) {
               functionOptions.push(response.data.workOptions[0].functionOptions[i - 1])
             }
           }

           let industryOptions = ['']
           for (let i = 1; i <= response.data.workOptions[0].industryOptions.length; i++) {
             if (i > 1) {
               industryOptions.push(response.data.workOptions[0].industryOptions[i - 1])
             }
           }


           let hoursPerWeekOptions = ['']
           for (let i = 1; i <= response.data.workOptions[0].hoursPerWeekOptions.length; i++) {
             if (i > 1) {
               hoursPerWeekOptions.push(response.data.workOptions[0].hoursPerWeekOptions[i - 1])
             }
           }

           let workTypeOptions = ['']
           for (let i = 1; i <= response.data.workOptions[0].workTypeOptions.length; i++) {
             if (i > 1) {
               workTypeOptions.push(response.data.workOptions[0].workTypeOptions[i - 1])
             }
           }

           let employerTypeOptions = ['']
           for (let i = 1; i <= response.data.workOptions[0].employerTypeOptions.length; i++) {
             if (i > 1) {
               employerTypeOptions.push(response.data.workOptions[0].employerTypeOptions[i - 1])
             }
           }

           let employeeCountOptions = ['']
           for (let i = 1; i <= response.data.workOptions[0].employeeCountOptions.length; i++) {
             if (i > 1) {
               employeeCountOptions.push(response.data.workOptions[0].employeeCountOptions[i - 1])
             }
           }

           let hourlyPayOptions = ['']
           for (let i = 1; i <= response.data.workOptions[0].hourlyPayOptions.length; i++) {
             if (i > 1) {
               hourlyPayOptions.push(response.data.workOptions[0].hourlyPayOptions[i - 1])
             }
           }

           let annualPayOptions = ['']
           for (let i = 1; i <= response.data.workOptions[0].annualPayOptions.length; i++) {
             if (i > 1) {
               annualPayOptions.push(response.data.workOptions[0].annualPayOptions[i - 1])
             }
           }

           let degreeOptions = ['']
           for (let i = 1; i <= response.data.workOptions[0].degreeOptions.length; i++) {
             if (i > 1) {
               degreeOptions.push(response.data.workOptions[0].degreeOptions[i - 1])
             }
           }

           let societalProblemOptions = ['']
           for (let i = 1; i <= response.data.workOptions[0].societalProblems.length; i++) {
             if (i > 1) {
               societalProblemOptions.push(response.data.workOptions[0].societalProblems[i - 1])
             }
           }

           let optimizeOptions = [''].concat(response.data.workOptions[0].optimizeOptions)
           let goalTypeOptions = [{ name: ''}]
           if (employerAccount) {
             for (let i = 1; i <= response.data.workOptions[0].employerGoalTypeOptions.length; i++) {
               goalTypeOptions.push(response.data.workOptions[0].employerGoalTypeOptions[i - 1])
             }
           } else {
             for (let i = 1; i <= response.data.workOptions[0].goalTypeOptions.length; i++) {
               if ((orgFocus === 'academy' || orgFocus === 'School') && !response.data.workOptions[0].goalTypeOptions[i - 1].adult) {
                 goalTypeOptions.push(response.data.workOptions[0].goalTypeOptions[i - 1])
               } else if ((orgFocus !== 'academy' && orgFocus !== 'School')){
                 goalTypeOptions.push(response.data.workOptions[0].goalTypeOptions[i - 1])
               }
             }
           }

           let checklistCategoryOptions = [''].concat(response.data.workOptions[0].checklistCategoryOptions)

           this.setState({ functionOptions, industryOptions, hourlyPayOptions, annualPayOptions,
             hoursPerWeekOptions, workTypeOptions, employerTypeOptions, employeeCountOptions, degreeOptions,
             societalProblemOptions, optimizeOptions, goalTypeOptions, checklistCategoryOptions
           })


         } else {
           console.log('no jobFamilies data found', response.data.message)

           const functionOptions = []
           const industryOptions = []
           const workDistanceOptions = []
           const hoursPerWeekOptions = []
           const workTypeOptions = []
           const hourlyPayOptions = []
           const annualPayOptions = []

           this.setState({ functionOptions, industryOptions,
           workDistanceOptions, hoursPerWeekOptions, workTypeOptions, hourlyPayOptions, annualPayOptions })

         }
       }).catch((error) => {
           console.log('query for work options did not work', error);
       })

       if (activeOrg) {
         Axios.get('/api/logs/goals', { params: { emailId: email } })
          .then((response) => {
            console.log('query for goal options worked', response.data);

            if (response.data.success) {

              let goalOptions = response.data.goals
              if (goalOptions.length > 0) {
                goalOptions = [{ title: '' }].concat(response.data.goals)
              }
              this.setState({ goalOptions })

            } else {
              console.log('no goals', response.data)
            }

          }).catch((error) => {
            console.log('query for goals did not work', error);
          })
       }

        if (logId !== 'new') {
          if (editExisting) {
            console.log('in editExisting', logId)

            // update log
            Axios.get('/api/logs/byid', { params: { _id: logId } })
            .then((response) => {
              console.log('Log query by id attempted', response.data);

              if (response.data.success) {
                console.log('log query worked')

                log = response.data.log

                let selectedMembers = []
                let selectedMemberDetails = []
                let selectedAdvisees = []
                let selectedAdviseeDetails = []

                let adviseeFirstName = undefined
                let adviseeLastName = undefined
                let adviseeEmail = undefined

                if (log) {
                  advisorFirstName = log.advisorFirstName
                  advisorLastName = log.advisorLastName
                  advisorEmail = log.advisorEmail
                  selectedMembers = [log.advisorFirstName + ' ' + log.advisorLastName]
                  selectedMemberDetails = [
                    { firstName: log.advisorFirstName, lastName: log.advisorLastName, email: log.advisorEmail}
                  ]
                  selectedAdvisees = [log.adviseeFirstName + ' ' + log.adviseeLastName]
                  selectedAdviseeDetails = [
                    { firstName: log.adviseeFirstName, lastName: log.adviseeLastName, email: log.adviseeEmail}
                  ]

                  if (!this.state.forceSelection) {
                    adviseeFirstName = log.adviseeFirstName
                    adviseeLastName = log.adviseeLastName
                    adviseeEmail = log.adviseeEmail
                  }

                }

                logType = log.logType

                if (logType === 'Session' || logType === 'Check In') {
                  let notes = ''
                  if (log.notes) {
                    notes = log.notes
                  }

                  let sessionDate = convertDateToString(new Date(log.sessionDate),'rawDateTimeForInput')

                  const meetingPurpose = log.meetingPurpose
                  const meetingOutcome = log.meetingOutcome
                  const meetingTags = log.meetingTags
                  const goalTags = log.goalTags

                  this.setState({
                    _id: log._id, sessionId: log._id, advisorFirstName, advisorLastName, advisorEmail,
                    adviseeFirstName, adviseeLastName, adviseeEmail,
                    sessionDate, category: log.category, hiddenToCareerSeeker: log.hiddenToCareerSeeker,
                    notes, sessionMethod: log.sessionMethod, createdAt: log.createdAt, selectedMembers, selectedMemberDetails,
                    selectedAdvisees, selectedAdviseeDetails,
                    meetingPurpose, meetingOutcome, meetingTags, goalTags
                  })
                } else if (logType === 'Meeting') {
                  const meetingId = log._id
                  const startTime = convertDateToString(new Date(log.startTime),"rawDateTimeForInput")
                  const endTime = convertDateToString(new Date(log.endTime),"rawDateTimeForInput")
                  const method = log.method
                  const location = log.location
                  const repeats = log.repeats
                  const reminder = log.reminder

                  let selectedMembers = []
                  let selectedMemberDetails = []
                  if (log.selectedMembers) {
                    for (let i = 1; i <= log.selectedMembers.length; i++) {
                      selectedMemberDetails.push(log.selectedMembers[i - 1])
                      selectedMembers.push(log.selectedMembers[i - 1].firstName + ' ' + log.selectedMembers[i - 1].lastName)
                    }
                  }

                  const description = log.description
                  const links = log.links
                  const notes = log.notes
                  const actionItems = log.actionItems
                  const selectedGroup = { _id: log.groupId, name: log.groupName }

                  this.setState({ meetingId, startTime, endTime, method, location, repeats, reminder, selectedMembers,
                    selectedMemberDetails, description, links, notes, actionItems, selectedGroup
                  })

                } else if (logType === 'Goal') {

                  let tasks = []
                  if (log.tasks) {
                    tasks = log.tasks
                  }

                  let requestedMentorSupport = ''
                  if (log.requestedMentorSupport) {
                    requestedMentorSupport = log.requestedMentorSupport
                  }

                  let notes = ''
                  if (log.notes) {
                    notes = log.notes
                  }

                  let goalType = this.state.goalType
                  if (log.goalType) {
                    goalType = log.goalType
                  }

                  let courseSearchTerm = ''

                  let tags = []
                  let selectedPathways = []
                  let selectedPathwayDetails = []
                  if (log.selectedPathways) {
                    for (let i = 1; i <= log.selectedPathways.length; i++) {
                      selectedPathwayDetails.push(log.selectedPathways[i - 1])
                      selectedPathways.push(log.selectedPathways[i - 1].name)
                      tags.push({ name: 'career', value: log.selectedPathways[i - 1]})
                      courseSearchTerm = log.selectedPathways[i - 1].name
                    }
                  }

                  let selectedCareers = []
                  let selectedCareerDetails = []
                  if (log.selectedCareers) {
                    for (let i = 1; i <= log.selectedCareers.length; i++) {
                      selectedCareerDetails.push(log.selectedCareers[i - 1])
                      selectedCareers.push(log.selectedCareers[i - 1].name)
                      tags.push({ name: 'career', value: log.selectedCareers[i - 1]})
                      courseSearchTerm = log.selectedCareers[i - 1].title
                    }
                  }

                  let selectedOpportunities = []
                  let selectedOpportunityDetails = []
                  if (log.selectedOpportunities) {
                    for (let i = 1; i <= log.selectedOpportunities.length; i++) {
                      selectedOpportunityDetails.push(log.selectedOpportunities[i - 1])
                      tags.push({ name: 'opportunity', value: log.selectedOpportunities[i - 1]})
                      if (log.selectedOpportunities[i - 1].title) {
                        selectedOpportunities.push({ name: 'opportunity', value: log.selectedOpportunities[i - 1].title })
                        courseSearchTerm = log.selectedOpportunities[i - 1].title
                      } else if (log.selectedOpportunities[i - 1].name) {
                        selectedOpportunities.push(log.selectedOpportunities[i - 1].name)
                        courseSearchTerm = log.selectedOpportunities[i - 1].name
                      }
                    }
                  }

                  let entrepreneurshipStage = this.state.entrepreneurshipStage
                  if (log.entrepreneurshipStage) {
                    entrepreneurshipStage = log.entrepreneurshipStage
                  }

                  let entrepreneurshipGoal = this.state.entrepreneurshipGoal
                  if (log.entrepreneurshipGoal) {
                    entrepreneurshipGoal = log.entrepreneurshipGoal
                    courseSearchTerm = entrepreneurshipGoal
                  }

                  let entrepreneurshipProject = this.state.entrepreneurshipProject
                  if (log.entrepreneurshipProject) {
                    entrepreneurshipProject = log.entrepreneurshipProject
                  }

                  let intensity = null
                  if (log.intensity) {
                    intensity = log.intensity
                  }

                  let budget = null
                  if (log.budget) {
                    budget = log.budget
                  }

                  let competencies = []
                  if (log.competencies) {
                    competencies = log.competencies
                    for (let i = 1; i <= log.competencies.length; i++) {
                      tags.push({ name: 'competency', value: log.competencies[i - 1]})
                      if (!courseSearchTerm) {
                        courseSearchTerm = log.competencies[i - 1].name
                      }
                    }
                  }

                  let selectedFunctions = []
                  if (log.selectedFunctions) {
                    selectedFunctions = log.selectedFunctions
                    for (let i = 1; i <= log.selectedFunctions.length; i++) {
                      tags.push({ name: 'function', value: log.selectedFunctions[i - 1]})
                      if (!courseSearchTerm) {
                        courseSearchTerm = log.selectedFunctions[i - 1]
                      }
                    }
                  }

                  let selectedIndustries = []
                  if (log.selectedIndustries) {
                    selectedIndustries = log.selectedIndustries
                    for (let i = 1; i <= log.selectedIndustries.length; i++) {
                      tags.push({ name: 'industry', value: log.selectedIndustries[i - 1]})
                      if (!courseSearchTerm) {
                        courseSearchTerm = log.selectedIndustries[i - 1]
                      }
                    }
                  }

                  let selectedHours = []
                  if (log.selectedHours) {
                    selectedHours = log.selectedHours
                    for (let i = 1; i <= log.selectedHours.length; i++) {
                      tags.push({ name: 'hoursPerWeek', value: log.selectedHours[i - 1]})
                    }
                  }

                  let selectedPayRanges = []
                  if (log.selectedPayRanges) {
                    selectedPayRanges = log.selectedPayRanges
                    for (let i = 1; i <= log.selectedPayRanges.length; i++) {
                      tags.push({ name: 'payRange', value: log.selectedPayRanges[i - 1]})
                    }
                  }

                  let selectedOptimizeOptions = []
                  if (log.selectedOptimizeOptions) {
                    selectedOptimizeOptions = log.selectedOptimizeOptions
                    for (let i = 1; i <= log.selectedOptimizeOptions.length; i++) {
                      tags.push({ name: 'optimize', value: log.selectedOptimizeOptions[i - 1]})
                    }
                  }

                  let selectedSkills = []
                  if (log.selectedSkills) {
                    selectedSkills = log.selectedSkills
                    for (let i = 1; i <= log.selectedSkills.length; i++) {
                      tags.push({ name: 'skill', value: log.selectedSkills[i - 1]})
                      if (!courseSearchTerm && log.selectedSkills[i - 1].name) {
                        courseSearchTerm = log.selectedSkills[i - 1].name
                      }
                    }
                  }

                  let selectedSchools = []
                  if (log.selectedSchools) {
                    selectedSchools = log.selectedSchools
                    for (let i = 1; i <= log.selectedSchools.length; i++) {
                      tags.push({ name: 'school', value: log.selectedSchools[i - 1]})
                    }
                  }

                  let selectedMajors = []
                  if (log.selectedMajors) {
                    selectedMajors = log.selectedMajors
                    for (let i = 1; i <= log.selectedMajors.length; i++) {
                      tags.push({ name: 'major', value: log.selectedMajors[i - 1]})
                      if (!courseSearchTerm) {
                        courseSearchTerm = log.selectedMajors[i - 1]
                      }
                    }
                  }

                  let selectedMembers = []
                  let selectedMemberDetails = []
                  if (log.selectedMembers) {
                    for (let i = 1; i <= log.selectedMembers.length; i++) {
                      selectedMemberDetails.push(log.selectedMembers[i - 1])
                      selectedMembers.push(log.selectedMembers[i - 1].firstName + ' ' + log.selectedMembers[i - 1].lastName)
                      tags.push({ name: 'member', value: log.selectedMembers[i - 1]})
                    }
                  }

                  const successDefined = log.successDefined
                  const degreeType = log.degreeType
                  const skillPreference = log.skillPreference
                  const societalProblem = log.societalProblem

                  const comparisonType = log.comparisonType
                  const pollConnections = log.pollConnections
                  const pollQuestion = log.pollQuestion
                  const aName = log.aName
                  const aValue = log.aValue
                  const aCase = log.aCase
                  const aLinks = log.aLinks
                  const aItem = log.aItem
                  const bName = log.bName
                  const bValue = log.bValue
                  const bCase = log.bCase
                  const bLinks = log.bLinks
                  const bItem = log.bItem
                  if (log.checklist) {
                    checklist = log.checklist
                  }

                  const progress = log.progress
                  const strategies = log.strategies

                  const shareURL = window.location.protocol + "//" + window.location.host + '/goals/' + log._id

                  if (log.startDate) {
                    goalStartDate = convertDateToString(new Date(log.startDate),'rawDateTimeForInput')
                  }

                  let goalDeadline = convertDateToString(new Date(log.deadline),'rawDateTimeForInput')

                  let dateAchieved = null
                  if (log.dateAchieved) {
                    dateAchieved = convertDateToString(new Date(log.dateAchieved),'rawDateTimeForInput')
                  }

                  // const year = new Date(log.deadline).getFullYear()
                  // const month = new Date(log.deadline).getMonth()
                  // const day = new Date(log.deadline).getDate()
                  // const formattedMonth = convertDateToString(month,'formatMonth')
                  console.log('show deadline: ', goalDeadline, log.deadline)
                  // 2022-03-25 2022 2 24 March
                  // 2022-03-25T00:00:00.000Z 2022 2 24 March

                  this.setState({
                    _id: log._id,
                    goalId: log._id, goalTitle: log.title, goalDescription: log.description, goalStartDate,
                    goalDeadline,
                    tasks, requestedMentorSupport, notes, goalStatus: log.status, goalDecision: log.decision,
                    dateAchieved, successDescription: log.successDescription, permissionToShare: log.permissionToShare,
                    createdAt: log.createdAt,
                    goalType, tags,
                    selectedPathways, selectedCareers, selectedOpportunities, entrepreneurshipStage, entrepreneurshipGoal, entrepreneurshipProject,
                    intensity, budget, competencies,
                    selectedFunctions, selectedIndustries, selectedHours, selectedPayRanges, selectedOptimizeOptions, selectedSkills, selectedMembers, selectedMemberDetails,
                    selectedSchools, selectedMajors,
                    successDefined, skillPreference, societalProblem, degreeType,
                    comparisonType, pollConnections, pollQuestion, aName, aValue, aCase, aLinks, bName, bValue, bCase, bLinks,
                    aItem, bItem, checklist, progress, strategies, shareURL,
                    selectedGoal: log
                  })

                  if (courseSearchTerm) {
                    this.pullCourses(courseSearchTerm, null, null, null)
                  }

                  if (goalType) {
                    const resLimit = 4
                    // members
                    Axios.get('/api/logs/goals', { params: { orgCode: activeOrg, goalType: goalType.name, resLimit } })
                     .then((response) => {
                       console.log('query for related goals worked');

                       if (response.data.success) {

                         // console.log('suggestion results: ', response.data)
                         let relatedMembers = []

                         // let goals = response.data.goals
                         for (let i = 1; i <= response.data.goals.length; i++) {
                           if (response.data.goals[i - 1].creatorEmail !== email) {
                             relatedMembers.push({
                               firstName: response.data.goals[i - 1].creatorFirstName,
                               lastName: response.data.goals[i - 1].creatorLastName,
                               email: response.data.goals[i - 1].creatorEmail,
                               pictureURL: response.data.goals[i - 1].creatorPictureURL,
                               username: response.data.goals[i - 1].creatorUsername,
                               title: response.data.goals[i - 1].title,
                               goalType: response.data.goals[i - 1].goalType,
                               description: response.data.goals[i - 1].description
                             })
                           }
                         }
                         this.setState({ relatedMembers })

                       } else {
                         console.log('no goals', response.data)
                       }

                   }).catch((error) => {
                     console.log('query for goals did not work', error);
                   })
                  }

                  Axios.get('/api/suggestions', { params: { emailId: email, goalId: log._id } })
                   .then((response) => {
                     console.log('query for suggestions worked');

                     if (response.data.success) {

                       console.log('suggestion results: ', response.data)
                       const suggestions = response.data.suggestions
                       this.setState({ suggestions })

                     } else {
                       console.log('no suggestions', response.data)
                     }

                 }).catch((error) => {
                   console.log('query for assessment results did not work', error);
                 })

                 Axios.get('/api/documents', { params: { goalId: log._id } })
                 .then((response) => {
                   console.log('Documents query worked', response.data);

                   if (response.data.success) {

                     const plans = response.data.documents
                     let relatedGoalDocuments = []
                     for (let i = 1; i <= plans.length; i++) {
                       if (plans[i - 1].goalId) {
                         relatedGoalDocuments.push({ name: plans[i - 1].fileName, goalId: plans[i - 1].goalId })
                       }
                     }

                     this.setState({ plans, relatedGoalDocuments })

                   } else {
                     console.log('no documents data found', response.data.message)
                   }

                 }).catch((error) => {
                     console.log('Documents query did not work', error);
                 });

                } else if (logType === 'Application') {

                  let applicationDeadline = ''
                  if (log.applicationDeadline) {
                    applicationDeadline = log.applicationDeadline
                  }

                  let reviewedMaterials = ''
                  if (log.reviewedMaterials) {
                    reviewedMaterials = log.reviewedMaterials
                  }

                  this.setState({
                    _id: log._id,
                    applicationId: log._id, employerName: log.employerName, employerURL: log.employerURL,
                    employerType: log.employerType, industry: log.employerIndustry, employeeCount: log.employerSize,
                    positionTitle: log.positionTitle, positionLink: log.positionLink, jobFunction: log.jobFunction,
                    workType: log.workType, timeframe: log.timeframe, applicationDeadline, reviewedMaterials, createdAt: log.createdAt
                  })

                } else if (logType === 'Interview') {

                  let associatedApplication = {
                    _id: log.associatedApplicationId,
                    positionTitle: log.associatedApplicationPositionTitle,
                    employerName: log.associatedApplicationEmployerName,
                    name: log.associatedApplicationPositionTitle + " | " + log.associatedApplicationEmployerName
                  }

                  this.setState({
                    _id: log._id,
                    interviewId: log._id, interviewDate: log.interviewDate, interviewRound: log.interviewRound,
                    numberOfInterviews: log.numberOfInterviews, interviewLength: log.interviewLength,
                    interviews: log.interviews, mcPracticedInterviewing: log.mcPracticedInterviewing,
                    wasPrepared: log.wasPrepared, questionsAsked: log.questionsAsked,
                    questionsAnswered: log.questionsAnswered, unrelatedTopics: log.unrelatedTopics,
                    positionRating: log.positionRating, thoughtsOnPosition: log.thoughtsOnPosition,
                    companyRating: log.companyRating, thoughtsOnCompany: log.thoughtsOnCompany,
                    fitRating: log.fitRating, thoughtsOnFit: log.thoughtsOnFit,
                    employerFeedback: log.employerFeedback, passed: log.passed, associatedApplication,
                    createdAt: log.createdAt
                  })

                } else if (logType === 'Offer') {

                  let offerAssociatedApplication = {
                    _id: log.associatedApplicationId,
                    positionTitle: log.associatedApplicationPositionTitle,
                    employerName: log.associatedApplicationEmployerName,
                    name: log.associatedApplicationPositionTitle + " | " + log.associatedApplicationEmployerName
                  }

                  let offerStartDate = convertDateToString(new Date(log.startDate),'rawDateTimeForInput')

                  this.setState({
                    _id: log._id,
                    offerId: log._id, offerAssociatedApplication,
                    offerPayType: log.payType, offerPay: log.pay, hasBonus: log.hasBonus, bonusDescription: log.bonusDescription,
                    offerBenefits: log.benefits, offeredEquity: log.offeredEquity, equityPercentage: log.equityPercentage,
                    companyValuation: log.companyValuation, offerStartDate, offerDecision: log.decision, decisionReason: log.decisionReason,
                    createdAt: log.createdAt
                  })

                } else if (logType === 'Passion') {

                  this.setState({
                    passionId: log._id, passionTitle: log.passionTitle, passionReason: log.passionReason,
                    createdAt: log.createdAt
                  })

                } else if (logType === 'Notes') {

                  this.setState({
                    notesId: log._id, generalNotes: log.generalNotes, createdAt: log.createdAt
                  })
                }

                this.setState({
                advisorFirstName, advisorLastName, advisorEmail,
                log, logs, editExisting, logType })

              } else {
                console.log('log query did not work', response.data.message)
              }
            }).catch((error) => {
              console.log('Log query did not work for some reason', error);
            });

          } else {
            console.log('not editingExisting', logId)

            if (logType === 'Native Application') {
              Axios.get('/api/applications/byid', { params: { applicationId: logId } })
              .then((response) => {

                if (response.data.success) {
                  console.log('Application query worked', response.data);

                  if (response.data.application) {
                    this.setState({ log: response.data.application })
                  }

                } else {
                  console.log('no application found', response.data.message)
                }

              }).catch((error) => {
                  console.log('Application query did not work', error);
              });
            }
          }
        }
      }
    }

    formChangeHandler(event) {
      console.log('formChangeHandler clicked', event.target.name, event.target.value);

      if (event.target.name === 'associatedApplication') {

        let associatedApplication = null
        for (let i = 1; i <= this.state.logs.length; i++) {
          if (this.state.logs[i - 1].logType === 'Application') {
            let comparedValue = this.state.logs[i - 1].positionTitle + " | " + this.state.logs[i - 1].employerName
            if (event.target.value === comparedValue) {
              associatedApplication = this.state.logs[i - 1]
              associatedApplication["name"] = event.target.value
              break;
            }
          }
        }
        this.setState({ associatedApplication })

      } else if (event.target.name === 'numberOfInterviews') {

        let interviews = []
        if (event.target.value=== '5 or more') {

          for (let i = 1; i <= 5; i++) {
            if (this.state.interviews[i - 1]) {
              interviews.push(this.state.interviews[i - 1])
            } else {
              interviews.push({ name: '', rating: ''})
            }
          }
        } else if (Number(event.target.value)){

          for (let i = 1; i <= Number(event.target.value); i++) {
            if (this.state.interviews[i - 1]) {
              interviews.push(this.state.interviews[i - 1])
            } else {
              interviews.push({ name: '', rating: ''})
            }
          }
        }

        this.setState({ numberOfInterviews: event.target.value, interviews })

      } else if (event.target.name.includes('interviewerName')) {
        const nameArray = event.target.name.split("|")
        const index = Number(nameArray[1])

        let interviews = this.state.interviews
        interviews[index] = { name: event.target.value, rating: this.state.interviews[index].rating }
        this.setState({ interviews })

      } else if (event.target.name.includes('interviewRating')) {
        const nameArray = event.target.name.split("|")
        const index = Number(nameArray[1])

        let interviews = this.state.interviews
        interviews[index] = { name: this.state.interviews[index].name, rating: event.target.value}
        this.setState({ interviews })

      } else if (event.target.name.includes('task|')) {
        const nameArray = event.target.name.split("|")
        const type = nameArray[0]
        const index = Number(nameArray[1])
        const name = nameArray[2]
        console.log('keepers: ', type, index, name, nameArray)
        let tasks = this.state.tasks
        tasks[index][name] = event.target.value
        this.setState({ tasks })
      } else if (event.target.name.includes('item')) {
        console.log('step 1')
        const nameArray = event.target.name.split("|")
        const type = nameArray[1]
        const index = Number(nameArray[2])
        console.log('step 2', type)
        if (type === 'Asked') {

          let questionsAsked = this.state.questionsAsked
          questionsAsked[index] = event.target.value
          this.setState({ questionsAsked })
          console.log('step 3', questionsAsked)
        } else if (type === 'Answered') {
          let questionsAnswered = this.state.questionsAnswered
          questionsAnswered[index] = event.target.value
          this.setState({ questionsAnswered })
        }
      } else if (event.target.name === 'offerAssociatedApplication') {

        let offerAssociatedApplication = null
        for (let i = 1; i <= this.state.logs.length; i++) {
          if (this.state.logs[i - 1].logType === 'Application') {
            let comparedValue = this.state.logs[i - 1].positionTitle + " | " + this.state.logs[i - 1].employerName
            if (event.target.value === comparedValue) {
              offerAssociatedApplication = this.state.logs[i - 1]
              offerAssociatedApplication["name"] = event.target.value
              break;
            }
          }
        }
        this.setState({ offerAssociatedApplication })

      } else if (event.target.name === 'goalType') {
        let goalType = { name: '' }
        for (let i = 1; i <= this.state.goalTypeOptions.length; i++) {
          if (this.state.goalTypeOptions[i - 1].description === event.target.value) {
            goalType = this.state.goalTypeOptions[i - 1]
          }
        }
        this.setState({ goalType })
        if (goalType.name === 'Basics' || goalType.name === 'Stability' || goalType.name === 'Pay' || goalType.name === 'Interests') {
          this.adjustCoreCompetencies(null, goalType.name.toLowerCase(), event.target.name, true)
        }
      } else if (event.target.name === 'skillPreference') {
        this.setState({ [event.target.name]: event.target.value })
        if (event.target.value && event.target.value !== '') {
          this.adjustCoreCompetencies(null, event.target.value.toLowerCase(), event.target.name, true)
        }
      } else if (event.target.name === 'entrepreneurshipGoal') {
        this.setState({ entrepreneurshipGoal: event.target.value })
        this.adjustCoreCompetencies(event.target.value, 'entrepreneurship', event.target.name, true)
      } else if (event.target.name === 'entrepreneurshipIndustry') {
        this.setState({ entrepreneurshipIndustry: event.target.value })
        this.adjustCoreCompetencies(event.target.value, 'entrepreneurship', event.target.name, true)
      } else if (event.target.name === 'entrepreneurshipProject') {

        let entrepreneurshipProject = null
        for (let i = 1; i <= this.state.projectOptions.length; i++) {
          if (this.state.projectOptions[i - 1].name === event.target.value) {
            entrepreneurshipProject = this.state.projectOptions[i - 1]
          }
        }
        this.setState({ entrepreneurshipProject })
      } else if (event.target.name === 'aItemProject') {

        let aItem = null
        for (let i = 1; i <= this.state.projectOptions.length; i++) {
          if (this.state.projectOptions[i - 1].name === event.target.value) {
            aItem = this.state.projectOptions[i - 1]
          }
        }
        this.setState({ aItem })

      } else if (event.target.name === 'bItemProject') {

        let bItem = null
        for (let i = 1; i <= this.state.projectOptions.length; i++) {
          if (this.state.projectOptions[i - 1].name === event.target.value) {
            bItem = this.state.projectOptions[i - 1]
          }
        }
        this.setState({ bItem })
      } else if (event.target.name === 'searchPathways') {
        this.searchItems(event.target.value, 'pathway')
      } else if (event.target.name === 'searchCareers') {
        this.searchItems(event.target.value, 'career')
      } else if (event.target.name === 'searchCareersA') {
        this.searchItems(event.target.value, 'careerA')
      } else if (event.target.name === 'searchCareersB') {
        this.searchItems(event.target.value, 'careerB')
      } else if (event.target.name === 'searchOpportunities') {
        this.searchItems(event.target.value, 'opportunity')
      } else if (event.target.name === 'searchOpportunitiesA') {
        this.searchItems(event.target.value, 'opportunityA')
      } else if (event.target.name === 'searchOpportunitiesB') {
        this.searchItems(event.target.value, 'opportunityB')
      } else if (event.target.name === 'searchSkills') {
        this.searchItems(event.target.value, 'skill')
      } else if (event.target.name === 'searchSkillsA') {
        this.searchItems(event.target.value, 'skillA')
      } else if (event.target.name === 'searchSkillsB') {
        this.searchItems(event.target.value, 'skillB')
      } else if (event.target.name === 'searchAdvisors') {
        this.searchItems(event.target.value, 'advisor')
      } else if (event.target.name === 'searchMembers') {
        this.searchItems(event.target.value, 'member')
      } else if (event.target.name === 'searchAdvisees') {
        this.searchItems(event.target.value, 'advisee')
      } else if (event.target.name.includes("actionItem|")) {
        let actionItems = this.state.actionItems
        const index = Number(event.target.name.split("|")[1])
        actionItems[index] = event.target.value
        this.setState({ actionItems })
      } else if (event.target.name.includes("link|")) {
        let links = this.state.links
        const index = Number(event.target.name.split("|")[1])
        links[index] = event.target.value
        this.setState({ links })
      } else if (event.target.name.includes('aLink|')) {
        const index = Number(event.target.name.split("|")[1])
        let aLinks = this.state.aLinks
        aLinks[index] = event.target.value
        this.setState({ aLinks })
      } else if (event.target.name.includes('bLink|')) {
        const index = Number(event.target.name.split("|")[1])
        let bLinks = this.state.bLinks
        bLinks[index] = event.target.value
        this.setState({ bLinks })
      } else if (event.target.name === 'comparisonType') {
        let pollQuestion = null
        if (event.target.value === 'Careers') {
          pollQuestion = 'Which career path should I choose? Why?'
        } else if (event.target.value === 'Competencies') {
          pollQuestion = 'Which competency should I focus on? Why?'
        } else if (event.target.value === 'Projects') {
          pollQuestion = 'Which project should I focus on? Why?'
        } else if (event.target.value === 'Jobs') {
          pollQuestion = 'Which job should I take? Why?'
        }
        this.setState({ [event.target.name]: event.target.value, pollQuestion })

      } else if (event.target.name.includes("progress|")) {
        let progress = this.state.progress
        const name = event.target.name.split("|")[1]
        const index = Number(event.target.name.split("|")[2])
        console.log('gimme values: ', progress, name, index)
        progress[index][name] = event.target.value

        this.setState({ progress })
      } else if (event.target.name.includes("strategy|")) {
        let strategies = this.state.strategies
        const name = event.target.name.split("|")[1]
        const index = Number(event.target.name.split("|")[2])
        // console.log('gimme values: ', progress, name, index)
        strategies[index][name] = event.target.value

        this.setState({ strategies })
      } else if (event.target.name.includes("tactic|")) {
        let strategies = this.state.strategies

        const index = Number(event.target.name.split("|")[1])
        const index2 = Number(event.target.name.split("|")[2])

        strategies[index]['tactics'][index2] = event.target.value
        this.setState({ strategies })
      } else if (event.target.name.includes("checklist|")) {
        let checklist = this.state.checklist

        const name = event.target.name.split("|")[1]
        const index = Number(event.target.name.split("|")[2])

        checklist[index][name] = event.target.value
        this.setState({ checklist })
      } else if (event.target.name === 'feedback') {
        let selectedSuggestion = this.state.selectedSuggestion
        selectedSuggestion['feedback'] = event.target.value
        this.setState({ selectedSuggestion })
      } else if (event.target.name === 'meetingPurpose') {

        let meetingOutcomeOptions = []
        for (let i = 1; i <= this.state.meetingPurposeOptions.length; i++) {
          if (this.state.meetingPurposeOptions[i - 1].name === event.target.value) {
            if (this.state.meetingPurposeOptions[i - 1].meetingOutcomeOptions) {
              meetingOutcomeOptions = [''].concat(this.state.meetingPurposeOptions[i - 1].meetingOutcomeOptions)
            }
          }
        }

        this.setState({ [event.target.name]: event.target.value, meetingOutcomeOptions })
      } else {
        this.setState({ [event.target.name]: event.target.value })
      }
    }

    searchItems(searchString, type) {
      console.log('searchItems called', searchString, type)

      if (type.includes('pathway')) {
        if (!searchString || searchString === '') {
          this.setState({ searchString, searchIsAnimatingPathways: false, pathwayOptions: null })
        } else {

          let searchIsAnimatingPathways = true

          this.setState({ searchString, searchIsAnimatingPathways })

          // const search = true

          const self = this
          function officiallyFilter() {
            console.log('officiallyFilter called')

            Axios.get('/api/pathways/search', { params: {searchString, orgCode: self.state.activeOrg, accountCode: null }})
            .then((response) => {
              console.log('Pathways query attempted', response.data);

                if (response.data.success) {
                  console.log('successfully retrieved pathways')

                  if (response.data) {

                    let pathwayOptions = []
                    if (response.data.pathways && response.data.pathways.length > 0) {
                      pathwayOptions = response.data.pathways
                    }

                    self.setState({ pathwayOptions, searchIsAnimatingPathways: false })
                  }

                } else {
                  console.log('no pathway data found', response.data.message)
                  let pathwayOptions = []
                  self.setState({ pathwayOptions,searchIsAnimatingPathways: false })
                }

            }).catch((error) => {
                console.log('Pathway query did not work', error);

                let pathwayOptions = []
                self.setState({ pathwayOptions, searchIsAnimatingPathways: false })
            });
          }

          const delayFilter = () => {
            console.log('delayFilter called: ')
            clearTimeout(self.state.timerId)
            self.state.timerId = setTimeout(officiallyFilter, 1000)
          }

          delayFilter();
        }
      } else if (type.includes('career')) {
        if (!searchString || searchString === '') {
          this.setState({ searchString, searchStringA: searchString, searchStringB: searchString,
            searchIsAnimatingCareers: false, careerOptions: null,
            searchIsAnimatingCareersA: false, careerOptionsA: null,
            searchIsAnimatingCareersB: false, careerOptionsB: null,
          })
        } else {

          // let searchString = this.state.searchString
          let searchIsAnimatingCareers = false
          let searchStringA = this.state.searchStringA
          let searchIsAnimatingCareersA = false
          let searchStringB = this.state.searchStringB
          let searchIsAnimatingCareersB = false
          if (type === 'career') {
            // searchString = searchString
            searchIsAnimatingCareers = true
          } else if (type === 'careerA') {
            searchStringA = searchString
            searchIsAnimatingCareersA = true
          } else if (type === 'careerB') {
            searchStringB = searchString
            searchIsAnimatingCareersB = true
          }
          this.setState({ searchString, searchIsAnimatingCareers, searchStringA, searchIsAnimatingCareersA,
            searchStringB, searchIsAnimatingCareersB
          })

          const search = true

          const self = this
          function officiallyFilter() {
            console.log('officiallyFilter called')

            const excludeMissingOutlookData = true
            const excludeMissingJobZone = true

            Axios.put('/api/careers/search', {  searchString, search, excludeMissingOutlookData, excludeMissingJobZone })
            .then((response) => {
              console.log('Careers query attempted', response.data);

                if (response.data.success) {
                  console.log('successfully retrieved careers')

                  if (response.data) {

                    let careerOptions = []
                    let careerOptionsA = []
                    let careerOptionsB = []
                    if (response.data.careers && response.data.careers.length > 0) {
                      if (type === 'career') {
                        careerOptions = response.data.careers
                      } else if (type === 'careerA') {
                        careerOptionsA = response.data.careers
                      } else if (type === 'careerB') {
                        careerOptionsB = response.data.careers
                      }
                    }

                    self.setState({
                      careerOptions, careerOptionsA, careerOptionsB,
                      searchIsAnimatingCareers: false, searchIsAnimatingCareersA: false, searchIsAnimatingCareersB: false
                    })
                  }

                } else {
                  console.log('no career data found', response.data.message)
                  let careerOptions = []
                  let careerOptionsA = []
                  let careerOptionsB = []
                  self.setState({ careerOptions, careerOptionsA, careerOptionsB,
                    searchIsAnimatingCareers: false, searchIsAnimatingCareersA: false, searchIsAnimatingCareersB: false
                  })
                }

            }).catch((error) => {
                console.log('Career query did not work', error);

                let careerOptions = []
                let careerOptionsA = []
                let careerOptionsB = []
                self.setState({ careerOptions, careerOptionsA, careerOptionsB,
                  searchIsAnimatingCareers: false, searchIsAnimatingCareersA: false, searchIsAnimatingCareersB: false
                })
            });
          }

          const delayFilter = () => {
            console.log('delayFilter called: ')
            clearTimeout(self.state.timerId)
            self.state.timerId = setTimeout(officiallyFilter, 1000)
          }

          delayFilter();
        }
      } else if (type.includes('opportunity')) {
        if (!searchString || searchString === '') {
          this.setState({ searchStringOpportunities: searchString, searchStringOpportunitiesA: searchString, searchStringOpportunitiesB: searchString,
            searchIsAnimatingOpportunities: false, careerOptions: null,
            searchIsAnimatingOpportunitiesA: false, careerOptionsA: null,
            searchIsAnimatingOpportunitiesB: false, careerOptionsB: null,
          })
        } else {

          let searchStringOpportunities = this.state.searchStringOpportunities
          let searchIsAnimatingOpportunities = false
          let searchStringOpportunitiesA = this.state.searchStringOpportunitiesA
          let searchIsAnimatingOpportunitiesA = false
          let searchStringOpportunitiesB = this.state.searchStringOpportunitiesB
          let searchIsAnimatingOpportunitiesB = false
          if (type === 'opportunity') {
            searchStringOpportunities = searchString
            searchIsAnimatingOpportunities = true
          } else if (type === 'opportunityA') {
            searchStringOpportunitiesA = searchString
            searchIsAnimatingOpportunitiesA = true
          } else if (type === 'opportunityB') {
            searchStringOpportunitiesB = searchString
            searchIsAnimatingOpportunitiesB = true
          }
          this.setState({ searchStringOpportunities, searchStringOpportunitiesA, searchStringOpportunitiesB,
            searchIsAnimatingOpportunities, searchIsAnimatingOpportunitiesA, searchIsAnimatingOpportunitiesB
          })

          const self = this
          function officiallyFilter() {
            console.log('officiallyFilter called')

            const orgCode = self.state.activeOrg
            const placementPartners = self.state.placementPartners
            const accountCode = self.state.accountCode
            const search = true
            const postTypes = ['Internship','Work','Assignment','Problem','Challenge']

            Axios.get('/api/postings/search', { params: { searchString, orgCode, placementPartners, accountCode, search, postTypes } })
            .then((response) => {
              console.log('Opportunity search query attempted', response.data);

                if (response.data.success) {
                  console.log('opportunity search query worked')

                  let opportunityOptions = []
                  let opportunityOptionsA = []
                  let opportunityOptionsB = []
                  if (type === 'opportunity') {
                    opportunityOptions = response.data.postings
                  } else if (type === 'opportunityA') {
                    opportunityOptionsA = response.data.postings
                  } else if (type === 'opportunityB') {
                    opportunityOptionsB = response.data.postings
                  }
                  self.setState({ opportunityOptions, opportunityOptionsA, opportunityOptionsB,
                    searchIsAnimatingOpportunities: false, searchIsAnimatingOpportunitiesA: false, searchIsAnimatingOpportunitiesB: false,
                  })

                } else {
                  console.log('opportunity search query did not work', response.data.message)

                  let opportunityOptions = []
                  let opportunityOptionsA = []
                  let opportunityOptionsB = []
                  self.setState({ opportunityOptions, opportunityOptionsA, opportunityOptionsB,
                    searchIsAnimatingOpportunities: false, searchIsAnimatingOpportunitiesA: false, searchIsAnimatingOpportunitiesB: false
                  })

                }

            }).catch((error) => {
                console.log('Search query did not work for some reason', error);
                let opportunityOptions = []
                let opportunityOptionsA = []
                let opportunityOptionsB = []
                self.setState({ opportunityOptions, opportunityOptionsA, opportunityOptionsB,
                  searchIsAnimatingOpportunities: false, searchIsAnimatingOpportunitiesA: false, searchIsAnimatingOpportunitiesB: false
                })
            });

            // Axios.put('/api/careers/search', {  searchString, search, excludeMissingOutlookData, excludeMissingJobZone })
            // .then((response) => {
            //   console.log('Careers query attempted', response.data);
            //
            //     if (response.data.success) {
            //       console.log('successfully retrieved careers')
            //
            //       if (response.data) {
            //
            //         let careerOptions = []
            //         if (response.data.careers && response.data.careers.length > 0) {
            //           careerOptions = response.data.careers
            //         }
            //
            //         // THIS IS SUPER UNNECESSARY
            //         const filterCriteriaArray = response.data.filterCriteriaArray
            //         const sortCriteriaArray = null
            //
            //         self.setState({ careerOptions, animating: false })
            //       }
            //
            //     } else {
            //       console.log('no career data found', response.data.message)
            //       self.setState({ animating: false })
            //     }
            //
            // }).catch((error) => {
            //     console.log('Career query did not work', error);
            //     self.setState({ animating: false })
            // });
          }

          const delayFilter = () => {
            console.log('delayFilter called: ')
            clearTimeout(self.state.timerId)
            self.state.timerId = setTimeout(officiallyFilter, 1000)
          }

          delayFilter();

        }
      } else if (type.includes('skill')) {
        if (!searchString || searchString === '') {
          this.setState({ searchStringCompetencies: searchString, searchStringCompetenciesA: searchString, searchStringCompetenciesB: searchString,
            searchIsAnimatingCompetencies: false, competencyOptions: null,
            searchIsAnimatingCompetenciesA: false, competencyOptionsA: null,
            searchIsAnimatingCompetenciesB: false, competencyOptionsB: null,
          })
        } else {

          let searchStringCompetencies = this.state.searchStringCompetencies
          let searchIsAnimatingCompetencies = false
          let searchStringCompetenciesA = this.state.searchStringCompetenciesA
          let searchIsAnimatingCompetenciesA = false
          let searchStringCompetenciesB = this.state.searchStringCompetenciesB
          let searchIsAnimatingCompetenciesB = false
          if (type === 'skill') {
            searchStringCompetencies = searchString
            searchIsAnimatingCompetencies = true
          } else if (type === 'skillA') {
            searchStringCompetenciesA = searchString
            searchIsAnimatingCompetenciesA = true
          } else if (type === 'skillB') {
            searchStringCompetenciesB = searchString
            searchIsAnimatingCompetenciesB = true
          }
          this.setState({ searchStringCompetencies, searchStringCompetenciesA, searchStringCompetenciesB,
            searchIsAnimatingCompetencies, searchIsAnimatingCompetenciesA, searchIsAnimatingCompetenciesB
          })

          const self = this
          function officiallyFilter() {
            console.log('officiallyFilter called', searchString)

            // const orgCode = self.state.org
            // const placementPartners = self.state.placementPartners
            // const accountCode = self.state.accountCode
            // const search = true
            // const postTypes = ['Internship','Work','Assignment','Problem','Challenge']

            Axios.get('/api/competency/search', { params: { searchString } })
            .then((response) => {
              console.log('Competencies search query attempted', response.data);

                if (response.data.success) {
                  console.log('competency search query worked')

                  let competencyOptions = []
                  let searchIsAnimatingCompetencies = false
                  let competencyOptionsA = []
                  let searchIsAnimatingCompetenciesA = false
                  let competencyOptionsB = []
                  let searchIsAnimatingCompetenciesB = false
                  if (type === 'skill') {
                    competencyOptions = response.data.competencies
                  } else if (type === 'skillA') {
                    competencyOptionsA = response.data.competencies
                  } else if (type === 'skillB') {
                    competencyOptionsB = response.data.competencies
                  }
                  self.setState({ competencyOptions, searchIsAnimatingCompetencies,
                    competencyOptionsA, searchIsAnimatingCompetenciesA,
                    competencyOptionsB, searchIsAnimatingCompetenciesB,
                  })

                } else {
                  console.log('opportunity search query did not work', response.data.message)

                  let competencyOptions = []
                  let searchIsAnimatingCompetencies = false
                  let competencyOptionsA = []
                  let searchIsAnimatingCompetenciesA = false
                  let competencyOptionsB = []
                  let searchIsAnimatingCompetenciesB = false
                  self.setState({ competencyOptions, searchIsAnimatingCompetencies,
                    competencyOptionsA, searchIsAnimatingCompetenciesA,
                    competencyOptionsB, searchIsAnimatingCompetenciesB,
                  })

                }

            }).catch((error) => {
                console.log('Search query did not work for some reason', error);
                let competencyOptions = []
                let searchIsAnimatingCompetencies = false
                let competencyOptionsA = []
                let searchIsAnimatingCompetenciesA = false
                let competencyOptionsB = []
                let searchIsAnimatingCompetenciesB = false
                self.setState({ competencyOptions, searchIsAnimatingCompetencies,
                  competencyOptionsA, searchIsAnimatingCompetenciesA,
                  competencyOptionsB, searchIsAnimatingCompetenciesB,
                })
            });
          }

          const delayFilter = () => {
            console.log('delayFilter called: ')
            clearTimeout(self.state.timerId)
            self.state.timerId = setTimeout(officiallyFilter, 1000)
          }

          delayFilter();

        }
      } else if (type === 'member' || type === 'advisor') {
        if (!searchString || searchString === '') {
          this.setState({ searchStringMembers: searchString, searchIsAnimatingMembers: false, memberOptions: null })
        } else {
          this.setState({ searchStringMembers: searchString, searchIsAnimatingMembers: true })

          let roleNames = null
          if (type === 'advisor') {
            roleNames = ['Teacher','Counselor','Support Staff','Mentor','Admin']
          }

          const self = this
          function officiallyFilter() {
            console.log('officiallyFilter called', searchString)

            const orgCode = self.state.activeOrg

            //school district orgs
            Axios.get('/api/members/search', { params: { roleNames, searchString, orgCode } })
            .then((response) => {

                if (response.data.success) {
                  console.log('Member query worked', response.data);

                  self.setState({ memberOptions: response.data.members, searchIsAnimatingMembers: false })

                } else {
                  console.log('no members found', response.data.message)
                }

            }).catch((error) => {
                console.log('Members query did not work', error);
            });
          }

          const delayFilter = () => {
            console.log('delayFilter called: ')
            clearTimeout(self.state.timerId)
            self.state.timerId = setTimeout(officiallyFilter, 1000)
          }

          delayFilter();

        }
      } else if (type === 'advisee') {
        if (!searchString || searchString === '') {
          this.setState({ searchStringAdvisees: searchString, searchIsAnimatingAdvisees: false, adviseeOptions: null })
        } else {
          this.setState({ searchStringAdvisees: searchString, searchIsAnimatingAdvisees: true })

          let roleNames = ['Student','Career-Seeker']
          if (type === 'advisor') {
            roleNames = ['Teacher','Counselor','Support Staff','Mentor','Admin']
          }

          const self = this
          function officiallyFilter() {
            console.log('officiallyFilter called', searchString)

            const orgCode = self.state.activeOrg

            //school district orgs
            Axios.get('/api/members/search', { params: { roleNames, searchString, orgCode } })
            .then((response) => {

                if (response.data.success) {
                  console.log('Member query worked', response.data);

                  self.setState({ adviseeOptions: response.data.members, searchIsAnimatingAdvisees: false })

                } else {
                  console.log('no members found', response.data.message)
                }

            }).catch((error) => {
                console.log('Members query did not work', error);
            });
          }

          const delayFilter = () => {
            console.log('delayFilter called: ')
            clearTimeout(self.state.timerId)
            self.state.timerId = setTimeout(officiallyFilter, 1000)
          }

          delayFilter();

        }
      }
    }

    adjustCoreCompetencies(selectedItem, type, subType, add) {
      console.log('adjustCoreCompetencies called', selectedItem, type, add)

      if (type === 'pathway') {
        // eventually add competencies
      } else if (type === 'career') {

        if (selectedItem) {

          let competencies = this.state.competencies
          // console.log('in career: ')
          if (selectedItem.abilitiesArray) {
            for (let i = 1; i <= selectedItem.abilitiesArray.length; i++) {

              if (add) {
                competencies.push({
                  category: 'Ability',
                  name: selectedItem.abilitiesArray[i - 1].category,
                  description: selectedItem.abilitiesArray[i - 1].subcategories.toString(),
                })
              } else {
                const compIndex = competencies.findIndex(x => x.name === selectedItem.abilitiesArray[i - 1].category)
                if (compIndex > -1) {
                  competencies.splice(compIndex,1)
                }
              }
            }
          }
          if (selectedItem.knowledgeArray) {
            for (let i = 1; i <= selectedItem.knowledgeArray.length; i++) {
              if (add) {
                competencies.push({
                  category: 'Knowledge',
                  name: selectedItem.knowledgeArray[i - 1].category,
                  description: selectedItem.knowledgeArray[i - 1].subcategories.toString(),
                })
              } else {
                const compIndex = competencies.findIndex(x => x.name === selectedItem.knowledgeArray[i - 1].category)
                if (compIndex > -1) {
                  competencies.splice(compIndex,1)
                }
              }

            }
          }
          if (selectedItem.personalityData && selectedItem.personalityData.workStyles) {
            for (let i = 1; i <= selectedItem.personalityData.workStyles.length; i++) {
              if (add) {
                competencies.push({
                  category: 'Soft Skill',
                  name: selectedItem.personalityData.workStyles[i - 1],
                })
              } else {
                const compIndex = competencies.findIndex(x => x.name === selectedItem.personalityData.workStyles[i - 1])
                if (compIndex > -1) {
                  competencies.splice(compIndex,1)
                }
              }

            }
          }
          if (selectedItem.skillsArray) {
            for (let i = 1; i <= selectedItem.skillsArray.length; i++) {
              if (add) {
                competencies.push({
                  category: 'General Hard Skill',
                  name: selectedItem.skillsArray[i - 1].category,
                  description: selectedItem.skillsArray[i - 1].subcategories.toString(),
                })
              } else {
                const compIndex = competencies.findIndex(x => x.name === selectedItem.skillsArray[i - 1].category)
                if (compIndex > -1) {
                  competencies.splice(compIndex,1)
                }
              }

            }
          }
          if (selectedItem.technologyArray) {
            for (let i = 1; i <= selectedItem.technologyArray.length; i++) {
              if (add) {
                competencies.push({
                  category: 'Tech Skill',
                  name: selectedItem.technologyArray[i - 1].name,
                  description: selectedItem.technologyArray[i - 1].examples.toString(),
                })
              } else {
                const compIndex = competencies.findIndex(x => x.name === selectedItem.technologyArray[i - 1].name)
                if (compIndex > -1) {
                  competencies.splice(compIndex,1)
                }
              }

            }
          }
          console.log('in competencies: ', competencies)
          this.setState({ competencies })
        }

      } else if (type === 'opportunity') {

        if (selectedItem) {

          let benchmarkId = null
          let jobFunction = null
          if (selectedItem.benchmarkId) {
            benchmarkId = selectedItem.benchmarkId
          } else {
            if (selectedItem.jobFunction) {
              jobFunction = selectedItem.jobFunction
            } else if (selectedItem.workFunction) {
              jobFunction = selectedItem.workFunction
            } else if (selectedItem.functions && selectedItem.functions[0]) {
              jobFunction = selectedItem.functions[0]
            } else if (selectedItem.field && selectedItem.field.split("|")) {
              jobFunction = selectedItem.field.split("|")[0].trim()
            }
          }

          Axios.get('/api/benchmarks/byid', { params: { _id: benchmarkId, jobFunction } })
          .then((response) => {
            console.log('Benchmarks query by id attempted', response.data);

              if (response.data.success) {
                console.log('successfully retrieved benchmarks for individual')

                let competencies = this.state.competencies
                if (response.data.benchmark && response.data.benchmark.skills) {
                  for (let i = 1; i <= response.data.benchmark.skills.length; i++) {

                    let category = response.data.benchmark.skills[i - 1].skillType
                    if (response.data.benchmark.skills[i - 1].skillType === 'Hard Skill') {
                      category = 'General Hard Skill'
                    }

                    const name = response.data.benchmark.skills[i - 1].title
                    const description = response.data.benchmark.skills[i - 1].description

                    if (add) {
                      competencies.push({ category, name, description })
                    } else {
                      const compIndex = competencies.findIndex(x => x.name === name)
                      if (compIndex > -1) {
                        competencies.splice(compIndex,1)
                      }
                    }
                  }
                }

                this.setState({ competencies })

              } else {
                console.log('no benchmarks by id data found', response.data.message)
              }

          }).catch((error) => {
              console.log('Benchmarks query by id did not work', error);
          });
        }

      } else if (type === 'entrepreneurship') {
        let competencies = []
        let entrepreneurshipGoal = this.state.entrepreneurshipGoal
        let entrepreneurshipIndustry = this.state.entrepreneurshipIndustry

        if (subType === 'entrepreneurshipGoal') {
          entrepreneurshipGoal = selectedItem
        } else if (subType === 'entrepreneurshipIndustry') {
          entrepreneurshipIndustry = selectedItem
        }

        competencies.push({ category: 'Ability', name: 'Entrepreneurship' })
        competencies.push({ category: 'Soft Skill', name: 'Time Management' })
        competencies.push({ category: 'General Hard Skill', name: 'Strategic Thinking' })
        competencies.push({ category: 'Soft Skill', name: 'Efficiency' })
        competencies.push({ category: 'Soft Skill', name: 'Resilience' })
        competencies.push({ category: 'Soft Skill', name: 'Communication' })
        competencies.push({ category: 'Soft Skill', name: 'Sales' })
        console.log('show entrepreneurshipGoal: ', entrepreneurshipGoal)
        if (entrepreneurshipGoal && entrepreneurshipGoal !== '') {
          competencies.push({ category: 'General Hard Skill', name: entrepreneurshipGoal })
        }
        if (entrepreneurshipIndustry && entrepreneurshipIndustry !== '') {
          competencies.push({ category: 'Knowledge', name: entrepreneurshipIndustry })
        }

        this.setState({ competencies })
      } else if (type === 'skill') {
        let selectedSkill = null
        if (selectedItem) {
          selectedSkill = selectedItem.name
        } else if (this.state.searchStringCompetencies && this.state.searchStringCompetencies !== ''){
          selectedSkill = this.state.searchStringCompetencies
        }

        if (selectedSkill) {
          let competencies = this.state.competencies

          if (add) {
            competencies.push(selectedItem)
          } else {
            // const compIndex = competencies.findIndex(x => x.name === selectedItem.abilitiesArray[i - 1].category)
            const compIndex = competencies.indexOf(selectedSkill)
            if (compIndex > -1) {
              competencies.splice(compIndex,1)
            }
          }

          console.log('in competencies: ', competencies)
          this.setState({ competencies })
        }
      } else if (type === 'basics') {
        let competencies = []

        competencies.push({ category: 'Soft Skill', name: 'Organize' })
        competencies.push({ category: 'Soft Skill', name: 'Leadership' })
        competencies.push({ category: 'Soft Skill', name: 'Conflict Management' })
        competencies.push({ category: 'Soft Skill', name: 'Decision Making' })
        competencies.push({ category: 'Soft Skill', name: 'Time Management' })
        competencies.push({ category: 'Soft Skill', name: 'Communication' })
        competencies.push({ category: 'Tech Skill', name: 'Microsoft Office / Google Suite' })
        competencies.push({ category: 'General Hard Skill', name: 'Math' })
        competencies.push({ category: 'General Hard Skill', name: 'Writing' })

        this.setState({ competencies })
      } else if (type === 'stability' || type === 'pay' || type === 'interests'  || type === 'your interests') {

        const profile = this.state.profile

        Axios.put('/api/learning-objectives', { profile, category: type })
        .then((response) => {
          console.log('Learning objectives query attempted', response.data);

          if (response.data.success) {
            console.log('learning objectives query worked')

            const competencies = response.data.learningObjectives
            this.setState({ competencies })

          } else {
            console.log('learning objectives query did not work', response.data.message)
            //don't allow signups without an org affiliation
            this.setState({ error: { message: 'There was an error finding the learning objectives' } })
          }

        }).catch((error) => {
            console.log('Learning objectives query did not work for some reason', error);
        });
      }
    }

    saveLog() {
      console.log('saveLog clicked');

      this.setState({ isSaving: true, clientErrorMessage: '' })

      if (this.state.logType === 'Session' || this.state.logType === 'Check In') {

        if (this.state.remoteAuth && (!this.state.selectedMemberDetails || this.state.selectedMemberDetails.length === 0)) {
          this.setState({ isSaving: false, clientErrorMessage: 'please add an advisor' })
        } else if (this.state.remoteAuth && (!this.state.selectedMemberDetails[0].firstName || !this.state.selectedMemberDetails[0].firstName === '')) {
          this.setState({ isSaving: false, clientErrorMessage: 'there was an error retrieving the advisor first name' })
        } else if (this.state.remoteAuth && (!this.state.selectedMemberDetails[0].lastName || !this.state.selectedMemberDetails[0].lastName === '')) {
          this.setState({ isSaving: false, clientErrorMessage: 'there was an error retrieving the advisor last name' })
        } else if (this.state.remoteAuth && (!this.state.selectedMemberDetails[0].email || !this.state.selectedMemberDetails[0].email === '')) {
          this.setState({ isSaving: false, clientErrorMessage: 'there was an error retrieving the advisor email' })
        } else if (!this.state.remoteAuth && (!this.state.advisorFirstName || !this.state.advisorFirstName === '') && window.location.pathname.includes('/app')) {
          this.setState({ isSaving: false, clientErrorMessage: 'please add a first name' })
        } else if (!this.state.remoteAuth && (!this.state.advisorLastName || !this.state.advisorLastName === '') && window.location.pathname.includes('/app')) {
          this.setState({ isSaving: false, clientErrorMessage: 'please add a last name' })
        } else if (!this.state.remoteAuth && (!this.state.advisorEmail || !this.state.advisorEmail === '') && window.location.pathname.includes('/app')) {
          this.setState({ isSaving: false, clientErrorMessage: 'please add an email' })
        } else if (!this.state.remoteAuth && !this.state.advisorEmail.includes('@') && window.location.pathname.includes('/app')) {
          this.setState({ isSaving: false, clientErrorMessage: 'please add a valid email' })
        } else if (this.state.sessionDate === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please select a session date for the session' })
        } else if (this.state.sessionMethod === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please select a meeting method for the session' })
        // } else if (this.state.category === '') {
        //   this.setState({ clientErrorMessage: 'please select a category from the session' })
        } else if (this.state.notes === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add some notes from the session' })
        } else {

          // this.state.forceSelection
          if (window.location.pathname.includes('/organizations') || window.location.pathname.includes('/advisor')) {
            if (this.state.forceSelection) {
              if (this.state.selectedAdviseeDetails && this.state.selectedAdviseeDetails.length === 0) {
                return this.setState({ isSaving: false, clientErrorMessage: 'please add at least one advisee' })
              }
            } else {
              if (!this.state.adviseeFirstName && !this.state.adviseeLastName && !this.state.adviseeEmail) {
                return this.setState({ isSaving: false, clientErrorMessage: 'please add at least one advisee' })
              }
            }

          }

          const sessionId = this.state.sessionId
          let advisorFirstName = this.state.advisorFirstName
          let advisorLastName = this.state.advisorLastName
          let advisorEmail = this.state.advisorEmail
          let advisorUsername = null
          let advisorPictureURL = null
          if (window.location.pathname.includes('/advisor')) {
            advisorFirstName = this.state.cuFirstName
            advisorLastName = this.state.cuLastName
            advisorEmail = this.state.emailId
            advisorUsername = this.state.username
            advisorPictureURL = this.state.pictureURL
          } else if (this.state.remoteAuth) {
            advisorFirstName = this.state.selectedMemberDetails[0].firstName
            advisorLastName = this.state.selectedMemberDetails[0].lastName
            advisorEmail = this.state.selectedMemberDetails[0].email.trim()
            advisorUsername = this.state.selectedMemberDetails[0].username
            advisorPictureURL = this.state.selectedMemberDetails[0].pictureURL
          }

          let adviseeFirstName = this.state.cuFirstName
          let adviseeLastName = this.state.cuLastName
          let adviseeEmail = this.state.emailId
          let adviseeUsername = this.state.username
          let adviseePictureURL = this.state.pictureURL
          if (window.location.pathname.startsWith('/organizations') || window.location.pathname.startsWith('/advisor')) {
            if (this.state.forceSelection) {
              adviseeFirstName = this.state.selectedAdviseeDetails[0].firstName
              adviseeLastName = this.state.selectedAdviseeDetails[0].lastName
              adviseeEmail = this.state.selectedAdviseeDetails[0].email.trim()
              if (this.state.selectedAdviseeDetails[0].username) {
                adviseeUsername = this.state.selectedAdviseeDetails[0].username
              }
              if (this.state.selectedAdviseeDetails[0].pictureURL) {
                adviseePictureURL = this.state.selectedAdviseeDetails[0].pictureURL
              }
            } else {
              adviseeFirstName = this.state.adviseeFirstName
              adviseeLastName = this.state.adviseeLastName
              adviseeEmail = this.state.adviseeEmail
            }
          }

          const orgContactEmail = this.state.orgContactEmail
          const orgName = this.state.orgName
          const remoteAuth = this.state.remoteAuth

          const hiddenToCareerSeeker = this.state.hiddenToCareerSeeker
          const meetingPurpose = this.state.meetingPurpose
          const meetingOutcome = this.state.meetingOutcome
          const meetingTags = this.state.meetingTags
          const goalTags = this.state.goalTags

          Axios.post('/api/counseling/session', {
            creatorEmail: this.state.emailId, _id: sessionId,
            advisorFirstName, advisorLastName, advisorEmail, advisorUsername, advisorPictureURL,
            adviseeFirstName, adviseeLastName, adviseeEmail, adviseeUsername, adviseePictureURL,
            sessionDate: this.state.sessionDate, category: this.state.category, notes: this.state.notes,
            orgCode: this.state.activeOrg, sessionMethod: this.state.sessionMethod, remoteAuth,
            orgContactEmail, orgName, logType: 'Session', hiddenToCareerSeeker,
            meetingPurpose, meetingOutcome, meetingTags, goalTags,
            createdAt: new Date(), updatedAt: new Date() })
          .then((response) => {

            if (response.data.success) {
              //save values
              console.log('Session save worked', response.data);

              let selectedMemberDetails = this.state.selectedMemberDetails
              let firstName = this.state.firstName
              let lastName = this.state.lastName
              let email = this.state.email
              let sessionDate = this.state.sessionDate
              let sessionMethod = this.state.sessionMethod
              let category = this.state.category
              let notes = this.state.notes
              if (!this.state.editExisting) {
                selectedMemberDetails = []
                firstName = ''
                lastName = ''
                email = ''
                sessionDate = ''
                sessionMethod = ''
                category = ''
                notes = ''
              }

              this.setState({
                selectedMemberDetails, firstName, lastName, email, sessionDate, sessionMethod, category, notes,
                isSaving: false,
                serverPostSuccess: true,
                serverSuccessMessage: 'Session saved successfully!'
              })
            } else {
              console.error('there was an error saving the session');
              this.setState({
                isSaving: false,
                serverPostSuccess: false,
                serverErrorMessage: response.data.message,
              })
            }
          }).catch((error) => {
              console.log('Session save did not work', error);
              this.setState({
                isSaving: false,
                serverPostSuccess: false,
                serverErrorMessage: error.toString(),
              })
          });
        }
      } else if (this.state.logType === 'Meeting') {

        if (!this.state.method || this.state.method === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add a meeting method' })
        } else if (!this.state.location || this.state.location === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add a location for the meeting' })
        } else if (!this.state.startTime || this.state.startTime === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add a start time for the meeting' })
        } else if (!this.state.endTime || this.state.endTime === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add an end time for the meeting' })
        } else if (!this.state.description || this.state.description === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add a description for the meeting' })
        } else {

          let _id = this.state.meetingId
          let method = this.state.method
          let location = this.state.location
          let startTime = this.state.startTime
          let endTime = this.state.endTime
          let repeats = this.state.repeats
          let reminder = this.state.reminder
          let selectedMembers = this.state.selectedMemberDetails
          let description = this.state.description
          let links = this.state.links
          let notes = this.state.notes
          let actionItems = this.state.actionItems

          const creatorEmail = this.state.emailId
          const logType = 'Meeting'
          const orgCode = this.state.activeOrg
          const groupId = this.state.selectedGroup._id
          const groupName = this.state.selectedGroup.name
          const createdAt = new Date()
          const updatedAt = new Date()

          let meeting = {
            _id, method, location, startTime, endTime, repeats, reminder, selectedMembers, description,
            links, notes, actionItems, creatorEmail, logType, orgCode, groupId, groupName,
            createdAt, updatedAt
          }

          Axios.post('/api/logs/meetings', meeting)
          .then((response) => {

            if (response.data.success) {
              //save values
              console.log('Meeting save worked', response.data);

              selectedMembers = this.state.selectedMembers
              let selectedMemberDetails = this.state.selectedMemberDetails

              if (!this.state.editExisting) {
                if (window.location.pathname.includes(this.state.prefix + '/groups')) {
                  meeting[_id] = response.data._id
                  this.props.passMeeting(meeting)
                  this.closeModal()
                }
                selectedMembers = []
                selectedMemberDetails = []

                _id = null
                method = ''
                location = ''
                startTime = null
                endTime = null
                repeats = ''
                reminder = ''
                description = ''
                links = []
                notes = ''
                actionItems = []
              }

              this.setState({
                selectedMembers, selectedMemberDetails, _id, method, location, startTime, endTime,
                repeats, reminder, description, links, notes, actionItems,

                isSaving: false, serverPostSuccess: true,
                serverSuccessMessage: 'Meeting saved successfully!'
              })
            } else {
              console.error('there was an error saving the meeting');
              this.setState({
                isSaving: false, serverPostSuccess: false,
                serverErrorMessage: response.data.message,
              })
            }
          }).catch((error) => {
              console.log('Meeting save did not work', error);
              this.setState({
                isSaving: false, serverPostSuccess: false,
                serverErrorMessage: error.toString(),
              })
          });
        }
      } else if (this.state.logType === 'Goal') {

        if (this.state.goalTitle === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add a title of your goal' })
        } else if (this.state.goalDeadline === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add a deadline for your goal' })
        } else {

          let goalId = this.state.goalId
          const creatorEmail = this.state.emailId
          const creatorFirstName = this.state.cuFirstName
          const creatorLastName = this.state.cuLastName
          const creatorUsername = this.state.username
          const creatorPictureURL = this.state.pictureURL
          const creatorRoleName = this.state.roleName

          const title = this.state.goalTitle
          let description = this.state.goalDescription
          const startDate = this.state.goalStartDate
          // let deadline = convertStringToDate(this.state.goalDeadline,'toLocalReversed')
          let deadline = this.state.goalDeadline
          let tasks = this.state.tasks
          let requestedMentorSupport = this.state.requestedMentorSupport
          let notes = this.state.notes
          let status = this.state.goalStatus
          let decision = this.state.goalDecision
          let dateAchieved = this.state.dateAchieved
          let successDescription = this.state.successDescription
          let permissionToShare = this.state.permissionToShare

          let orgCode = ''
          if (this.state.activeOrg) {
            orgCode = this.state.activeOrg
          }
          const orgContactEmail = this.state.orgContactEmail
          const goalType = this.state.goalType

          let selectedPathways = this.state.selectedPathwayDetails
          let selectedCareers = this.state.selectedCareerDetails
          let selectedOpportunities = this.state.selectedOpportunityDetails
          let competencies = this.state.competencies
          let selectedFunctions = this.state.selectedFunctions
          let selectedIndustries = this.state.selectedIndustries
          let selectedHours = this.state.selectedHours
          let selectedPayRanges = this.state.selectedPayRanges
          let selectedOptimizeOptions = this.state.selectedOptimizeOptions
          let selectedSkills = this.state.selectedSkills
          let selectedMembers = this.state.selectedMemberDetails
          let selectedSchools = this.state.selectedSchools
          let selectedMajors = this.state.selectedMajors
          if (this.state.tags && this.state.tags.length > 0) {
            selectedPathways = []
            selectedCareers = []
            selectedOpportunities = []
            competencies = []
            selectedFunctions = []
            selectedIndustries = []
            selectedHours = []
            selectedPayRanges = []
            selectedOptimizeOptions = []
            selectedSkills = []
            // selectedMembers = []
            for (let i = 1; i <= this.state.tags.length; i++) {
              if (this.state.tags[i - 1].name === 'pathway') {
                selectedPathways.push(this.state.tags[i - 1].value)
              } else if (this.state.tags[i - 1].name === 'career') {
                selectedCareers.push(this.state.tags[i - 1].value)
              } else if (this.state.tags[i - 1].name === 'opportunity') {
                selectedOpportunities.push(this.state.tags[i - 1].value)
              } else if (this.state.tags[i - 1].name === 'competency') {
                competencies.push(this.state.tags[i - 1].value)
              } else if (this.state.tags[i - 1].name === 'function') {
                selectedFunctions.push(this.state.tags[i - 1].value)
              } else if (this.state.tags[i - 1].name === 'industry') {
                selectedIndustries.push(this.state.tags[i - 1].value)
              } else if (this.state.tags[i - 1].name === 'hoursPerWeek') {
                selectedHours.push(this.state.tags[i - 1].value)
              } else if (this.state.tags[i - 1].name === 'payRange') {
                selectedPayRanges.push(this.state.tags[i - 1].value)
              } else if (this.state.tags[i - 1].name === 'optimize') {
                selectedOptimizeOptions.push(this.state.tags[i - 1].value)
              } else if (this.state.tags[i - 1].name === 'skill') {
                selectedSkills.push(this.state.tags[i - 1].value)
              // } else if (this.state.tags[i - 1].name === 'member') {
              //   selectedMembers.push(this.state.tags[i - 1].value)
              }
            }
          }

          const entrepreneurshipStage = this.state.entrepreneurshipStage
          const entrepreneurshipType = this.state.entrepreneurshipType
          const entrepreneurshipGoal = this.state.entrepreneurshipGoal
          const entrepreneurshipProject = this.state.entrepreneurshipProject
          const intensity = this.state.intensity
          const budget = this.state.budget
          const degreeType = this.state.degreeType

          const skillPreference = this.state.skillPreference
          const societalProblem = this.state.societalProblem
          const successDefined = this.state.successDefined

          const checklist = this.state.checklist
          const progress = this.state.progress
          const strategies = this.state.strategies
          const comparisonType = this.state.comparisonType
          const pollConnections = this.state.pollConnections
          const pollQuestion = this.state.pollQuestion
          const aName = this.state.aName
          const aValue = this.state.aValue
          const aItem = this.state.aItem
          const aCase = this.state.aCase
          const aLinks = this.state.aLinks
          const bName = this.state.bName
          const bValue = this.state.bValue
          const bItem = this.state.bItem
          const bCase = this.state.bCase
          const bLinks = this.state.bLinks

          const pictureURL = this.state.pictureURL
          const username = this.state.username
          const roleName = this.state.roleName
          const headline = this.state.headline
          const remoteAuth = this.state.remoteAuth

          let publicExtent = 'Private'
          if (this.state.publicProfile && this.state.publicProfileExtent === 'Public') {
            // public, members only, private
            publicExtent = 'Public'
          } else if (this.state.publicProfile && this.state.publicProfileExtent === 'Only Connections and Members') {
            publicExtent = 'Members Only'
          }

          console.log('show aItem: ', this.state.publicProfile, this.state.publicProfileExtent)

          let selectedGoal = {
            _id: goalId, creatorEmail, creatorFirstName, creatorLastName, creatorUsername, creatorPictureURL, creatorRoleName,
            title, description, startDate, deadline, tasks,
            goalType, selectedPathways, selectedCareers, selectedOpportunities, entrepreneurshipStage, entrepreneurshipType, entrepreneurshipGoal,
            entrepreneurshipProject, intensity, budget, competencies, degreeType,
            comparisonType, pollConnections, pollQuestion, aName, aValue, aCase, aLinks, bName, bValue, bCase, bLinks,
            aItem, bItem,
            selectedFunctions, selectedIndustries, selectedHours, selectedPayRanges, selectedOptimizeOptions, selectedSkills, selectedMembers,
            selectedSchools, selectedMajors, checklist, progress, strategies,
            requestedMentorSupport, notes, logType: 'Goal', skillPreference, societalProblem, successDefined,
            pictureURL, username, roleName, headline, remoteAuth, publicExtent,
            status, decision, dateAchieved, successDescription, permissionToShare,
            createdAt: new Date(), orgContactEmail, orgCode, updatedAt: new Date()
          }

          //save goals
          Axios.post('/api/logs/goals', selectedGoal)
          .then((response) => {

            if (response.data.success) {
              //save values
              console.log('Goal save worked', response.data);

              let currentPage = 'Details'
              if (!this.state.editExisting) {
                // window.scrollTo(0, 0)
                // currentPage = 'Suggestions'
                goalId = response.data._id
                selectedGoal['_id'] = goalId

                const category = 'Activation';
                let action = 'completions'

                let firstGoal = true
                if (this.state.goalOptions && this.state.goalOptions.length > 0) {
                  if (this.state.goalOptions[1] && this.state.goalOptions[1].title) {
                    firstGoal = false
                  }
                }

                if (firstGoal) {
                  action = 'firstCompletions'
                }

                ReactGA.initialize([{ trackingId: "376007762" }]);
                ReactGA.event({ category, action, label: action });

                // console.log('show the first goal: ', firstGoal)

              }

              let serverSuccessMessage = response.data.message

              const self = this
              function wrapUpSave(creditsUsed) {
                if (window.location.pathname.includes(self.state.prefix + '/walkthrough')) {
                  self.setState({ isSaving: false, creditsUsed })
                  self.closeModal()
                  self.props.passGoal(selectedGoal)
                } else {
                  self.setState({ goalId, editExisting: true, currentPage, selectedGoal, creditsUsed,

                    isSaving: false, serverPostSuccess: true, serverSuccessMessage
                  })

                  self.props.navigate((window.location.pathname.includes('/advisor')) ? '/advisor/edit-logs/' + goalId : '/app/logs/' + goalId, { state: { editExisting: true }})

                }
              }
              if (this.state.showModule && this.state.autoGeneratePlan) {
                const startingCredits = this.state.startingCredits
                const creditsUsed = this.state.creditsUsed
                const relatedGoalDocuments = this.state.relatedGoalDocuments

                Axios.post('/api/goals/generate-plan', { goal: selectedGoal, roleName, startingCredits, creditsUsed, relatedGoalDocuments })
                .then((response) => {
                  if (response.data.success) {
                    console.log('Generate plan worked', response.data);

                    serverSuccessMessage = "Successfully saved your goal and auto-generated a plan!"
                    wrapUpSave(response.data.creditsUsed)
                  } else {
                    console.error('there was an error generating the plan', response.data.message);
                    wrapUpSave()
                  }
                }).catch((error) => {
                    console.log('Generate plan did not work', error);
                    wrapUpSave()
                });
              } else {
                wrapUpSave()
              }

              // if (window.location.pathname.includes(this.state.prefix + '/walkthrough')) {
              //   this.setState({ isSaving: false })
              //   this.closeModal()
              //   this.props.passGoal(selectedGoal)
              // } else {
              //   this.setState({ goalId, editExisting: true, currentPage, selectedGoal,
              //
              //     isSaving: false, serverPostSuccess: true,
              //     serverSuccessMessage: response.data.message
              //   })
              //
              //   this.props.navigate((window.location.pathname.includes('/advisor')) ? '/advisor/edit-logs/' + goalId : '/app/logs/' + goalId, { state: { editExisting: true }})
              //
              // }

            } else {
              console.log('there was an error saving the goal', response.data.message);
              this.setState({
                isSaving: false, serverPostSuccess: false,
                serverErrorMessage: response.data.message,
              })
            }
          }).catch((error) => {
              console.log('Goal save did not work', error);
              this.setState({
                isSaving: false, serverPostSuccess: false,
                serverErrorMessage: error.toString(),
              })
          });

        }
      } else if (this.state.logType === 'Application') {

        if (this.state.employerName === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the employer name' })
        } else if (this.state.employerURL === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the employer url' })
        } else if (this.state.employerType === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the employer type' })
        } else if (this.state.industry === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the employer industry' })
        } else if (this.state.positionTitle === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the position title' })
        } else if (this.state.jobFunction === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the job function' })
        } else if (this.state.workType === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the work type' })
        } else if (this.state.timeframe === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the timeframe' })
        } else {

          const applicationId = this.state.applicationId
          const creatorEmail = this.state.emailId
          const creatorFirstName = this.state.cuFirstName
          const creatorLastName = this.state.cuLastName
          const creatorUsername = this.state.username
          const creatorPictureURL = this.state.pictureURL

          let employerName = this.state.employerName
          let employerURL = this.state.employerURL
          let employerType = this.state.employerType
          let employerIndustry = this.state.industry
          let employerSize = this.state.employeeCount
          let positionTitle = this.state.positionTitle
          let positionLink = this.state.positionLink
          let jobFunction = this.state.jobFunction
          let workType = this.state.workType
          let timeframe = this.state.timeframe
          let applicationDeadline = this.state.applicationDeadline
          let reviewedMaterials = this.state.reviewedMaterials
          let orgCode = ''
          if (this.state.activeOrg) {
            orgCode = this.state.activeOrg
          }

          //save application
          Axios.post('/api/logs/applications', {
            _id: applicationId, creatorEmail, creatorFirstName, creatorLastName, creatorUsername, creatorPictureURL,
            employerName, employerURL,
            employerType, employerIndustry, employerSize, logType: 'Application',
            positionTitle, positionLink, jobFunction, workType, timeframe, applicationDeadline,
            reviewedMaterials, orgCode, createdAt: new Date(), updatedAt: new Date() })
          .then((response) => {

            if (response.data.success) {
              //save values
              console.log('Application save worked', response.data);

              if (!this.state.editExisting) {
                employerName = ''
                employerURL = ''
                employerType = ''
                employerIndustry = ''
                employerSize = ''
                positionTitle = ''
                positionLink = ''
                jobFunction = ''
                workType = ''
                timeframe = ''
                applicationDeadline = ''
                reviewedMaterials = ''
              }

              this.setState({
                employerName, employerURL, employerType, industry: employerIndustry,
                employeeCount: employerSize, positionTitle, positionLink,
                jobFunction, workType, timeframe, applicationDeadline, reviewedMaterials,

                isSaving: false, serverPostSuccess: true,
                serverSuccessMessage: 'Application saved successfully!'
              })
            } else {
              console.error('there was an error saving the application', response.data.message);
              this.setState({
                isSaving: false, serverPostSuccess: false,
                serverErrorMessage: response.data.message,
              })
            }
          }).catch((error) => {
              console.log('Application save did not work', error);
              this.setState({
                isSaving: false, serverPostSuccess: false,
                serverErrorMessage: error.toString(),
              })
          });
        }

      } else if (this.state.logType === 'Interview') {

        if (this.state.interviewDate === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the interview round' })
        } else if (this.state.interviewRound === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the interview round' })
        } else if (this.state.numberOfInterviews === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the number of interviews' })
        } else if (this.state.interviewLength === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the interview length' })
        } else if (this.state.fitRating === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please rate your fit' })
        } else {

          const interviewId = this.state.interviewId
          const creatorEmail = this.state.emailId
          const creatorFirstName = this.state.cuFirstName
          const creatorLastName = this.state.cuLastName
          const creatorUsername = this.state.username
          const creatorPictureURL = this.state.pictureURL

          let associatedApplicationId = this.state.associatedApplication._id
          let associatedApplicationPositionTitle = this.state.associatedApplication.positionTitle
          let associatedApplicationEmployerName = this.state.associatedApplication.employerName
          let interviewDate = this.state.interviewDate
          let interviewRound = this.state.interviewRound
          let numberOfInterviews = this.state.numberOfInterviews
          let interviewLength = this.state.interviewLength
          let interviews = this.state.interviews
          let mcPracticedInterviewing = this.state.mcPracticedInterviewing
          let wasPrepared = this.state.wasPrepared
          let questionsAsked = this.state.questionsAsked
          let questionsAnswered = this.state.questionsAnswered
          let unrelatedTopics = this.state.unrelatedTopics
          let positionRating = this.state.positionRating
          let thoughtsOnPosition = this.state.thoughtsOnPosition
          let companyRating = this.state.companyRating
          let thoughtsOnCompany = this.state.thoughtsOnCompany
          let fitRating = this.state.fitRating
          let thoughtsOnFit = this.state.thoughtsOnFit
          let employerFeedback = this.state.employerFeedback
          let passed = this.state.passed
          let orgCode = ''
          if (this.state.activeOrg) {
            orgCode = this.state.activeOrg
          }

          //save application
          Axios.post('/api/logs/interviews', {
            _id: interviewId, creatorEmail, creatorFirstName, creatorLastName, creatorUsername, creatorPictureURL,
            associatedApplicationId, associatedApplicationPositionTitle, associatedApplicationEmployerName,
            interviewDate, interviewRound, numberOfInterviews, logType: 'Interview',
            interviewLength, interviews, mcPracticedInterviewing, wasPrepared, questionsAsked, questionsAnswered,
            unrelatedTopics, positionRating, thoughtsOnPosition, companyRating, thoughtsOnCompany,
            fitRating, thoughtsOnFit, employerFeedback, passed, orgCode,
            createdAt: new Date(), updatedAt: new Date() })
          .then((response) => {

            if (response.data.success) {
              //save values
              console.log('Interview save worked', response.data);

              let associatedApplication = this.state.associatedApplication

              if (!this.state.editExisting) {
                associatedApplication = { name: 'Attach a Saved Application'}
                interviewDate = ''
                interviewRound = ''
                numberOfInterviews = ''
                interviews = []
                interviewLength = ''
                mcPracticedInterviewing = false
                wasPrepared = false
                questionsAsked = []
                questionsAnswered = []
                unrelatedTopics = ''
                positionRating = ''
                thoughtsOnPosition = ''
                companyRating = ''
                thoughtsOnCompany = ''
                fitRating = ''
                thoughtsOnFit = ''
                employerFeedback = ''
                passed = false
              }

              this.setState({
                associatedApplication,
                interviewDate, interviewRound, numberOfInterviews: '',
                interviewLength, mcPracticedInterviewing, wasPrepared,
                questionsAsked, questionsAnswered, unrelatedTopics, positionRating,
                thoughtsOnPosition, companyRating, thoughtsOnCompany, fitRating,
                thoughtsOnFit, employerFeedback, passed,

                isSaving: false, serverPostSuccess: true,
                serverSuccessMessage: 'Interview saved successfully!'
              })
            } else {
              console.error('there was an error saving the interview', response.data.message);
              this.setState({
                isSaving: false, serverPostSuccess: false,
                serverErrorMessage: response.data.message,
              })
            }
          }).catch((error) => {
              console.log('Interview save did not work', error);
              this.setState({
                isSaving: false, serverPostSuccess: false,
                serverErrorMessage: error.toString(),
              })
          });
        }
      } else if (this.state.logType === 'Offer') {

        if (this.state.offerPayType === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the pay type' })
        } else if (this.state.offerPay === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the pay' })
        } else if (this.state.offerStartDate === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add the start date' })
        } else if (this.state.offerDecision === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add your decision' })
        } else if (this.state.decisionReason === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add a reason for your decision' })
        } else {

          const offerId = this.state.offerId
          const creatorEmail = this.state.emailId
          const creatorFirstName = this.state.cuFirstName
          const creatorLastName = this.state.cuLastName
          const creatorUsername = this.state.username
          const creatorPictureURL = this.state.pictureURL

          let associatedApplicationId = this.state.offerAssociatedApplication._id

          let associatedApplicationPositionTitle = this.state.offerAssociatedApplication.positionTitle
          let associatedApplicationEmployerName = this.state.offerAssociatedApplication.employerName
          let payType = this.state.offerPayType
          let pay = this.state.offerPay
          let hasBonus = this.state.hasBonus
          let bonusDescription = this.state.bonusDescription
          let benefits = this.state.offerBenefits
          let offeredEquity = this.state.offeredEquity
          let equityPercentage = this.state.equityPercentage
          let companyValuation = this.state.companyValuation
          let startDate = this.state.offerStartDate
          let decision = this.state.offerDecision
          let decisionReason = this.state.decisionReason

          let orgCode = ''
          if (this.state.activeOrg) {
            orgCode = this.state.activeOrg
          }

          console.log('audit stuff', startDate)

          //save offer
          Axios.post('/api/logs/offers', {
            _id: offerId, creatorEmail, creatorFirstName, creatorLastName, creatorUsername, creatorPictureURL,
            associatedApplicationId, associatedApplicationPositionTitle, associatedApplicationEmployerName,
            payType, pay, hasBonus, bonusDescription, benefits, offeredEquity, equityPercentage,
            companyValuation, startDate, decision, decisionReason, orgCode, logType: 'Offer',
            createdAt: new Date(), updatedAt: new Date() })
          .then((response) => {
            console.log('testing ')
            if (response.data.success) {
              //save values
              console.log('Offer save worked', response.data);

              let offerAssociatedApplication = this.state.offerAssociatedApplication

              if (!this.state.editExisting) {
                offerAssociatedApplication = { name: 'Attach a Saved Application'}
                payType = ''
                pay = ''
                hasBonus = ''
                bonusDescription = ''
                benefits = ''
                offeredEquity = ''
                equityPercentage = ''
                companyValuation = ''
                startDate = ''
                decision = ''
                decisionReason = ''

              }

              this.setState({
                offerAssociatedApplication,
                offerPayType: payType, offerPay: pay, hasBonus, bonusDescription,
                offerBenefits: benefits, offeredEquity, equityPercentage, companyValuation,
                offerStartDate: startDate, offerDecision: decision, decisionReason,

                isSaving: false, serverPostSuccess: true,
                serverSuccessMessage: 'Offer saved successfully!'
              })
            } else {
              console.error('there was an error saving the interview', response.data.message);
              this.setState({
                isSaving: false, serverPostSuccess: false,
                serverErrorMessage: response.data.message,
              })
            }
          }).catch((error) => {
              console.log('Offer save did not work', error);
              this.setState({
                sisSaving: false, erverPostSuccess: false,
                serverErrorMessage: error.toString(),
              })
          });
        }
      } else if (this.state.logType === 'Passion') {

        if (this.state.passionTitle === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please name your passion' })
        } else if (this.state.passionReason === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add a reason for your passion' })
        } else {

          const passionId = this.state.passionId
          const creatorEmail = this.state.emailId
          const creatorFirstName = this.state.cuFirstName
          const creatorLastName = this.state.cuLastName
          const creatorUsername = this.state.username
          const creatorPictureURL = this.state.pictureURL

          let passionTitle = this.state.passionTitle
          let passionReason = this.state.passionReason

          let orgCode = ''
          if (this.state.activeOrg) {
            orgCode = this.state.activeOrg
          }

          //save passion
          Axios.post('/api/logs/passions', {
            _id: passionId, creatorEmail, creatorFirstName, creatorLastName, creatorUsername, creatorPictureURL,
            logType: 'Passion',
            passionTitle, passionReason, orgCode,
            createdAt: new Date(), updatedAt: new Date() })
          .then((response) => {

            if (response.data.success) {
              //save values
              console.log('Passion save worked', response.data);

              if (!this.state.editExisting) {
                passionTitle = ''
                passionReason = ''
              }

              this.setState({
                passionTitle, passionReason,

                isSaving: false, serverPostSuccess: true,
                serverSuccessMessage: 'Passion saved successfully!'
              })
            } else {
              console.error('there was an error saving the interview', response.data.message);
              this.setState({
                isSaving: false, serverPostSuccess: false,
                serverErrorMessage: response.data.message,
              })
            }
          }).catch((error) => {
              console.log('Passion save did not work', error);
              this.setState({
                isSaving: false, serverPostSuccess: false,
                serverErrorMessage: error.toString(),
              })
          });
        }
      } else if (this.state.logType === 'Notes') {

        if (this.state.generalNotes === '') {
          this.setState({ isSaving: false, clientErrorMessage: 'please add some notes' })
        } else {

          const notesId = this.state.notesId
          const creatorEmail = this.state.emailId
          const creatorFirstName = this.state.cuFirstName
          const creatorLastName = this.state.cuLastName
          const creatorUsername = this.state.username
          const creatorPictureURL = this.state.pictureURL

          let generalNotes = this.state.generalNotes

          let orgCode = ''
          if (this.state.activeOrg) {
            orgCode = this.state.activeOrg
          }

          const logType = 'Notes'
          const createdAt = new Date()
          const updatedAt = new Date()

          //save notes
          Axios.post('/api/logs/notes', {
            _id: notesId, creatorEmail, creatorFirstName, creatorLastName, creatorUsername, creatorPictureURL,
            logType, generalNotes, orgCode, createdAt, updatedAt })
          .then((response) => {

            if (response.data.success) {
              //save values
              console.log('Note entry save worked', response.data);

              if (!this.state.editExisting) {
                generalNotes = ''
              }

              this.setState({ generalNotes, isSaving: false, serverPostSuccess: true,
                serverSuccessMessage: 'Note entry saved successfully!'
              })
            } else {
              console.error('there was an error saving the notes', response.data.message);
              this.setState({
                isSaving: false, serverPostSuccess: false,
                serverErrorMessage: response.data.message,
              })
            }
          }).catch((error) => {
              console.log('Notes save did not work', error);
              this.setState({
                isSaving: false, serverPostSuccess: false,
                serverErrorMessage: error.toString(),
              })
          });
        }
      }
    }

    deleteLog() {
      console.log('deleteLog called')

      const _id = this.state.log._id

      Axios.delete('/api/logs/' + _id)
      .then((response) => {
        console.log('tried to delete', response.data)
        if (response.data.success) {
          //save values
          console.log('Log delete worked');

          if (window.location.pathname.includes(this.state.prefix + '/walkthrough')) {
            this.closeModal()
            this.props.reloadScreen()
          } else {
            if (window.location.pathname.startsWith('/organizations')) {
              this.props.navigate(this.state.prefix + '/sessions')
            } else {
              this.props.navigate(this.state.prefix + '/logs')
            }
          }
          // this.setState({
          //   serverPostSuccess: true,
          //   serverSuccessMessage: 'Log was successfully deleted', confirmDelete: false
          // })

        } else {
          console.error('there was an error deleting the log');
          this.setState({
            serverPostSuccess: false,
            serverErrorMessage: response.data.message,
          })
        }
      }).catch((error) => {
          console.log('The deleting did not work', error);
          this.setState({
            serverPostSuccess: false,
            serverErrorMessage: error,
          })
      });
    }

    renderItems(type) {
      console.log('renderItems called', type)

      let rows = []

      let items = []
      let placeholder = "Add a question..."

      if (type === 'Asked') {
        items = this.state.questionsAsked
      } else if (type === 'Answered') {
        items = this.state.questionsAnswered
      }

      for (let i = 1; i <= items.length; i++) {

        const index = i - 1
        const nameField = "item|" + type + "|" + index

        rows.push(
          <div key={i}>
            <div className="spacer"/>
            <div className="relative-column-90">

              <input className="text-field" type="text" placeholder={placeholder} name={nameField} value={items[index]} onChange={this.formChangeHandler} />
            </div>
            <div className="relative-column-10 left-padding top-padding-5">
              <button className="background-button float-left" onClick={() => this.addRemoveItems('Remove',index,type)}>
                <img src={exitIcon} alt="Compass exit icon" className="image-auto-30"/>
              </button>
            </div>
            <div className="clear" />
          </div>
        )
      }

      return rows
    }

    toggleEditMode(index) {
      console.log('toggleEditMode called', index)

      let editModes = this.state.editModes
      if (editModes[index]) {
        editModes[index] = false
      } else {
        editModes[index] = true
      }

      this.setState({ editModes })
    }

    addRemoveItems(action, index, type, index2) {
      console.log('addRemoveItems called')

      if (type === 'Asked') {
        let questionsAsked = this.state.questionsAsked
        if (action === 'Add') {
          questionsAsked.push("")
        } else {
          if (index > -1) {
            questionsAsked.splice(index, 1);
          }
        }

        this.setState({ questionsAsked })

      } else if (type === 'Answered') {

        let questionsAnswered = this.state.questionsAnswered
        if (action === 'Add') {
          questionsAnswered.push("")
        } else {
          if (index > -1) {
            questionsAnswered.splice(index, 1);
          }
        }

        this.setState({ questionsAnswered })
      } else if (type === 'task') {
        if (action === 'Remove') {
          let tasks = this.state.tasks
          tasks.splice(index, 1)
          this.setState({ tasks })
        }
      } else if (type === 'link') {
        let links = this.state.links
        links.splice(index,1)
        this.setState({ links })
      } else if (type === 'aLink') {
        let aLinks = this.state.aLinks
        aLinks.splice(index,1)
        this.setState({ aLinks })
      } else if (type === 'bLink') {
        let bLinks = this.state.bLinks
        bLinks.splice(index,1)
        this.setState({ bLinks })
      } else if (type === 'actionItem') {
        let actionItems = this.state.actionItems
        actionItems.splice(index,1)
        this.setState({ actionItems })
      } else if (type === 'checklist') {
        let checklist = this.state.checklist
        checklist.splice(index,1)
        this.setState({ checklist })
      } else if (type === 'progress') {
        let progress = this.state.progress
        progress.splice(index,1)
        this.setState({ progress })
      } else if (type === 'strategy') {
        let strategies = this.state.strategies
        strategies.splice(index,1)
        this.setState({ strategies })
      } else if (type === 'tactic') {
        let strategies = this.state.strategies
        let tactics = this.state.strategies[index].tactics
        tactics.splice(index2,1)
        strategies[index]['tactics'] = tactics
        this.setState({ strategies })
      }
    }

    searchItemClicked(passedItem, type) {
      console.log('searchItemClicked called', passedItem, type)

      if (type.includes('pathway')) {
        let searchObject = passedItem
        let searchString = passedItem.title
        let pathwayOptions = null

        this.setState({ searchObject, searchString, pathwayOptions })
      } else if (type.includes('career')) {

        let searchObject = null
        let searchString = null
        let careerOptions = null
        let searchObjectA = null
        let searchStringA = null
        let careerOptionsA = null
        let searchObjectB = null
        let searchStringB = null
        let careerOptionsB = null
        if (type === 'career') {
          searchObject = passedItem
          searchString = passedItem.name
          careerOptions = null
        } else if (type === 'careerA') {
          searchObjectA = passedItem
          searchStringA = passedItem.name
          careerOptionsA = null
        } else if (type === 'careerB') {
          searchObjectB = passedItem
          searchStringB = passedItem.name
          careerOptionsB = null
        }

        this.setState({ searchObject, searchString, careerOptions, searchObjectA, searchStringA, careerOptionsA,
          searchObjectB, searchStringB, careerOptionsB
        })

      } else if (type.includes('opportunity')) {
        let searchObject = null
        let searchStringOpportunities = null
        let opportunityOptions = null
        let searchObjectA = null
        let searchStringOpportunitiesA = null
        let opportunityOptionsA = null
        let searchObjectB = null
        let searchStringOpportunitiesB = null
        let opportunityOptionsB = null
        if (type === 'opportunity') {
          searchObject = passedItem
          searchStringOpportunities = passedItem.name
          if (passedItem.title) {
            searchStringOpportunities = passedItem.title
          }
          opportunityOptions = null
        } else if (type === 'opportunityA') {
          searchObjectA = passedItem
          searchStringOpportunitiesA = passedItem.name
          if (passedItem.title) {
            searchStringOpportunitiesA = passedItem.title
          }
          opportunityOptionsA = null
        } else if (type === 'opportunityB') {
          searchObjectB = passedItem
          searchStringOpportunitiesB = passedItem.name
          if (passedItem.title) {
            searchStringOpportunitiesB = passedItem.title
          }
          opportunityOptionsB = null
        }

        this.setState({ searchObject, searchStringOpportunities, opportunityOptions,
          searchObjectA, searchStringOpportunitiesA, opportunityOptionsA,
          searchObjectB, searchStringOpportunitiesB, opportunityOptionsB,
        })
      } else if (type.includes('competency')) {
        let searchObject = null
        let searchStringCompetencies = null
        let competencyOptions = null
        let searchObjectA = null
        let searchStringCompetenciesA = null
        let competencyOptionsA = null
        let searchObjectB = null
        let searchStringCompetenciesB = null
        let competencyOptionsB = null
        if (type === 'competency') {
          searchObject = passedItem
          searchStringCompetencies = passedItem.name
          competencyOptions = null
        } else if (type === 'competencyA') {
          searchObjectA = passedItem
          searchStringCompetenciesA = passedItem.name
          competencyOptionsA = null
        } else if (type === 'competencyB') {
          searchObjectB = passedItem
          searchStringCompetenciesB = passedItem.name
          competencyOptionsB = null
        }

        this.setState({
          searchObject, searchStringCompetencies, competencyOptions,
          searchObjectA, searchStringCompetenciesA, competencyOptionsA,
          searchObjectB, searchStringCompetenciesB, competencyOptionsB,
        })
      } else if (type === 'member') {
        const searchObject = passedItem
        let searchStringMembers = passedItem.firstName + ' ' + passedItem.lastName

        const memberOptions = null

        this.setState({ searchObject, searchStringMembers, memberOptions })

      } else if (type === 'advisee') {

        const searchObject = passedItem
        let searchStringAdvisees = passedItem.firstName + ' ' + passedItem.lastName

        const adviseeOptions = null

        this.setState({ searchObject, searchStringAdvisees, adviseeOptions })

      }
    }

    renderTags(type) {
      console.log('renderTags ', type, this.state.competencies)

      if (type.includes('career')) {
        if (type === 'career') {
          const selectedCareers = this.state.selectedCareers
          if (selectedCareers && selectedCareers.length > 0) {

            return (
              <div key={"selectedCareers"}>
                <div className="spacer" />
                {selectedCareers.map((value, optionIndex) =>
                  <div key={"career|" + optionIndex} className="float-left">

                    <div className="close-button-container-1" >
                      <button className="background-button" onClick={() => this.removeTag(optionIndex,type)}>
                        <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                      </button>
                    </div>

                    <div className="float-left right-padding-5">
                      <div className="half-spacer" />
                      <div className="tag-container-inactive">
                        <p className="description-text-2">{value}</p>
                      </div>
                      <div className="half-spacer" />
                    </div>

                  </div>
                )}
              </div>
            )
          }
        } else {
          let item = null
          if (type === 'careerA') {
            item = this.state.aItem
          } else if (type === 'careerB') {
            item = this.state.bItem
          }

          if (item) {
            return (
              <div key={"selectedCareer"}>
                <div className="spacer" />
                <div key={"career"} className="float-left">

                  <div className="close-button-container-1" >
                    <button className="background-button" onClick={() => this.removeTag(null,type)}>
                      <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                    </button>
                  </div>

                  <div className="float-left right-padding-5">
                    <div className="half-spacer" />
                    <div className="tag-container-inactive">
                      <p className="description-text-2">{(item.name) ? item.name : item.title}</p>
                    </div>
                    <div className="half-spacer" />
                  </div>

                </div>
                <div className="clear" />
              </div>
            )
          }
        }

      } else if (type.includes('opportunity')) {
        if (type === 'opportunity') {
          const selectedOpportunities = this.state.selectedOpportunities
          if (selectedOpportunities && selectedOpportunities.length > 0) {
            console.log('about to in', selectedOpportunities)
            return (
              <div key={"selectedOpportunities"}>
                <div className="spacer" />
                {selectedOpportunities.map((value, optionIndex) =>
                  <div key={"career|" + optionIndex} className="float-left">

                    <div className="close-button-container-1" >
                      <button className="background-button" onClick={() => this.removeTag(optionIndex,type)}>
                        <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                      </button>
                    </div>
                    <div className="float-left right-padding-5">
                      <div className="half-spacer" />
                      <div className="tag-container-inactive">
                        <p className="description-text-2">{value}</p>
                      </div>
                      <div className="half-spacer" />
                    </div>

                  </div>
                )}
              </div>
            )
          }
        } else {
          let item = null
          if (type === 'opportunityA') {
            item = this.state.aItem
          } else if (type === 'opportunityB') {
            item = this.state.bItem
          }

          if (item) {
            return (
              <div key={"selectedOpportunity"}>
                <div className="spacer" />
                <div key={"career"} className="float-left">

                  <div className="close-button-container-1" >
                    <button className="background-button" onClick={() => this.removeTag(null,type)}>
                      <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                    </button>
                  </div>

                  <div className="float-left right-padding-5">
                    <div className="half-spacer" />
                    <div className="tag-container-inactive">
                      <p className="description-text-2">{(item.name) ? item.name : item.title}</p>
                    </div>
                    <div className="half-spacer" />
                  </div>

                </div>
                <div className="clear" />
              </div>
            )
          }
        }

      } else if (type === 'learningObjective') {
        // console.log('in learningObjective', this.state.learningObjectives)
        // abilities, knowledge, , soft skill, hard skil, tech skill
        const competencies = this.state.competencies

        if (competencies && competencies.length > 0) {
          console.log('compare 0')
          return (
            <div key={"competency"}>
              <div className="spacer" />
              {competencies.map((value, optionIndex) =>
                <div key={"career|" + optionIndex} className="float-left">
                  {(value) && (
                    <div>
                      <div className="close-button-container-1" >
                        <button className="background-button" onClick={() => this.removeTag(optionIndex,type)}>
                          <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                        </button>
                      </div>
                      <div>
                        <div className="half-spacer" />
                        {(value.category === 'Ability') && (
                          <div className="tag-container-8 primary-background primary-border white-text">
                            <p className="description-text-2">{value.category}: {value.name}{(value.description) && " (" + value.description + ")"}</p>
                          </div>
                        )}
                        {(value.category === 'Knowledge') && (
                          <div className="tag-container-8 secondary-background secondary-border white-text">
                            <p className="description-text-2">{value.category}: {value.name}{(value.description) && " (" + value.description + ")"}</p>
                          </div>
                        )}
                        {(value.category === 'Soft Skill') && (
                          <div className="tag-container-8 tertiary-background tertiary-border white-text">
                            <p className="description-text-2">{value.category}: {value.name}{(value.description) && " (" + value.description + ")"}</p>
                          </div>
                        )}
                        {(value.category === 'General Hard Skill') && (
                          <div className="tag-container-8 quaternary-background quaternary-border white-text">
                            <p className="description-text-2">{value.category}: {value.name}{(value.description) && " (" + value.description + ")"}</p>
                          </div>
                        )}
                        {(value.category === 'Tech Skill') && (
                          <div className="tag-container-8 quinary-background quinary-border white-text">
                            <p className="description-text-2">{value.category}: {value.name}{(value.description) && " (" + value.description + ")"}</p>
                          </div>
                        )}

                        <div className="half-spacer" />
                      </div>
                    </div>
                  )}

                </div>
              )}
            </div>
          )

        }
      } else if (type.includes('skill')) {
        if (type === 'skill') {
          const selectedSkills = this.state.selectedSkills
          if (selectedSkills && selectedSkills.length > 0) {

            return (
              <div key={"selectedSkills"}>
                <div className="spacer" />
                {selectedSkills.map((value, optionIndex) =>
                  <div key={"career|" + optionIndex} className="float-left">

                    <div className="close-button-container-1" >
                      <button className="background-button" onClick={() => this.removeTag(optionIndex,type)}>
                        <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                      </button>
                    </div>
                    <div className="float-left right-padding-5">
                      <div className="half-spacer" />
                      <div className="tag-container-inactive">
                        <p className="description-text-2">{value}</p>
                      </div>
                      <div className="half-spacer" />
                    </div>

                  </div>
                )}
              </div>
            )
          }
        } else {
          let item = null
          if (type === 'skillA') {
            item = this.state.aItem
          } else if (type === 'skillB') {
            item = this.state.bItem
          }
          // console.log('show item: ', item, type)
          if (item) {
            return (
              <div key={"selectedSkill"}>
                <div className="spacer" />
                <div key={"career"} className="float-left">

                  <div className="close-button-container-1" >
                    <button className="background-button" onClick={() => this.removeTag(null,type)}>
                      <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                    </button>
                  </div>

                  <div className="float-left right-padding-5">
                    <div className="half-spacer" />
                    <div className="tag-container-inactive">
                      <p className="description-text-2">{(item.name) ? item.name : item.title}</p>
                    </div>
                    <div className="half-spacer" />
                  </div>

                </div>
                <div className="clear" />
              </div>
            )
          }
        }

      } else if (type === 'member' || type === 'advisee') {
        let items = []
        if (type === 'member') {
          items = this.state.selectedMembers
        } else if (type === 'advisee') {
          items = this.state.selectedAdvisees
        }

        if (items && items.length > 0) {
          // console.log('show selectedMembers: ', selectedMembers)
          return (
            <div key={"selectedMembers"}>
              <div className="spacer" />
              {items.map((value, optionIndex) =>
                <div key={"career|" + optionIndex} className="float-left">

                  <div className="close-button-container-1" >
                    <button className="background-button" onClick={() => this.removeTag(optionIndex,type)}>
                      <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                    </button>
                  </div>
                  <div className="float-left right-padding-5">
                    <div className="half-spacer" />
                    <div className="tag-container-inactive">
                      <p className="description-text-2">{value}</p>
                    </div>
                    <div className="half-spacer" />
                  </div>

                </div>
              )}
            </div>
          )
        }
      } else if (type === 'all') {
        let tags = this.state.tags
        if (tags && tags.length > 0) {
          console.log('about to in all tags: ', tags)
          return (
            <div key={type}>
              <div className="spacer" />
              {tags.map((value, optionIndex) =>
                <div key={type + "|" + optionIndex} className="float-left">
                  <div className="close-button-container-1" >
                    <button className="background-button" onClick={() => this.removeTag(optionIndex,type)}>
                      <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                    </button>
                  </div>
                  {console.log('show value: ', value)}
                  {(value.name === 'competency' || value.name === 'skill') && (
                    <div>
                      <div className="half-spacer" />
                      {(value.value.category === 'Ability' || value.value.category === 'Communicating effectively in writing as appropriate for the needs of the audience.') && (
                        <div className="tag-container-8 primary-background primary-border white-text">
                          <p className="description-text-2">{value.value.category}: {value.value.name}{(value.value.description) && " (" + value.value.description + ")"}</p>
                        </div>
                      )}
                      {(value.value.category === 'Knowledge') && (
                        <div className="tag-container-8 secondary-background secondary-border white-text">
                          <p className="description-text-2">{value.value.category}: {value.value.name}{(value.value.description) && " (" + value.value.description + ")"}</p>
                        </div>
                      )}
                      {(value.value.category === 'Soft Skill') && (
                        <div className="tag-container-8 tertiary-background tertiary-border white-text">
                          <p className="description-text-2">{value.value.category}: {value.value.name}{(value.value.description) && " (" + value.value.description + ")"}</p>
                        </div>
                      )}
                      {(value.value.category === 'General Hard Skill') && (
                        <div className="tag-container-8 quaternary-background quaternary-border white-text">
                          <p className="description-text-2">{value.value.category}: {value.value.name}{(value.value.description) && " (" + value.value.description + ")"}</p>
                        </div>
                      )}
                      {(value.value.category === 'Tech Skill' || value.value.category === 'Tools Used') && (
                        <div className="tag-container-8 quinary-background quinary-border white-text">
                          <p className="description-text-2">{value.value.category}: {value.name}{(value.value.description) && " (" + value.value.description + ")"}</p>
                        </div>
                      )}

                      <div className="half-spacer" />
                    </div>
                  )}
                  {(value.name === 'pathway' || value.name === 'career' || value.name === 'opportunity') && (
                    <div className="float-left right-padding-5">
                      <div className="half-spacer" />
                      <div className="tag-container-inactive">
                        <p className="description-text-2">{(value.value.title) ? value.value.title : value.value.name}{(value.value.employerName) && " | " + value.value.employerName}</p>
                      </div>
                      <div className="half-spacer" />
                    </div>
                  )}
                  {(value.name === 'member') && (
                    <div className="float-left right-padding-5">
                      <div className="half-spacer" />
                      <div className="tag-container-inactive">
                        <p className="description-text-2">{(value.value) ? value.value.firstName : value.firstName} {(value.value.lastName) ? value.value.lastName : value.lastName}</p>
                      </div>
                      <div className="half-spacer" />
                    </div>
                  )}
                  {(value.name === 'optimize' || value.name === 'function' || value.name === 'industry' || value.name === 'hoursPerWeek' || value.name === 'payRange') && (
                    <div className="float-left right-padding-5">
                      <div className="half-spacer" />
                      <div className="tag-container-inactive">
                        <p className="description-text-2">{value.value}</p>
                      </div>
                      <div className="half-spacer" />
                    </div>
                  )}
                </div>
              )}
              <div className="clear" />
            </div>
          )
        }
      } else {

        let tags = []
        if (type === 'function') {
          tags = this.state.selectedFunctions
        } else if (type === 'industry') {
          tags = this.state.selectedIndustries
        } else if (type === 'hoursPerWeek') {
          tags = this.state.selectedHours
        } else if (type === 'payRange') {
          tags = this.state.selectedPayRanges
        } else if (type === 'optimize') {
          tags = this.state.selectedOptimizeOptions
        } else if (type === 'school') {
          tags = this.state.selectedSchools
        } else if (type === 'major') {
          tags = this.state.selectedMajors
        }

        if (tags && tags.length > 0) {
          console.log('about to in', tags)
          return (
            <div key={type}>
              <div className="spacer" />
              {tags.map((value, optionIndex) =>
                <div key={type + "|" + optionIndex} className="float-left">
                  <div className="close-button-container-1" >
                    <button className="background-button" onClick={() => this.removeTag(optionIndex,type)}>
                      <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                    </button>
                  </div>
                  <div className="float-left right-padding-5">
                    <div className="half-spacer" />
                    <div className="tag-container-inactive">
                      <p className="description-text-2">{value}</p>
                    </div>
                    <div className="half-spacer" />
                  </div>

                </div>
              )}
            </div>
          )
        }
      }
    }

    removeTag(index, type) {
      console.log('removeTag called', index, type)

      if (type.includes('career')) {
        if (type === 'career') {
          let selectedCareers = this.state.selectedCareers
          selectedCareers.splice(index, 1)

          let selectedCareerDetails = this.state.selectedCareerDetails
          const careerToRemove = selectedCareerDetails[index]
          selectedCareerDetails.splice(index, 1)
          this.setState({ selectedCareers, selectedCareerDetails })
          this.adjustCoreCompetencies(careerToRemove,type, null, false)
        } else if (type === 'careerA') {
          this.setState({ aItem: null })
        } else if (type === 'careerB') {
          this.setState({ bItem: null })
        }
      } else if (type.includes('opportunity')) {
        if (type === 'opportunity') {
          let selectedOpportunities = this.state.selectedOpportunities
          selectedOpportunities.splice(index, 1)

          let selectedOpportunityDetails = this.state.selectedOpportunityDetails
          const opportunityToRemove = selectedOpportunityDetails[index]
          selectedOpportunityDetails.splice(index, 1)
          this.setState({ selectedOpportunities, selectedOpportunityDetails })
          this.adjustCoreCompetencies(opportunityToRemove,type, null, false)
        } else if (type === 'opportunityA') {
          this.setState({ aItem: null })
        } else if (type === 'opportunityB') {
          this.setState({ bItem: null })
        }
      } else if (type === 'function') {
        let selectedFunctions = this.state.selectedFunctions
        selectedFunctions.splice(index, 1)
        this.setState({ selectedFunctions })
      } else if (type === 'industry') {
        let selectedIndustries = this.state.selectedIndustries
        selectedIndustries.splice(index, 1)
        this.setState({ selectedIndustries })
      } else if (type === 'hoursPerWeek') {
        let selectedHours = this.state.selectedHours
        selectedHours.splice(index, 1)
        this.setState({ selectedHours })
      } else if (type === 'payRange') {
        let selectedPayRanges = this.state.selectedPayRanges
        selectedPayRanges.splice(index, 1)
        this.setState({ selectedPayRanges })
      } else if (type === 'optimize') {
        let selectedOptimizeOptions = this.state.selectedOptimizeOptions
        selectedOptimizeOptions.splice(index, 1)
        this.setState({ selectedOptimizeOptions })

      } else if (type === 'learningObjective') {
        let competencies = this.state.competencies
        competencies.splice(index, 1)
        this.setState({ competencies })
      } else if (type === 'member') {
        let selectedMembers = this.state.selectedMembers
        selectedMembers.splice(index, 1)

        let selectedMemberDetails = this.state.selectedMemberDetails
        // const memberToRemove = selectedMemberDetails[index]
        selectedMemberDetails.splice(index, 1)
        this.setState({ selectedMembers, selectedMemberDetails })
      } else if (type === 'advisee') {
        let selectedAdvisees = this.state.selectedAdvisees
        selectedAdvisees.splice(index, 1)

        let selectedAdviseeDetails = this.state.selectedAdviseeDetails
        // const memberToRemove = selectedMemberDetails[index]
        selectedAdviseeDetails.splice(index, 1)
        this.setState({ selectedAdvisees, selectedAdviseeDetails })
      } else if (type.includes('skill')) {
        if (type === 'skill') {
          let selectedSkills = this.state.selectedSkills
          selectedSkills.splice(index, 1)
          this.setState({ selectedSkills })
        } else if (type === 'skillA') {
          this.setState({ aItem: null })
        } else if (type === 'skillB') {
          this.setState({ bItem: null })
        }
      } else if (type === 'school') {
        let selectedSchools = this.state.selectedSchools
        selectedSchools.splice(index, 1)
        this.setState({ selectedSchools })
      } else if (type === 'major') {
        let selectedMajors = this.state.selectedMajors
        selectedMajors.splice(index, 1)
        this.setState({ selectedMajors })
      } else if (type === 'all') {
        let tags = this.state.tags
        tags.splice(index, 1)
        this.setState({ tags })
      }
    }

    addItem(type, index) {
      console.log('addItem called', type)

      if (type.includes('pathway')) {
        if (this.state.selectedPathways.includes(this.state.searchString)) {
          this.setState({ errorMessage: 'You have already added this career pathway' })
        } else {

          if (!this.state.searchObject) {
            return this.setState({ errorMessage: 'Please select a career pathway from search suggestions' })
          }

          const searchString = ''
          const searchObject = null

          let selectedPathways = this.state.selectedPathways
          selectedPathways.unshift(this.state.searchString)

          let selectedPathwayDetails = this.state.selectedPathwayDetails
          selectedPathwayDetails.unshift(this.state.searchObject)

          let tags = this.state.tags
          tags.unshift({ name: type, value: this.state.searchObject })

          this.setState({ searchString, searchObject, selectedPathways, selectedPathwayDetails, tags, errorMessage: null, pathwayOptions: [] })
          this.adjustCoreCompetencies(this.state.searchObject,type, null, true)
        }
      } else if (type.includes('career')) {
        if (this.state.selectedCareers.includes(this.state.searchString)) {
          this.setState({ errorMessage: 'You have already added this career' })
        } else {

          if (type === 'career') {
            if (!this.state.searchObject) {
              return this.setState({ errorMessage: 'Please select a career from search suggestions' })
            }

            const searchString = ''
            const searchObject = null

            let selectedCareers = this.state.selectedCareers
            selectedCareers.unshift(this.state.searchString)

            let selectedCareerDetails = this.state.selectedCareerDetails
            selectedCareerDetails.unshift(this.state.searchObject)

            let tags = this.state.tags
            tags.unshift({ name: type, value: this.state.searchObject })

            // const selectedCareer = this.state.searchString

            this.setState({ searchString, searchObject, selectedCareers, selectedCareerDetails, tags, errorMessage: null, careerOptions: [] })
            this.adjustCoreCompetencies(this.state.searchObject,type, null, true)
          } else if (type === 'careerA') {
            if (!this.state.searchObjectA) {
              return this.setState({ errorMessage: 'Please select a career from search suggestions' })
            }

            const searchStringA = ''
            const searchObjectA = null
            const aItem = this.state.searchObjectA

            this.setState({ searchStringA, searchObjectA, aItem, errorMessageA: null, careerOptionsA: [] })
          } else if (type === 'careerB') {
            if (!this.state.searchObjectB) {
              return this.setState({ errorMessage: 'Please select a career from search suggestions' })
            }

            const searchStringB = ''
            const searchObjectB = null
            const bItem = this.state.searchObjectB

            this.setState({ searchStringB, searchObjectB, bItem, errorMessageB: null, careerOptionsB: [] })
          }
        }
      } else if (type.includes('opportunity')) {
        if (this.state.selectedOpportunities.includes(this.state.searchStringOpportunities)) {
          this.setState({ errorMessage: 'You have already added this opportunity' })
        } else {

          if (type === 'opportunity') {

            if (!this.state.searchObject) {
              return this.setState({ errorMessage: 'Please select an opportunity from search suggestions' })
            }

            const searchStringOpportunities = ''
            const searchObject = null

            let selectedOpportunities = this.state.selectedOpportunities
            selectedOpportunities.unshift(this.state.searchStringOpportunities)

            let selectedOpportunityDetails = this.state.selectedOpportunityDetails
            selectedOpportunityDetails.unshift(this.state.searchObject)

            let tags = this.state.tags
            tags.unshift({ name: type, value: this.state.searchObject })

            this.setState({ searchStringOpportunities, searchObject, selectedOpportunities,
              selectedOpportunityDetails, tags, errorMessage: null, opportunityOptions: []
            })

            this.adjustCoreCompetencies(this.state.searchObject,type, null, true)
          } else if (type === 'opportunityA') {
            if (!this.state.searchObjectA) {
              return this.setState({ errorMessage: 'Please select an opportunity from search suggestions' })
            }

            const searchStringOpportunitiesA = ''
            const searchObjectA = null
            const aItem = this.state.searchObjectA

            this.setState({ searchStringOpportunitiesA, searchObjectA, aItem, errorMessageA: null, opportunityOptionsA: [] })
          } else if (type === 'opportunityB') {
            if (!this.state.searchObjectB) {
              return this.setState({ errorMessage: 'Please select an opportunity from search suggestions' })
            }

            const searchStringOpportunitiesB = ''
            const searchObjectB = null
            const bItem = this.state.searchObjectB

            this.setState({ searchStringOpportunitiesB, searchObjectB, bItem, errorMessageB: null, opportunityOptionsB: [] })
          }

        }
      } else if (type === 'function') {

        if (this.state.selectedFunctions.includes(this.state.selectedFunction)) {
          this.setState({ errorMessage: 'You have already added this' })
        } else {

          const selectedFunction = ''

          let selectedFunctions = this.state.selectedFunctions
          selectedFunctions.unshift(this.state.selectedFunction)

          let tags = this.state.tags
          tags.unshift({ name: type, value: this.state.selectedFunction })

          this.setState({ selectedFunction, selectedFunctions, tags, errorMessage: null })

        }
      } else if (type === 'industry') {

        if (this.state.selectedIndustries.includes(this.state.selectedIndustry)) {
          this.setState({ errorMessage: 'You have already added this' })
        } else {

          const selectedIndustry = ''

          let selectedIndustries = this.state.selectedIndustries
          selectedIndustries.unshift(this.state.selectedIndustry)

          let tags = this.state.tags
          tags.unshift({ name: type, value: this.state.selectedIndustry })

          this.setState({ selectedIndustry, selectedIndustries, tags, errorMessage: null })

        }
      } else if (type === 'hoursPerWeek') {

        if (this.state.selectedHours.includes(this.state.selectedHoursPerWeek)) {
          this.setState({ errorMessage: 'You have already added this' })
        } else {

          const selectedHoursPerWeek = ''

          let selectedHours = this.state.selectedHours
          selectedHours.unshift(this.state.selectedHoursPerWeek)

          let tags = this.state.tags
          tags.unshift({ name: type, value: this.state.selectedHoursPerWeek })

          this.setState({ selectedHoursPerWeek, selectedHours, tags, errorMessage: null })

        }
      } else if (type === 'payRange') {

        if (this.state.selectedPayRanges.includes(this.state.selectedPayRange)) {
          this.setState({ errorMessage: 'You have already added this' })
        } else {

          const selectedPayRange = ''

          let selectedPayRanges = this.state.selectedPayRanges
          selectedPayRanges.unshift(this.state.selectedPayRange)

          let tags = this.state.tags
          tags.unshift({ name: type, value: this.state.selectedPayRange })

          this.setState({ selectedPayRange, selectedPayRanges, tags, errorMessage: null, hourlyPayOptions: []  })
        }
      } else if (type === 'optimize') {

        if (this.state.selectedOptimizeOptions.includes(this.state.selectedOptimize)) {
          this.setState({ errorMessage: 'You have already added this' })
        } else {

          const selectedOptimize = ''

          let selectedOptimizeOptions = this.state.selectedOptimizeOptions
          selectedOptimizeOptions.unshift(this.state.selectedOptimize)

          let tags = this.state.tags
          tags.unshift({ name: type, value: this.state.selectedOptimize })

          this.setState({ selectedOptimize, selectedOptimizeOptions, tags, errorMessage: null, optimizeOptions: [] })

        }
      } else if (type.includes('skill')) {
        if (this.state.selectedSkills.includes(this.state.searchStringCompetencies)) {
          this.setState({ errorMessage: 'You have already added this competency' })
        } else {

          if (type === 'skill') {
            if (!this.state.searchObject) {
              return this.setState({ errorMessage: 'Please select a skill from search suggestions' })
            }

            const searchStringCompetencies = ''
            const searchObject = null

            let competencies = this.state.competencies

            let category = this.state.searchObject.type
            if (this.state.searchObject.type === 'General Skill') {
              category = 'General Hard Skill'
            } else if (this.state.searchObject.type === 'Work Style') {
              category = 'Soft Skill'
            }

            const tempObject = {
              category,
              name: this.state.searchObject.name,
              description: this.state.searchObject.description,
            }

            competencies.unshift(tempObject)

            let tags = this.state.tags
            tags.unshift({ name: type, value: tempObject })

            this.setState({ searchStringCompetencies, searchObject, competencies, tags, errorMessage: null, competencyOptions: null })
          } else if (type === 'skillA') {
            if (!this.state.searchObjectA) {
              return this.setState({ errorMessage: 'Please select a skill from search suggestions' })
            }

            const searchStringCompetenciesA = ''
            const searchObjectA = null


            let category = this.state.searchObjectA.type
            if (this.state.searchObjectA.type === 'General Skill') {
              category = 'General Hard Skill'
            } else if (this.state.searchObjectA.type === 'Work Style') {
              category = 'Soft Skill'
            }

            const aItem = {
              category,
              name: this.state.searchObjectA.name,
              description: this.state.searchObjectA.description,

            }

            this.setState({ searchStringCompetenciesA, searchObjectA, aItem, errorMessageA: null, competencyOptionsA: null })

          } else if (type === 'skillB') {
            if (!this.state.searchObjectB) {
              return this.setState({ errorMessage: 'Please select a skill from search suggestions' })
            }

            const searchStringCompetenciesB = ''
            const searchObjectB = null


            let category = this.state.searchObjectB.type
            if (this.state.searchObjectB.type === 'General Skill') {
              category = 'General Hard Skill'
            } else if (this.state.searchObjectB.type === 'Work Style') {
              category = 'Soft Skill'
            }

            const bItem = {
              category,
              name: this.state.searchObjectB.name,
              description: this.state.searchObjectB.description,
            }
            // console.log('show bItem: ', bItem)
            this.setState({ searchStringCompetenciesB, searchObjectB, bItem, errorMessageB: null, competencyOptionsB: null })
          }
        }
      } else if (type === 'member' || type === 'advisor') {
        if (this.state.selectedMembers.includes(this.state.searchStringMembers)) {
          this.setState({ errorMessage: 'You have already added this member' })
        } else if (!this.state.searchObject) {
          this.setState({ errorMessage: 'Please select a member from search suggestions' })
        } else {

          const searchStringMembers = ''
          const searchObject = null

          let selectedMembers = this.state.selectedMembers
          selectedMembers.unshift(this.state.searchStringMembers)

          let selectedMemberDetails = this.state.selectedMemberDetails
          selectedMemberDetails.unshift(this.state.searchObject)

          if (type === 'advisor') {
            selectedMembers = [this.state.searchStringMembers]
            selectedMemberDetails = [this.state.searchObject]
          }

          let tags = this.state.tags
          tags.unshift({ name: type, value: this.state.searchStringMembers })

          this.setState({ searchStringMembers, searchObject, selectedMembers, selectedMemberDetails, tags, errorMessage: null, memberOptions: [] })

        }
      } else if (type === 'advisee') {
        if (this.state.selectedAdvisees.includes(this.state.searchStringAdvisees)) {
          this.setState({ errorMessage: 'You have already added this member' })
        } else if (!this.state.searchObject) {
          this.setState({ errorMessage: 'Please select a member from search suggestions' })
        } else {

          const searchStringAdvisees = ''
          const searchObject = null

          let selectedAdvisees = this.state.selectedAdvisees
          selectedAdvisees.unshift(this.state.searchStringAdvisees)

          let selectedAdviseeDetails = this.state.selectedAdviseeDetails
          selectedAdviseeDetails.unshift(this.state.searchObject)

          let tags = this.state.tags
          tags.unshift({ name: type, value: this.state.searchStringAdvisees })

          this.setState({ searchStringAdvisees, searchObject, selectedAdvisees, selectedAdviseeDetails, tags, errorMessage: null, adviseeOptions: [] })

        }
      } else if (type === 'task') {
        let tasks = this.state.tasks
        if (tasks) {
          tasks.push({ name: "", deadline: "", status: ""})
        } else {
          tasks = [{ name: "", deadline: "", status: ""}]
        }
        this.setState({ tasks })
      } else if (type === 'link') {
        let links = this.state.links
        if (links) {
          links.push('')
        } else {
          links = ['']
        }
        this.setState({ links })
      } else if (type === 'aLink') {
        let aLinks = this.state.aLinks
        if (aLinks) {
          aLinks.push('')
        } else {
          aLinks = ['']
        }
        this.setState({ aLinks })
      } else if (type === 'bLink') {
        let bLinks = this.state.bLinks
        if (bLinks) {
          bLinks.push('')
        } else {
          bLinks = ['']
        }
        this.setState({ bLinks })
      } else if (type === 'school') {
        console.log('in school')
        let selectedSchools = this.state.selectedSchools
        selectedSchools.push(this.state.schoolName)

        let tags = this.state.tags
        tags.unshift({ name: type, value: this.state.schoolName })

        const schoolName = ''
        this.setState({ schoolName, selectedSchools, tags })
      } else if (type === 'major') {
        let selectedMajors = this.state.selectedMajors
        selectedMajors.push(this.state.major)

        let tags = this.state.tags
        tags.unshift({ name: type, value: this.state.major })

        const major = ''
        this.setState({ major, selectedMajors, tags })
      } else if (type === 'actionItem') {
        let actionItems = this.state.actionItems
        if (actionItems) {
          actionItems.push('')
        } else {
          actionItems = ['']
        }
        this.setState({ actionItems })
      } else if (type === 'checklist') {
        let checklist = this.state.checklist
        if (checklist) {
          checklist.push({ name: null, url: null, category: null, checked: null, editMode: true })
        } else {
          checklist = [{ name: null, url: null, category: null, checked: null, editMode: true }]
        }
        this.setState({ checklist })
      } else if (type === 'progress') {
        let progress = this.state.progress
        if (progress) {
          progress.push({ date: null, value: null })
        } else {
          progress = [{ date: null, value: null }]
        }
        this.setState({ progress })
      } else if (type === 'strategy') {
        let strategies = this.state.strategies
        if (strategies) {
          strategies.push({ name: '' })
        } else {
          strategies = [{ name: '' }]
        }
        this.setState({ strategies })
      } else if (type === 'tactic') {
        let strategies = this.state.strategies
        let tactics = this.state.strategies[index].tactics
        if (tactics) {
          tactics.push('')
        } else {
          tactics = ['']
        }
        strategies[index]['tactics'] = tactics
        this.setState({ strategies })
      }
    }

    subNavClicked(currentPage) {
      console.log('subNavClicked called', currentPage)

      this.setState({ currentPage })

    }

    closeModal() {
      console.log('closeModal called in SubEditLog')

      this.setState({ modalIsOpen: false, showSmartDefinition: false, showStrategyDefinition: false,
        showFeedback: false, showShareButtons: false,
        showPost: false, showSuggestions: false, selectedSuggestion: null, selectedIndex: null,
        showAIPlanExplanation: false, showAICreditExplanation: false
      })
      if (this.props.closeModal) {
        this.props.closeModal()
      }
    }

    pullCourses(searchValue, priceValue, durationValue, difficultyLevelValue) {
      console.log('pullCourses called', searchValue, priceValue, durationValue, difficultyLevelValue)

      this.setState({ animating: true, errorMessage: null, successMessage: null })

      // const searchValue = 'Excel'
      if (!searchValue) {
        searchValue = this.state.selectedSkill
      }
      const categoryValue = null
      const subcategoryValue = null
      // let priceValue = this.state.priceValue
      if (!priceValue) {
        priceValue = this.state.priceValue
      }
      let ratingValue = null
      if (!ratingValue) {
        ratingValue = 3.0
      }
      // let durationValue = this.state.durationValue
      if (!durationValue) {
        durationValue = this.state.durationValue
      }

      if (difficultyLevelValue) {
        difficultyLevelValue = difficultyLevelValue.toLowerCase()
      }

      const resLimit = 4
      Axios.get('/api/courses/search', { params: { searchValue, categoryValue, subcategoryValue, priceValue, ratingValue, durationValue, difficultyLevelValue, queryUdemyCourses: true, resLimit } })
      .then((response) => {
        console.log('Courses query attempted', response.data);

          if (response.data.success) {
            console.log('successfully retrieved courses')

            if (response.data.responseData) {

              let relatedCourses = response.data.responseData.results
              if (relatedCourses && relatedCourses.length > resLimit) {
                relatedCourses = relatedCourses.slice(0,resLimit)

              }

              this.setState({ relatedCourses, animating: false })
            }

          } else {
            console.log('no course data found', response.data.message)
            this.setState({ animating: false, errorMessage: 'Found no courses that match the criteria'})
          }

      }).catch((error) => {
          console.log('Course query did not work', error);
          this.setState({ animating: false, errorMessage: 'There was an unknown error retrieving the courses'})
      });
    }

    renderDetails() {
      console.log('renderDetails called in SubEditLog')

      let mainClass = ""
      let subClass = ""
      if (this.props.modalView) {
        mainClass = ""
        subClass = ""
      } else if (window.innerWidth > 768 && this.state.editExisting && this.state.logType === 'Goal') {
        mainClass = "relative-column-70 padding-five-percent-left"
        subClass = "card-clear-padding slightly-rounded-corners full-width max-width-1400 top-margin-40 pin-right"
      } else if (window.innerWidth > 768) {
        mainClass = "full-width"
        subClass = "standard-container-2"
      // } else if (window.innerWidth < 768 && window.location.pathname.includes('/walkthrough')) {
        // mainClass = "full-width"
        // subClass = "card-clear-padding slightly-rounded-corners width-94-percent max-width-1400 center-horizontally top-margin-40"
      } else {
        mainClass = "full-width"
        subClass = "card-clear-padding slightly-rounded-corners width-94-percent max-width-1400 center-horizontally top-margin-40"
      }

      return (
        <div key="everythingLogs">
          {(this.state.editExisting && this.state.logType === 'Goal' && !this.props.modalView) && (
            <div>
              <div className={(window.innerWidth > 768) ? "relative-column-70 padding-five-percent-left" : "full-width"}>
                <div className={(window.innerWidth > 768) ? "full-width max-width-1400 pin-right relative-position" : ""}>
                  <img src={targetIconOrange} alt="GC" className={(window.innerWidth > 768) ? "image-auto-50 white-background circle-radius bottom-margin-negative-50 top-margin z-index-1 absolute-position" : "image-auto-50 center-horizontally white-background circle-radius bottom-margin-negative-50 top-margin"} style={(window.innerWidth > 768) ? { left: '50%', marginLeft: '-25px' } : {}} />
                </div>

              </div>
              <div className="clear" />
              {/*<img src={targetIconOrange} alt="GC" className="image-auto-50 center-horizontally white-background circle-radius bottom-margin-negative-50 top-margin" />*/}
            </div>
          )}
          <div className={mainClass}>
            <div className={subClass}>
              {(window.innerWidth > 768 && this.state.editExisting && this.state.logType === 'Goal') && (
                <div className="full-width height-5 primary-background" />
              )}
              <div className={((window.innerWidth > 768 && this.state.editExisting && this.state.logType === 'Goal') || window.innerWidth < 768) ? "padding-40" : "padding-20"}>
                <div className="row-10">
                  <div className={(this.props.modalView) ? "calc-column-offset-40" : "full-width"}>
                    {this.state.editExisting ? (
                      <div>
                        {(this.state.logType === 'Goal') ? (
                          <div>
                            {(this.props.modalView) ? (
                              <p className="heading-text-2 full-width center-text left-padding-40">{this.state.goalTitle}</p>
                            ) : (
                              <p className="heading-text-2 full-width center-text">{this.state.goalTitle}</p>
                            )}

                            {(this.state.goalDescription) && (
                              <div className="row-10">
                                <p className={(this.props.modalView) ? "description-text-1 description-text-color center-text left-padding-40" : "description-text-1 description-text-color center-text"}>{this.state.goalDescription}</p>
                              </div>
                            )}
                          </div>

                        ) : (
                          <p className="heading-text-2">Edit {this.state.logType}</p>
                        )}
                      </div>
                    ) : (
                      <div>
                        {(this.state.logType && this.state.logType !== '') ? (
                          <p className="heading-text-2">New {(this.state.selectedGroup) && this.state.selectedGroup.name + " "}{this.state.logType}</p>
                        ) : (
                          <p className="heading-text-2">New Log</p>
                        )}
                      </div>
                    )}
                  </div>
                  {(this.props.modalView) && (
                    <div className="fixed-column-40">
                      <button className="background-button" onClick={() => this.closeModal()}>
                        <img src={closeIcon} alt="GC" className="image-auto-20" />
                      </button>
                    </div>
                  )}
                  <div className="clear" />
                </div>

                {(!window.location.pathname.includes(this.state.prefix + '/walkthrough')) && (
                  <div>
                    {(!this.state.editExisting && !window.location.pathname.includes('/goals/new') && !window.location.pathname.includes('/groups/') && !window.location.pathname.includes('/organizations/') && (!window.location.pathname.startsWith('/advisor' && this.state.roleName !== 'Mentor') && this.props.passedType !== 'Session')) && (
                      <div className="row-10">
                        <label className="profile-label">Log Type<label className="error-color">*</label></label>
                        <select className="dropdown" name="logType" value={this.state.logType} onChange={this.formChangeHandler}>
                          {this.state.logTypeOptions.map(value => <option key={value} value={value}>{value}</option>)}
                        </select>
                        <div className="clear"/>

                        {(!window.location.pathname.includes(this.state.prefix + '/walkthrough')) && (
                          <div className="row-10">
                            {(this.state.logType === 'Goal') && (
                              <label className="description-text-1">Set <button className="background-button cta-color underline-text offset-underline" onClick={() => this.setState({ modalIsOpen: true, showSmartDefinition: true })}>S.M.A.R.T.</button> career goals to get suggestions and make use of accountability groups.</label>
                            )}
                            {(this.state.logType === 'Meeting') && (
                              <label className="description-text-1">Add meetings and associated meeting minutes within accountability groups.</label>
                            )}
                            {(this.state.logType === 'Session' && window.location.pathname.includes('/app')) && (
                              <label className="description-text-1">Add advising sessions with counselors, mentors, and other advisors discussing paths, opportunities, resume reviews, mock interviews, etc....</label>
                            )}
                            {(this.state.logType === 'Application') && (
                              <label className="description-text-1">Add your applications to work opportunities you've submitted outside of Guided Compass, for your record and to share with advisors.</label>
                            )}
                            {(this.state.logType === 'Interview') && (
                              <label className="description-text-1">Add notes from interviews you've had for work opportunities, for your record and to share with advisors.</label>
                            )}
                            {(this.state.logType === 'Offer') && (
                              <label className="description-text-1">Add offer details you've had for work opportunities, for your record and to share with advisors.</label>
                            )}
                            {(this.state.logType === 'Passion') && (
                              <label className="description-text-1">Add passions you have, for your record, for creating a career plan, for recommending opportunities, and to share with advisors.</label>
                            )}
                            {(this.state.logType === 'Notes') && (
                              <label className="description-text-1">Add notes you can reference later. Notes can also be imported/exported into conversations with A.I.</label>
                            )}
                          </div>
                        )}

                        <div className="spacer" />

                        <hr className="clear-margin clear-padding"/>
                      </div>
                    )}
                  </div>
                )}

                {(this.state.logType === 'Goal') && (
                  <div>
                    {(this.state.editExisting && !this.state.remoteAuth && !this.props.modalView) && (
                      <div className="row-10 bottom-margin-20 full-width flex-container flex-center row-direction">
                        <div className="right-padding">
                          <button onClick={() => this.setState({ modalIsOpen: true, showPost: true })} className="btn btn-squarish">
                            <div className={(window.innerWidth > 768) ? "float-left right-padding" : "float-left right-padding-8"}>
                              <img src={newsFeedIconDark} alt="GC" className="image-auto-18 center-horizontally" />
                            </div>
                            <div className={(window.innerWidth > 768) ? "float-left right-padding-20" : "float-left right-padding-15"}>
                              <p>Post</p>
                            </div>
                            <div className="clear" />
                          </button>
                        </div>

                        {(!this.state.remoteAuth) && (
                          <div className="left-padding right-padding">
                            <button onClick={() => this.setState({ modalIsOpen: true, showShareButtons: true, sharePosting: true })} className="btn btn-squarish white-background cta-color">
                              <div className={(window.innerWidth > 768) ? "float-left right-padding" : "float-left right-padding-8"}>
                                <img src={shareIconDark} alt="GC" className="image-auto-18 center-horizontally" />
                              </div>
                              <div className={(window.innerWidth > 768) ? "float-left right-padding-20" : "float-left right-padding-15"}>
                                <p>Share</p>
                              </div>
                              <div className="clear" />
                            </button>
                          </div>
                        )}

                        <div className="left-padding">
                          <button className="btn btn-squarish senary-background cta-border cta-color" onClick={() => this.props.navigate(this.state.prefix + '/messaging', { state: { selectedGoal: this.state.selectedGoal }})}>
                            <div className={(window.innerWidth > 768) ? "float-left right-padding" : "float-left right-padding-8"}>
                              <img src={sendIconDark} alt="GC" className="image-auto-18 center-horizontally" />
                            </div>
                            <div className={(window.innerWidth > 768) ? "float-left right-padding-20" : "float-left right-padding-15"}>
                              <p>Send</p>
                            </div>
                            <div className="clear" />
                          </button>
                        </div>
                      </div>
                    )}

                    {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="description-text-2 error-color row-5 full-width center-text">{this.state.errorMessage}</p>}
                    {(this.state.successMessage && this.state.successMessage !== '') && <p className="description-text-2 cta-color row-5 full-width center-text">{this.state.successMessage}</p>}

                    {(window.innerWidth < 768 && this.state.editExisting) && (
                      <div>
                        <div className="full-width standard-border top-margin">
                          <div className="carousel-3" onScroll={this.handleScroll}>
                            {this.state.subNavCategories.map((value, index) =>
                              <div className="display-inline right-padding-20">
                                {(this.state.subNavCategories[index] === this.state.currentPage) ? (
                                  <div className="selected-carousel-item">
                                    <label key={value}>{value}</label>
                                  </div>
                                ) : (
                                  <button className="menu-button" onClick={() => this.subNavClicked(value)}>
                                    <label key={value}>{value}</label>
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="spacer" />
                      </div>
                    )}

                    {(this.state.currentPage === 'Details') && (
                      <div>
                        <div className="row-15">
                          <div className="container-left">
                            <label className="profile-label">Title<label className="error-color">*</label></label>
                            <input className="text-field" type="text" placeholder="Write a short title of your goal..." name="goalTitle" value={this.state.goalTitle} onChange={this.formChangeHandler} />
                          </div>
                          <div className="container-right">
                            <label className="profile-label">Select a Goal Type<label className="error-color">*</label></label>
                            <select name="goalType" value={this.state.goalType.description} onChange={this.formChangeHandler} className="dropdown">
                              {this.state.goalTypeOptions.map(value =>
                                <option key={value.description} value={value.description}>{value.description}</option>
                              )}
                            </select>
                          </div>
                          <div className="clear" />
                        </div>

                        <div>
                          {(this.state.goalType && this.state.goalType.name !== '') && (
                            <div>
                              <div className="row-15">
                                <label className="profile-label">Description<label className="error-color">*</label></label>
                                <textarea className="text-field" type="text" placeholder="Describe the goal..." name={"goalDescription"} value={this.state.goalDescription} onChange={this.formChangeHandler} />
                              </div>
                            </div>
                          )}

                          {(this.state.goalType.name === 'Alternatives') && (
                            <div>
                              <div className="top-padding-15">
                                <div className="container-left">
                                  <label className="profile-label">What type of comparison?</label>
                                  <select name="comparisonType" value={this.state.comparisonType} onChange={this.formChangeHandler} className="dropdown">
                                    {this.state.comparisonTypeOptions.map(value =>
                                      <option key={value} value={value}>{value}</option>
                                    )}
                                  </select>
                                </div>
                                <div className="container-right">
                                  <div>
                                    <div className="bottom-padding-5">
                                      <label className="profile-label">Would you like to poll your connections?</label>
                                      {/*<label className="profile-descriptor">This allows people to vote on what you should do and explain why</label>*/}
                                      <div className="clear" />
                                    </div>

                                    <Switch
                                      onChange={(change) => this.setState({ pollConnections: change, formHasChanged: true })}
                                      checked={this.state.pollConnections}
                                      id="normal-switch"
                                    />
                                  </div>
                                </div>
                                <div className="clear" />
                              </div>

                              {(this.state.pollConnections && this.state.pollQuestion) && (
                                <div className="top-padding-15">
                                  <label className="profile-label description-text-color">Poll Questions: <label className="error-color">{this.state.pollQuestion}</label></label>
                                </div>
                              )}

                              <div className="top-padding-20">
                                <div>
                                  <div className="container-left standard-border padding-20">
                                    <label className="heading-text-6">Option A</label>

                                    <div className="row-15">
                                      <label className="profile-label">Name<label className="error-color">*</label></label>
                                      <input className="text-field" type="text" placeholder="Option A name..." name="aName" value={this.state.aName} onChange={this.formChangeHandler} />
                                    </div>

                                    {(this.state.comparisonType === 'Careers') && (
                                      <div>
                                        <div className="row-15">
                                          <label className="profile-label">Tag a Career Path</label>
                                          <div className="calc-column-offset-70">
                                            <input type="text" className="text-field" placeholder="Search 1,000+ career paths..." name="searchCareersA" value={this.state.searchStringA} onChange={this.formChangeHandler}></input>
                                          </div>
                                          <div className="fixed-column-70 left-padding">
                                            <button className={(!this.state.searchStringA || this.state.searchStringA === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchStringA || this.state.searchStringA === '') ? true : false} onClick={() => this.addItem('careerA')}>Add</button>
                                          </div>
                                          <div className="clear" />
                                        </div>

                                        {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="description-text-2 error-color row-5">{this.state.errorMessage}</p>}
                                        {(this.state.successMessage && this.state.successMessage !== '') && <p className="description-text-2 cta-color row-5">{this.state.successMessage}</p>}

                                        {(this.state.searchIsAnimatingCareersA) ? (
                                          <div className="flex-container flex-center full-space">
                                            <div>
                                              <div className="super-spacer" />

                                              <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                              <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                              <p className="center-text cta-color bold-text">Searching...</p>

                                            </div>
                                          </div>
                                        ) : (
                                          <div>
                                            <div>
                                              {(this.state.careerOptionsA && this.state.careerOptionsA.length > 0) && (
                                                <div className="card top-margin-15">
                                                  {this.state.careerOptionsA.map((value, optionIndex) =>
                                                    <div key={value._id} className="left-text bottom-margin-5 full-width">
                                                      <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'careerA')}>
                                                        <div className="full-width">
                                                          <div className="fixed-column-40">
                                                            <div className="mini-spacer" />
                                                            <img src={experienceIcon} alt="Compass employer icon icon" className="image-auto-22" />
                                                          </div>
                                                          <div className="calc-column-offset-40">
                                                            <p className="cta-color">{value.name}</p>
                                                          </div>
                                                        </div>
                                                      </button>
                                                    </div>
                                                  )}
                                                </div>
                                              )}
                                            </div>

                                            <div>

                                              {this.renderTags('careerA')}
                                              <div className="clear" />

                                            </div>

                                          </div>
                                        )}
                                        <div className="clear" />
                                      </div>
                                    )}

                                    {(this.state.comparisonType === 'Jobs') && (
                                      <div>
                                        <div className="row-15">
                                          <label className="profile-label">Tag a Job</label>
                                          <div className="calc-column-offset-70">
                                            <input type="text" className="text-field" placeholder="Search work opportunities..." name="searchOpportunitiesA" value={this.state.searchStringOpportunitiesA} onChange={this.formChangeHandler}></input>
                                          </div>
                                          <div className="fixed-column-70 left-padding">
                                            <button className={(!this.state.searchStringOpportunitiesA || this.state.searchStringOpportunitiesA === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchStringOpportunitiesA || this.state.searchStringOpportunitiesA === '') ? true : false} onClick={() => this.addItem('opportunityA')}>Add</button>
                                          </div>
                                          <div className="clear" />
                                        </div>

                                        <div className="clear" />

                                        {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="description-text-2 error-color row-5">{this.state.errorMessage}</p>}
                                        {(this.state.successMessage && this.state.successMessage !== '') && <p className="description-text-2 cta-color row-5">{this.state.successMessage}</p>}

                                        {(this.state.searchIsAnimatingOpportunitiesA) ? (
                                          <div className="flex-container flex-center full-space">
                                            <div>
                                              <div className="super-spacer" />

                                              <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                              <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                              <p className="center-text cta-color bold-text">Searching...</p>

                                            </div>
                                          </div>
                                        ) : (
                                          <div>
                                            <div>
                                              {(this.state.opportunityOptionsA && this.state.opportunityOptionsA.length > 0) && (
                                                <div className="card top-margin-15">
                                                  {this.state.opportunityOptionsA.map((value, optionIndex) =>
                                                    <div key={value._id} className="left-text bottom-margin-5 full-width">
                                                      <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'opportunityA')}>
                                                        <div className="full-width">
                                                          <div className="fixed-column-40">
                                                            <div className="mini-spacer" />
                                                            <img src={experienceIcon} alt="Compass employer icon icon" className="image-auto-22" />
                                                          </div>
                                                          <div className="calc-column-offset-40">
                                                            <p className="cta-color">{(value.title) ? value.title : value.name}{value.employerName && " | " + value.employerName}</p>
                                                          </div>
                                                        </div>
                                                      </button>
                                                    </div>
                                                  )}
                                                </div>
                                              )}
                                            </div>

                                            <div>
                                              {this.renderTags('opportunityA')}
                                              <div className="clear" />
                                            </div>

                                          </div>
                                        )}
                                        <div className="clear" />
                                      </div>
                                    )}

                                    {(this.state.comparisonType === 'Competencies') && (
                                      <div>
                                        <label className="profile-label">Tag a Competency</label>
                                        <div className="calc-column-offset-70">
                                          <input type="text" className="text-field" placeholder="Search competencies..." name="searchSkillsA" value={this.state.searchStringCompetenciesA} onChange={this.formChangeHandler}></input>
                                        </div>
                                        <div className="fixed-column-70 left-padding">
                                          <button className={(!this.state.searchStringCompetenciesA || this.state.searchStringCompetenciesA === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchStringCompetenciesA || this.state.searchStringCompetenciesA === '') ? true : false} onClick={() => this.addItem('skillA')}>Add</button>
                                        </div>
                                        <div className="clear" />

                                        {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="description-text-2 error-color row-5">{this.state.errorMessage}</p>}
                                        {(this.state.successMessage && this.state.successMessage !== '') && <p className="description-text-2 cta-color row-5">{this.state.successMessage}</p>}

                                        {(this.state.searchIsAnimatingCompetenciesA) ? (
                                          <div className="flex-container flex-center full-space">
                                            <div>
                                              <div className="super-spacer" />

                                              <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                              <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                              <p className="center-text cta-color bold-text">Searching...</p>

                                            </div>
                                          </div>
                                        ) : (
                                          <div>
                                            <div>
                                              {(this.state.competencyOptionsA && this.state.competencyOptionsA.length > 0) && (
                                                <div className="card top-margin-15">
                                                  {this.state.competencyOptionsA.map((value, optionIndex) =>
                                                    <div key={value._id} className="left-text bottom-margin-5 full-width">
                                                      <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'competencyA')}>
                                                        <div className="full-width">
                                                          <div className="fixed-column-40">
                                                            <div className="half-spacer" />
                                                            <img src={skillsIcon} alt="Compass employer icon icon" className="image-auto-22" />
                                                          </div>
                                                          <div className="calc-column-offset-40">
                                                            <p className="cta-color">{value.name}</p>
                                                            <p className="description-text-2 description-text-color">{value.type}</p>
                                                          </div>
                                                        </div>
                                                      </button>
                                                    </div>
                                                  )}
                                                </div>
                                              )}
                                            </div>

                                            <div>

                                              {this.renderTags('skillA')}
                                              <div className="clear" />

                                            </div>

                                          </div>
                                        )}

                                        <div className="clear" />
                                      </div>
                                    )}

                                    {(this.state.comparisonType === 'Projects') && (
                                      <div className="row-15">
                                        <label className="profile-label">Select one of your projects</label>
                                        <select name="aItemProject" value={(this.state.aItem) && this.state.aItem.name} onChange={this.formChangeHandler} className="dropdown">
                                          {this.state.projectOptions.map(value =>
                                            <option key={value.name} value={value.name}>{value.name}</option>
                                          )}
                                        </select>
                                        <label className="profile-descriptor">You can add projects to your profile <Link to={this.state.prefix + "/edit-profile/profile-details"} target="_blank">here</Link></label>
                                        <div className="clear" />
                                      </div>
                                    )}

                                    <div className="row-15">
                                      <label className="profile-label">Annualized Market Value / Pay</label>

                                      <div className="float-left standard-border light-background width-22 center-text height-40">
                                        <div className="mini-spacer"/><div className="mini-spacer"/><div className="mini-spacer"/><div className="mini-spacer"/>
                                        <p className="heading-text-4 cta-color bold-text full-width">$</p>
                                      </div>
                                      <div className="width-85 float-left">
                                        <input type="number" className="number-field cta-color float-left" placeholder="0" name="aValue" value={this.state.aValue} onChange={this.formChangeHandler}></input>
                                      </div>

                                      <div className="clear" />
                                    </div>

                                    <div className="row-15">
                                      <label className="profile-label">The Case for Option A</label>
                                      <textarea className="text-field" type="text" placeholder="Make the case for this option..." name={"aCase"} value={this.state.aCase} onChange={this.formChangeHandler} />
                                    </div>

                                    <div className="row-15">
                                      <div>
                                        <div className="float-left">
                                          <label className="profile-label">Relevant Links to Decide</label>
                                        </div>
                                        <div className="float-left left-padding top-padding">
                                          <button className="background-button" onClick={() => this.addItem('aLink')}>
                                            <img src={addIcon} alt="Compass target icon" className="image-auto-15" />
                                          </button>
                                        </div>
                                        <div className="clear" />
                                      </div>

                                      {(this.state.aLinks) && (
                                        <div>
                                        {/*
                                          <div key={'aLink'} className="bottom-padding-5">
                                            <div className="fixed-column-35 top-padding" >
                                              <button className="background-button" onClick={() => this.addRemoveItems('Remove', '0','aLink')}>
                                                <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                                              </button>
                                            </div>
                                            <div className="calc-column-offset-35">
                                              <input key={"aLink|0"} className="text-field" type="text" placeholder="Add a link..." name={"aLink|0"} value={this.state.aLinks[0]} onChange={this.formChangeHandler} />
                                            </div>
                                            <div className="clear" />
                                          </div>*/}

                                          {this.state.aLinks.map((value, optionIndex) =>
                                            <div key={'aLink|' + optionIndex} className="bottom-padding-5">
                                              <div className="fixed-column-35 top-padding" >
                                                <button className="background-button" onClick={() => this.addRemoveItems('Remove', optionIndex,'aLink')}>
                                                  <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                                                </button>
                                              </div>
                                              <div className="calc-column-offset-35">
                                                <input className="text-field" type="text" placeholder="Add a link..." name={"aLink|" + optionIndex + "|name"} value={value} onChange={this.formChangeHandler} />

                                                {(value !== '' && !value.startsWith('http')) && (
                                                  <div className="top-padding-5">
                                                    <p className="error-color description-text-2">Please add a valid link that starts with http</p>
                                                  </div>
                                                )}
                                              </div>
                                              <div className="clear" />
                                            </div>
                                          )}
                                        </div>
                                      )}

                                    </div>

                                  </div>
                                  <div className="container-right standard-border padding-20">
                                    <label className="heading-text-6">Option B</label>

                                    <div className="row-15">
                                      <label className="profile-label">Name<label className="error-color">*</label></label>
                                      <input className="text-field" type="text" placeholder="Option B name..." name="bName" value={this.state.bName} onChange={this.formChangeHandler} />
                                    </div>

                                    {(this.state.comparisonType === 'Careers') && (
                                      <div>
                                        <div className="row-15">
                                          <label className="profile-label">Tag a Career Path</label>
                                          <div className="calc-column-offset-70">
                                            <input type="text" className="text-field" placeholder="Search 1,000+ career paths..." name="searchCareersB" value={this.state.searchStringB} onChange={this.formChangeHandler}></input>
                                          </div>
                                          <div className="fixed-column-70 left-padding">
                                            <button className={(!this.state.searchStringB || this.state.searchStringB === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchStringB || this.state.searchStringB === '') ? true : false} onClick={() => this.addItem('careerB')}>Add</button>
                                          </div>
                                          <div className="clear" />
                                        </div>

                                        {(this.state.errorMessageB && this.state.errorMessageB !== '') && <p className="description-text-2 error-color row-5">{this.state.errorMessageB}</p>}
                                        {(this.state.successMessageB && this.state.successMessageB !== '') && <p className="description-text-2 cta-color row-5">{this.state.successMessageB}</p>}

                                        {(this.state.searchIsAnimatingCareersB) ? (
                                          <div className="flex-container flex-center full-space">
                                            <div>
                                              <div className="super-spacer" />

                                              <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                              <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                              <p className="center-text cta-color bold-text">Searching...</p>

                                            </div>
                                          </div>
                                        ) : (
                                          <div>
                                            <div>
                                              {(this.state.careerOptionsB && this.state.careerOptionsB.length > 0) && (
                                                <div className="card top-margin-15">
                                                  {this.state.careerOptionsB.map((value, optionIndex) =>
                                                    <div key={value._id} className="left-text bottom-margin-5 full-width">
                                                      <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'careerB')}>
                                                        <div className="full-width">
                                                          <div className="fixed-column-40">
                                                            <div className="mini-spacer" />
                                                            <img src={experienceIcon} alt="Compass employer icon icon" className="image-auto-22" />
                                                          </div>
                                                          <div className="calc-column-offset-40">
                                                            <p className="cta-color">{value.name}</p>
                                                          </div>
                                                        </div>
                                                      </button>
                                                    </div>
                                                  )}
                                                </div>
                                              )}
                                            </div>

                                            <div>

                                              {this.renderTags('careerB')}
                                              <div className="clear" />

                                            </div>

                                          </div>
                                        )}
                                        <div className="clear" />
                                      </div>
                                    )}

                                    {(this.state.comparisonType === 'Jobs') && (
                                      <div>
                                        <div className="row-15">
                                          <label className="profile-label">Tag a Job</label>
                                          <div className="calc-column-offset-70">
                                            <input type="text" className="text-field" placeholder="Search work opportunities..." name="searchOpportunitiesB" value={this.state.searchStringOpportunitiesB} onChange={this.formChangeHandler}></input>
                                          </div>
                                          <div className="fixed-column-70 left-padding">
                                            <button className={(!this.state.searchStringOpportunitiesB || this.state.searchStringOpportunitiesB === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchStringOpportunitiesB || this.state.searchStringOpportunitiesB === '') ? true : false} onClick={() => this.addItem('opportunityB')}>Add</button>
                                          </div>
                                          <div className="clear" />
                                        </div>

                                        <div className="clear" />

                                        {(this.state.errorMessageB && this.state.errorMessageB !== '') && <p className="description-text-2 error-color row-5">{this.state.errorMessageB}</p>}
                                        {(this.state.successMessageB && this.state.successMessageB !== '') && <p className="description-text-2 cta-color row-5">{this.state.successMessageB}</p>}

                                        {(this.state.searchIsAnimatingOpportunitiesB) ? (
                                          <div className="flex-container flex-center full-space">
                                            <div>
                                              <div className="super-spacer" />

                                              <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                              <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                              <p className="center-text cta-color bold-text">Searching...</p>

                                            </div>
                                          </div>
                                        ) : (
                                          <div>
                                            <div>
                                              {(this.state.opportunityOptionsB && this.state.opportunityOptionsB.length > 0) && (
                                                <div className="card top-margin-15">
                                                  {this.state.opportunityOptionsB.map((value, optionIndex) =>
                                                    <div key={value._id} className="left-text bottom-margin-5 full-width">
                                                      <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'opportunityB')}>
                                                        <div className="full-width">
                                                          <div className="fixed-column-40">
                                                            <div className="mini-spacer" />
                                                            <img src={experienceIcon} alt="Compass employer icon icon" className="image-auto-22" />
                                                          </div>
                                                          <div className="calc-column-offset-40">
                                                            <p className="cta-color">{(value.title) ? value.title : value.name}{value.employerName && " | " + value.employerName}</p>
                                                          </div>
                                                        </div>
                                                      </button>
                                                    </div>
                                                  )}
                                                </div>
                                              )}
                                            </div>

                                            <div>

                                              {this.renderTags('opportunityB')}
                                              <div className="clear" />

                                            </div>

                                          </div>
                                        )}
                                        <div className="clear" />
                                      </div>
                                    )}

                                    {(this.state.comparisonType === 'Competencies') && (
                                      <div>
                                        <label className="profile-label">Tag a Competency</label>
                                        <div className="calc-column-offset-70">
                                          <input type="text" className="text-field" placeholder="Search competencies..." name="searchSkillsB" value={this.state.searchStringCompetenciesB} onChange={this.formChangeHandler}></input>
                                        </div>
                                        <div className="fixed-column-70 left-padding">
                                          <button className={(!this.state.searchStringCompetenciesB || this.state.searchStringCompetenciesB === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchStringCompetenciesB || this.state.searchStringCompetenciesB === '') ? true : false} onClick={() => this.addItem('skillB')}>Add</button>
                                        </div>
                                        <div className="clear" />

                                        {(this.state.errorMessageB && this.state.errorMessageB !== '') && <p className="description-text-2 error-color row-5">{this.state.errorMessageB}</p>}
                                        {(this.state.successMessageB && this.state.successMessageB !== '') && <p className="description-text-2 cta-color row-5">{this.state.successMessageB}</p>}

                                        {(this.state.searchIsAnimatingCompetenciesB) ? (
                                          <div className="flex-container flex-center full-space">
                                            <div>
                                              <div className="super-spacer" />

                                              <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                              <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                              <p className="center-text cta-color bold-text">Searching...</p>

                                            </div>
                                          </div>
                                        ) : (
                                          <div>
                                            <div>
                                              {(this.state.competencyOptionsB && this.state.competencyOptionsB.length > 0) && (
                                                <div className="card top-margin-15">
                                                  {this.state.competencyOptionsB.map((value, optionIndex) =>
                                                    <div key={value._id} className="left-text bottom-margin-5 full-width">
                                                      <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'competencyB')}>
                                                        <div className="full-width">
                                                          <div className="fixed-column-40">
                                                            <div className="half-spacer" />
                                                            <img src={skillsIcon} alt="Compass employer icon icon" className="image-auto-22" />
                                                          </div>
                                                          <div className="calc-column-offset-40">
                                                            <p className="cta-color">{value.name}</p>
                                                            <p className="description-text-2 description-text-color">{value.type}</p>
                                                          </div>
                                                        </div>
                                                      </button>
                                                    </div>
                                                  )}
                                                </div>
                                              )}
                                            </div>

                                            <div>

                                              {this.renderTags('skillB')}
                                              <div className="clear" />

                                            </div>

                                          </div>
                                        )}

                                        <div className="clear" />
                                      </div>
                                    )}

                                    {(this.state.comparisonType === 'Projects') && (
                                      <div className="row-15">
                                        <label className="profile-label">Select one of your projects</label>
                                        <select name="bItemProject" value={(this.state.bItem) && this.state.bItem.name} onChange={this.formChangeHandler} className="dropdown">
                                          {this.state.projectOptions.map(value =>
                                            <option key={value.name} value={value.name}>{value.name}</option>
                                          )}
                                        </select>
                                        <label className="profile-descriptor">You can add projects to your profile <Link to={this.state.prefix + "/edit-profile/profile-details"} target="_blank">here</Link></label>
                                        <div className="clear" />
                                      </div>
                                    )}

                                    <div className="row-15">
                                      <label className="profile-label">Annualized Market Value / Pay</label>

                                      <div className="float-left standard-border light-background width-22 center-text height-40">
                                        <div className="mini-spacer"/><div className="mini-spacer"/><div className="mini-spacer"/><div className="mini-spacer"/>
                                        <p className="heading-text-4 cta-color bold-text full-width">$</p>
                                      </div>
                                      <div className="width-85 float-left">
                                        <input type="number" className="number-field cta-color float-left" placeholder="0" name="bValue" value={this.state.bValue} onChange={this.formChangeHandler}></input>
                                      </div>

                                      <div className="clear" />
                                    </div>

                                    <div className="row-15">
                                      <label className="profile-label">The Case for Option B</label>
                                      <textarea className="text-field" type="text" placeholder="Make the case for this option..." name={"bCase"} value={this.state.bCase} onChange={this.formChangeHandler} />
                                    </div>

                                    <div className="row-15">
                                      <div>
                                        <div className="float-left">
                                          <label className="profile-label">Relevant Links to Decide</label>
                                        </div>
                                        <div className="float-left left-padding top-padding">
                                          <button className="background-button" onClick={() => this.addItem('bLink')}>
                                            <img src={addIcon} alt="Compass target icon" className="image-auto-15" />
                                          </button>
                                        </div>
                                        <div className="clear" />
                                      </div>

                                      {(this.state.bLinks) && (
                                        <div>
                                          {this.state.bLinks.map((value, optionIndex) =>
                                            <div key={'bLink|' + optionIndex} className="bottom-padding">
                                              <div className="fixed-column-35 top-padding" >
                                                <button className="background-button" onClick={() => this.addRemoveItems('Remove', optionIndex,'aLink')}>
                                                  <img src={deniedIcon} alt="Compass target icon" className="image-auto-20" />
                                                </button>
                                              </div>
                                              <div className="calc-column-offset-35">
                                                <input className="text-field" type="text" placeholder="Add a link..." name={"bLink|" + optionIndex + "|name"} value={value} onChange={this.formChangeHandler} />

                                                {(value !== '' && !value.startsWith('http')) && (
                                                  <div className="top-padding-5">
                                                    <p className="error-color description-text-2">Please add a valid link that starts with http</p>
                                                  </div>
                                                )}
                                              </div>
                                              <div className="clear" />
                                            </div>
                                          )}
                                        </div>
                                      )}

                                    </div>

                                  </div>
                                  <div className="clear" />
                                </div>
                              </div>
                            </div>
                          )}

                          {(this.state.goalType.name === 'Degree') && (
                            <div>
                              <div className="row-15">
                                <div className="container-left">
                                  <label className="profile-label">Degree Type</label>
                                  <select name="degreeType" value={this.state.degreeType} onChange={this.formChangeHandler} className="dropdown">
                                    {this.state.degreeOptions.map(value =>
                                      <option key={value} value={value}>{value}</option>
                                    )}
                                  </select>
                                </div>
                                <div className="clear" />
                              </div>

                              <div className="row-15">
                                <div className="container-left">
                                  <div className="row-10">
                                    <label className="profile-label">School / University Name(s)</label>
                                    <div className="calc-column-offset-70">
                                      <input type="text" className="text-field" placeholder="Add a school..." name="schoolName" value={this.state.schoolName} onChange={this.formChangeHandler}></input>
                                    </div>
                                    <div className="fixed-column-70 left-padding">
                                      <button className={(!this.state.schoolName || this.state.schoolName === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.schoolName || this.state.schoolName === '') ? true : false} onClick={() => this.addItem('school')}>Add</button>
                                    </div>
                                    <div className="clear" />
                                  </div>

                                  <div>
                                    {this.renderTags('school')}
                                    <div className="clear" />
                                  </div>

                                </div>

                                <div className="container-right">
                                  <div className="row-15">
                                    <label className="profile-label">Major(s)</label>
                                    <div className="calc-column-offset-70">
                                      <input type="text" className="text-field" placeholder="Add a major..." name="major" value={this.state.major} onChange={this.formChangeHandler}></input>
                                    </div>
                                    <div className="fixed-column-70 left-padding">
                                      <button className={(!this.state.major || this.state.major === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.major || this.state.major === '') ? true : false} onClick={() => this.addItem('major')}>Add</button>
                                    </div>
                                    <div className="clear" />
                                  </div>

                                  <div>
                                    {this.renderTags('major')}
                                    <div className="clear" />
                                  </div>

                                </div>
                                <div className="clear" />
                              </div>
                            </div>
                          )}

                          {(this.state.goalType.name === 'Social Problem') && (
                            <div>
                              <div className="row-15">
                                <div className="container-left">
                                  <label className="profile-label">Problem Type</label>
                                  <select name="societalProblem" value={this.state.societalProblem} onChange={this.formChangeHandler} className="dropdown">
                                    {this.state.societalProblemOptions.map(value =>
                                      <option key={value} value={value}>{value}</option>
                                    )}
                                  </select>
                                </div>
                                <div className="clear" />
                              </div>
                            </div>
                          )}

                          {(this.state.goalType.name === 'Entrepreneurship' || this.state.goalType.name === 'Entrepreneurship - Start') && (
                            <div>
                              <div className="row-15">
                                <div className="container-left">
                                  <label className="profile-label">What stage is your business in?<label className="error-color">*</label></label>
                                  <select name="entrepreneurshipStage" value={this.state.entrepreneurshipStage} onChange={this.formChangeHandler} className="dropdown">
                                    {this.state.entrepreneurshipStageOptions.map(value =>
                                      <option key={value} value={value}>{value}</option>
                                    )}
                                  </select>
                                  <div className="clear" />
                                </div>

                                <div className="container-right">
                                  <label className="profile-label">Is this organization for profit or nonprofit?</label>
                                  <select name="entrepreneurshipType" value={this.state.entrepreneurshipType} onChange={this.formChangeHandler} className="dropdown">
                                    {['','For-Profit','Non-Profit'].map(value =>
                                      <option key={value} value={value}>{value}</option>
                                    )}
                                  </select>
                                  <div className="clear" />
                                </div>
                                <div className="clear" />
                              </div>

                              <div className="row-15">
                                <div className="container-left">
                                  <label className="profile-label">Add your business as a project (Optional)</label>
                                  <select name="entrepreneurshipProject" value={this.state.entrepreneurshipProject.name} onChange={this.formChangeHandler} className="dropdown">
                                    {this.state.projectOptions.map(value =>
                                      <option key={value.name} value={value.name}>{value.name}</option>
                                    )}
                                  </select>
                                  <label className="profile-descriptor">You can add projects to your profile <Link to={this.state.prefix + "/edit-profile/profile-details"} target="_blank">here</Link></label>
                                  <div className="clear" />
                                </div>
                                <div className="container-right">
                                  <label className="profile-label">What area do you need help with?</label>
                                  <select name="entrepreneurshipGoal" value={this.state.entrepreneurshipGoal} onChange={this.formChangeHandler} className="dropdown">
                                    {this.state.entrepreneurshipGoalOptions.map(value =>
                                      <option key={value} value={value}>{value}</option>
                                    )}
                                  </select>
                                  <div className="clear" />
                                </div>
                                <div className="clear" />
                              </div>
                            </div>
                          )}

                          {(this.state.goalType && this.state.goalType.name !== '' && this.state.goalType.name !== 'Alternatives' && this.state.goalType.name !== 'Career' && this.state.goalType.name !== 'Switch' && this.state.goalType.name !== 'Freelance' && this.state.goalType.name !== 'Explore' && this.state.goalType.name !== 'Leadership' && this.state.goalType.name !== 'Expert' && this.state.goalType.name !== 'Promotion' && this.state.goalType.name !== 'Award') && (
                            <div>
                              <div className="row-15">
                                <div className="container-left">
                                  <label className="profile-label">Tag Relevant Skills & Knowledge</label>
                                  <div className="calc-column-offset-70">
                                    <input type="text" className="text-field" placeholder="Search competencies..." name="searchSkills" value={this.state.searchStringCompetencies} onChange={this.formChangeHandler}></input>
                                  </div>
                                  <div className="fixed-column-70 left-padding">
                                    <button className={(!this.state.searchStringCompetencies || this.state.searchStringCompetencies === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchStringCompetencies || this.state.searchStringCompetencies === '') ? true : false} onClick={() => this.addItem('skill')}>Add</button>
                                  </div>
                                  <div className="clear" />
                                </div>
                                {(this.state.goalType.name === 'Learn New Skills') && (
                                  <div className="container-right">
                                    <label className="profile-label">Competencies to Prioritize</label>
                                    <select name="skillPreference" value={this.state.skillPreference} onChange={this.formChangeHandler} className="dropdown">
                                      {this.state.skillPreferenceOptions.map(value =>
                                        <option key={value} value={value}>{value}</option>
                                      )}
                                    </select>
                                  </div>
                                )}

                                <div className="clear" />

                                {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="description-text-2 error-color row-5">{this.state.errorMessage}</p>}
                                {(this.state.successMessage && this.state.successMessage !== '') && <p className="description-text-2 cta-color row-5">{this.state.successMessage}</p>}

                                {(this.state.searchIsAnimatingCompetencies) ? (
                                  <div className="flex-container flex-center full-space">
                                    <div>
                                      <div className="super-spacer" />

                                      <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                      <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                      <p className="center-text cta-color bold-text">Searching...</p>

                                    </div>
                                  </div>
                                ) : (
                                  <div>
                                    <div>
                                      {(this.state.competencyOptions) && (
                                        <div className="card top-margin-15">
                                          {this.state.competencyOptions.map((value, optionIndex) =>
                                            <div key={value._id} className="left-text bottom-margin-5 full-width">
                                              <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'competency')}>
                                                <div className="full-width">
                                                  <div className="fixed-column-40">
                                                    <div className="half-spacer" />
                                                    <img src={skillsIcon} alt="Compass employer icon icon" className="image-auto-22" />
                                                  </div>
                                                  <div className="calc-column-offset-40">
                                                    <p className="cta-color">{value.name}</p>
                                                    <p className="description-text-2 description-text-color">{value.type}</p>
                                                  </div>
                                                </div>
                                              </button>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                    {/*
                                    <div>

                                      {this.renderTags('skill')}
                                      <div className="clear" />

                                    </div>*/}

                                  </div>
                                )}

                                <div className="clear" />
                              </div>

                              <div>
                                {this.renderTags('learningObjective')}
                                <div className="clear" />
                              </div>
                            </div>
                          )}

                          {(this.state.goalType.name && this.state.goalType !== '') && (
                            <div>
                              <div className="row-15">
                                <div className="container-left">
                                  <label className="profile-label">When You'll Start Working Toward This<label className="error-color">*</label></label>
                                  <div>
                                    <input type="datetime-local" className="date-picker white-background" name="goalStartDate" value={this.state.goalStartDate} min={this.state.minTargetDate} max={this.state.maxTargetDate} onChange={this.formChangeHandler}></input>
                                  </div>
                                  {/*
                                  <div className="fixed-column-70 left-padding">
                                    <button className={(this.state.unready) ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={this.state.unready} onClick={() => this.addItem('goal')}>Add</button>
                                  </div>*/}
                                  <div className="clear" />
                                </div>
                                <div className="container-right">
                                  <label className="profile-label">Deadline to Reach Your Goal<label className="error-color">*</label></label>
                                  <div>
                                    <input type="datetime-local" className="date-picker white-background" name="goalDeadline" value={this.state.goalDeadline} min={this.state.minTargetDate} max={this.state.maxTargetDate} onChange={this.formChangeHandler}></input>
                                  </div>
                                  {/*
                                  <div className="fixed-column-70 left-padding">
                                    <button className={(this.state.unready) ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={this.state.unready} onClick={() => this.addItem('goal')}>Add</button>
                                  </div>*/}
                                  <div className="clear" />
                                </div>
                                <div className="clear" />
                              </div>

                              {(this.state.goalType.name !== 'Alternatives') && (
                                <div className="row-15">
                                  <div className="container-left">
                                    <label className="profile-label">Intensity</label>
                                    <select name="intensity" value={this.state.intensity} onChange={this.formChangeHandler} className="dropdown">
                                      {this.state.intensityOptions.map(value =>
                                        <option key={value} value={value}>{value}</option>
                                      )}
                                    </select>
                                    {/*
                                    <div className="fixed-column-70 left-padding">
                                      <button className={(this.state.unready) ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={this.state.unready} onClick={() => this.addItem('goal')}>Add</button>
                                    </div>*/}
                                  </div>
                                  <div className="clear" />
                                </div>
                              )}

                              <div className="clear" />
                            </div>
                          )}

                          <div className="clear" />

                          {(this.state.goalType && this.state.goalType.name !== '' && this.state.goalType.name !== 'Alternatives') && (
                            <div>
                              <div className="row-15">
                                <label className="profile-label">Define Success</label>
                                <textarea className="text-field" type="text" placeholder="How do you define success?" name={"successDefined"} value={this.state.successDefined} onChange={this.formChangeHandler} />
                              </div>

                              <div className="row-15">
                                <div>
                                  <div className="calc-column-offset-30">
                                    <div className="float-left">
                                      <label className="profile-label">Strategies & Tactics</label>
                                    </div>
                                    <div className="float-left left-padding top-padding">
                                      <button className="background-button" onClick={() => this.addItem('strategy')}>
                                        <div className="padding-5 cta-border circle-corners">
                                          <img src={addIcon} alt="Compass target icon" className="image-auto-10" />
                                        </div>
                                      </button>
                                    </div>
                                  </div>
                                  <div className="fixed-column-30">
                                    <div className="half-spacer" /><div className="mini-spacer" /><div className="mini-spacer" /><div className="mini-spacer" />
                                    <div className="float-left left-margin noti-bubble-info-7-9">
                                      <a className="background-link" onClick={() => this.setState({ modalIsOpen: true, showStrategyDefinition: true })}>
                                        <img src={questionMarkBlue} alt="Guided Compass dashboard icon" className="image-auto-14 center-item" />
                                      </a>
                                    </div>
                                  </div>

                                  <div className="clear" />
                                </div>

                                {(this.state.strategies && this.state.strategies.length > 0) ? (
                                  <div>
                                    {this.state.strategies.map((item, index) =>
                                      <div className="vertical-margin-10">
                                        <div>
                                          <div className="fixed-column-30 top-padding" >
                                            <button className="background-button" onClick={() => this.addRemoveItems('Remove', index,'strategy')}>
                                              <img src={deniedIcon} alt="GC" className="image-auto-20" />
                                            </button>
                                          </div>
                                          <div className="calc-column-offset-30 left-padding">
                                            <input type="text" className="text-field" placeholder="Add a strategy (e.g., create regular habits to make progress)" name={"strategy|name|" + index} value={item.name} onChange={this.formChangeHandler}></input>
                                          </div>
                                          <div className="clear" />
                                        </div>

                                        {(item.tactics && item.tactics.length > 0) && (
                                          <div>
                                            {item.tactics.map((item2, index2) =>
                                              <div className="left-padding-40 vertical-margin-10">
                                                <div>
                                                  <div className="fixed-column-30 top-padding" >
                                                    <button className="background-button" onClick={() => this.addRemoveItems('Remove', index,'tactic',index2)}>
                                                      <img src={deniedIcon} alt="GC" className="image-auto-20" />
                                                    </button>
                                                  </div>
                                                  <div className="calc-column-offset-30 left-padding">
                                                    <input type="text" className="text-field" placeholder="Add a tactic (e.g., do 5 math problems a day after I work out each morning)" name={"tactic|" + index + "|" + index2} value={item2} onChange={this.formChangeHandler}></input>
                                                  </div>
                                                  <div className="clear" />
                                                </div>

                                              </div>
                                            )}
                                          </div>
                                        )}

                                        <div className="left-padding-40 vertical-margin-10">
                                          <button className="background-button clear-margin clear-padding" onClick={() => this.addItem('tactic',index)}>
                                            <img src={addIconBlue} alt="GC" className="image-auto-25 padding-5 circle-radius cta-border bottom-margin-negative-18 white-background" />
                                          </button>

                                          <hr className="cta-border left-margin-30" />
                                        </div>

                                        <div className="spacer" />
                                      </div>
                                    )}
                                    <div className="spacer" />
                                  </div>
                                ) : (
                                  <div className="row-10">
                                    <p className="description-text-2 description-text-color">You haven't listed any strategies and/or tactics to achieve your goal.</p>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          <div className="row-20">
                            <hr />
                          </div>

                          {(this.state.goalType && this.state.goalType.name !== '') && (
                            <div className="row-15 top-margin">
                              <p className="heading-text-5">Add Tags</p>
                            </div>
                          )}

                          {(this.state.goalType.name === 'Career' || this.state.goalType.name === 'Switch' || this.state.goalType.name === 'Freelance' || this.state.goalType.name === 'Explore' || this.state.goalType.name === 'Leadership' || this.state.goalType.name === 'Expert' || this.state.goalType.name === 'Promotion'  || this.state.goalType.name === 'Award') && (
                            <div>
                              <div>
                                <div className="row-15">
                                  <div className="container-left">
                                    <label className="profile-label">Add Appropriate Tags</label>
                                    <select name="tagType" value={this.state.tagType} onChange={this.formChangeHandler} className="dropdown">
                                      {this.state.tagTypeOptions.map(value =>
                                        <option key={value} value={value}>{value}</option>
                                      )}
                                    </select>
                                  </div>

                                  {(this.state.tagType === 'Community Career Paths') && (
                                    <div className="container-right">
                                      <label className="profile-label">Tag Career Path(s)</label>
                                      <div className="calc-column-offset-70">
                                        <input type="text" className="text-field" placeholder="Search career paths..." name="searchPathways" value={this.state.searchString} onChange={this.formChangeHandler}></input>
                                      </div>
                                      <div className="fixed-column-70 left-padding">
                                        <button className={(!this.state.searchString || this.state.searchString === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchString || this.state.searchString === '') ? true : false} onClick={() => this.addItem('pathway')}>Add</button>
                                      </div>
                                      <div className="clear" />

                                      {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="description-text-2 error-color row-5">{this.state.errorMessage}</p>}
                                      {(this.state.successMessage && this.state.successMessage !== '') && <p className="description-text-2 cta-color row-5">{this.state.successMessage}</p>}

                                      {(this.state.searchIsAnimatingPathways) ? (
                                        <div className="flex-container flex-center full-space">
                                          <div>
                                            <div className="super-spacer" />

                                            <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                            <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                            <p className="center-text cta-color bold-text">Searching...</p>

                                          </div>
                                        </div>
                                      ) : (
                                        <div>
                                          <div>
                                            {(this.state.pathwayOptions && this.state.pathwayOptions.length > 0) && (
                                              <div className="card top-margin-15">
                                                {this.state.pathwayOptions.map((value, optionIndex) =>
                                                  <div key={value._id} className="left-text bottom-margin-5 full-width">
                                                    <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'pathway')}>
                                                      <div className="full-width">
                                                        <div className="fixed-column-40">
                                                          <div className="mini-spacer" />
                                                          <img src={pathsIconDark} alt="GC" className="image-auto-22" />
                                                        </div>
                                                        <div className="calc-column-offset-40">
                                                          <p className="cta-color">{value.title}</p>
                                                        </div>
                                                      </div>
                                                    </button>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                  {(this.state.tagType === 'General Careers') && (
                                    <div className="container-right">
                                      <label className="profile-label">Tag Career(s)</label>
                                      <div className="calc-column-offset-70">
                                        <input type="text" className="text-field" placeholder="Search 1,000+ careers..." name="searchCareers" value={this.state.searchString} onChange={this.formChangeHandler}></input>
                                      </div>
                                      <div className="fixed-column-70 left-padding">
                                        <button className={(!this.state.searchString || this.state.searchString === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchString || this.state.searchString === '') ? true : false} onClick={() => this.addItem('career')}>Add</button>
                                      </div>
                                      <div className="clear" />

                                      {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="description-text-2 error-color row-5">{this.state.errorMessage}</p>}
                                      {(this.state.successMessage && this.state.successMessage !== '') && <p className="description-text-2 cta-color row-5">{this.state.successMessage}</p>}

                                      {(this.state.searchIsAnimatingCareers) ? (
                                        <div className="flex-container flex-center full-space">
                                          <div>
                                            <div className="super-spacer" />

                                            <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                            <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                            <p className="center-text cta-color bold-text">Searching...</p>

                                          </div>
                                        </div>
                                      ) : (
                                        <div>
                                          <div>
                                            {(this.state.careerOptions && this.state.careerOptions.length > 0) && (
                                              <div className="card top-margin-15">
                                                {this.state.careerOptions.map((value, optionIndex) =>
                                                  <div key={value._id} className="left-text bottom-margin-5 full-width">
                                                    <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'career')}>
                                                      <div className="full-width">
                                                        <div className="fixed-column-40">
                                                          <div className="mini-spacer" />
                                                          <img src={experienceIcon} alt="Compass employer icon icon" className="image-auto-22" />
                                                        </div>
                                                        <div className="calc-column-offset-40">
                                                          <p className="cta-color">{value.name}</p>
                                                        </div>
                                                      </div>
                                                    </button>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                  {(this.state.tagType === 'Opportunities') && (
                                    <div className="container-right">
                                      <div>
                                        <label className="profile-label">Tag Specific Opportunities</label>
                                        <div className="calc-column-offset-70">
                                          <input type="text" className="text-field" placeholder="Search work opportunities..." name="searchOpportunities" value={this.state.searchStringOpportunities} onChange={this.formChangeHandler}></input>
                                        </div>
                                        <div className="fixed-column-70 left-padding">
                                          <button className={(!this.state.searchStringOpportunities || this.state.searchStringOpportunities === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchStringOpportunities || this.state.searchStringOpportunities === '') ? true : false} onClick={() => this.addItem('opportunity')}>Add</button>
                                        </div>
                                        <div className="clear" />
                                      </div>

                                      <div className="clear" />

                                      {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="description-text-2 error-color row-5">{this.state.errorMessage}</p>}
                                      {(this.state.successMessage && this.state.successMessage !== '') && <p className="description-text-2 cta-color row-5">{this.state.successMessage}</p>}

                                      {(this.state.searchIsAnimatingOpportunities) ? (
                                        <div className="flex-container flex-center full-space">
                                          <div>
                                            <div className="super-spacer" />

                                            <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                            <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                            <p className="center-text cta-color bold-text">Searching...</p>

                                          </div>
                                        </div>
                                      ) : (
                                        <div>
                                          <div>
                                            {(this.state.opportunityOptions && this.state.opportunityOptions.length > 0) && (
                                              <div className="card top-margin-15">
                                                {this.state.opportunityOptions.map((value, optionIndex) =>
                                                  <div key={value._id} className="left-text bottom-margin-5 full-width">
                                                    <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'opportunity')}>
                                                      <div className="full-width">
                                                        <div className="fixed-column-40">
                                                          <div className="mini-spacer" />
                                                          <img src={experienceIcon} alt="Compass employer icon icon" className="image-auto-22" />
                                                        </div>
                                                        <div className="calc-column-offset-40">
                                                          <p className="cta-color">{(value.title) ? value.title : value.name}{value.employerName && " | " + value.employerName}</p>
                                                        </div>
                                                      </div>
                                                    </button>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                  {(this.state.tagType === 'Functions') && (
                                    <div className="container-right">
                                      <label className="profile-label">Tag Functions of Interest</label>
                                      <div className="calc-column-offset-70">
                                        <select name="selectedFunction" value={this.state.selectedFunction} onChange={this.formChangeHandler} className="dropdown">
                                          {this.state.functionOptions.map(value =>
                                            <option key={value} value={value}>{value}</option>
                                          )}
                                        </select>
                                      </div>
                                      <div className="fixed-column-70 left-padding">
                                        <button className={(!this.state.selectedFunction || this.state.selectedFunction === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.selectedFunction || this.state.selectedFunction === '') ? true : false} onClick={() => this.addItem('function')}>Add</button>
                                      </div>
                                      <div className="clear" />
                                    </div>
                                  )}
                                  {(this.state.tagType === 'Industries') && (
                                    <div className="container-right">
                                      <label className="profile-label">Tag Industries of Interests</label>
                                      <div className="calc-column-offset-70">
                                        <select name="selectedIndustry" value={this.state.selectedIndustry} onChange={this.formChangeHandler} className="dropdown">
                                          {this.state.industryOptions.map(value =>
                                            <option key={value} value={value}>{value}</option>
                                          )}
                                        </select>
                                      </div>
                                      <div className="fixed-column-70 left-padding">
                                        <button className={(!this.state.selectedIndustry || this.state.selectedIndustry === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.selectedIndustry || this.state.selectedIndustry === '') ? true : false} onClick={() => this.addItem('industry')}>Add</button>
                                      </div>
                                      <div className="clear" />
                                    </div>
                                  )}
                                  {(this.state.tagType === 'Hours per Week') && (
                                    <div className="container-right">
                                      <label className="profile-label">Hours / Week</label>
                                      <div className="calc-column-offset-70">
                                        <select name="selectedHoursPerWeek" value={this.state.selectedHoursPerWeek} onChange={this.formChangeHandler} className="dropdown">
                                          {this.state.hoursPerWeekOptions.map(value =>
                                            <option key={value} value={value}>{value}</option>
                                          )}
                                        </select>
                                      </div>
                                      <div className="fixed-column-70 left-padding">
                                        <button className={(!this.state.selectedHoursPerWeek || this.state.selectedHoursPerWeek === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.selectedHoursPerWeek || this.state.selectedHoursPerWeek === '') ? true : false} onClick={() => this.addItem('hoursPerWeek')}>Add</button>
                                      </div>
                                      <div className="clear" />
                                    </div>
                                  )}
                                  {(this.state.tagType === 'Pay Range') && (
                                    <div className="container-right">
                                      <label className="profile-label">Annualized Pay Range</label>
                                      <div className="calc-column-offset-70">
                                        <select name="selectedPayRange" value={this.state.selectedPayRange} onChange={this.formChangeHandler} className="dropdown">
                                          {this.state.annualPayOptions.map(value =>
                                            <option key={value} value={value}>{value}</option>
                                          )}
                                        </select>
                                      </div>
                                      <div className="fixed-column-70 left-padding">
                                        <button className={(!this.state.selectedPayRange || this.state.selectedPayRange === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.selectedPayRange || this.state.selectedPayRange === '') ? true : false} onClick={() => this.addItem('payRange')}>Add</button>
                                      </div>
                                      <div className="clear" />
                                    </div>
                                  )}
                                  {(this.state.tagType === 'Optimizations') && (
                                    <div className="container-right">
                                      <label className="profile-label">What do you want to optimize for?</label>
                                      <div className="calc-column-offset-70">
                                        <select name="selectedOptimize" value={this.state.selectedOptimize} onChange={this.formChangeHandler} className="dropdown">
                                          {this.state.optimizeOptions.map(value =>
                                            <option key={value} value={value}>{value}</option>
                                          )}
                                        </select>
                                      </div>
                                      <div className="fixed-column-70 left-padding">
                                        <button className={(!this.state.selectedOptimize || this.state.selectedOptimize === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.selectedOptimize || this.state.selectedOptimize === '') ? true : false} onClick={() => this.addItem('optimize')}>Add</button>
                                      </div>
                                      <div className="clear" />
                                    </div>
                                  )}
                                  {(this.state.tagType === 'Competencies') && (
                                    <div className="container-right">
                                      <label className="profile-label">Tag Relevant Skills & Knowledge</label>
                                      <div className="calc-column-offset-70">
                                        <input type="text" className="text-field" placeholder="Search competencies..." name="searchSkills" value={this.state.searchStringCompetencies} onChange={this.formChangeHandler}></input>
                                      </div>
                                      <div className="fixed-column-70 left-padding">
                                        <button className={(!this.state.searchStringCompetencies || this.state.searchStringCompetencies === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchStringCompetencies || this.state.searchStringCompetencies === '') ? true : false} onClick={() => this.addItem('skill')}>Add</button>
                                      </div>
                                      <div className="clear" />

                                      <div className="clear" />

                                      {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="description-text-2 error-color row-5">{this.state.errorMessage}</p>}
                                      {(this.state.successMessage && this.state.successMessage !== '') && <p className="description-text-2 cta-color row-5">{this.state.successMessage}</p>}

                                      {(this.state.searchIsAnimatingCompetencies) ? (
                                        <div className="flex-container flex-center full-space">
                                          <div>
                                            <div className="super-spacer" />

                                            <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                            <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                            <p className="center-text cta-color bold-text">Searching...</p>

                                          </div>
                                        </div>
                                      ) : (
                                        <div>
                                          <div>
                                            {(this.state.competencyOptions) && (
                                              <div className="card top-margin-15">
                                                {this.state.competencyOptions.map((value, optionIndex) =>
                                                  <div key={value._id} className="left-text bottom-margin-5 full-width">
                                                    <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'competency')}>
                                                      <div className="full-width">
                                                        <div className="fixed-column-40">
                                                          <div className="half-spacer" />
                                                          <img src={skillsIcon} alt="Compass employer icon icon" className="image-auto-22" />
                                                        </div>
                                                        <div className="calc-column-offset-40">
                                                          <p className="cta-color">{value.name}</p>
                                                          <p className="description-text-2 description-text-color">{value.type}</p>
                                                        </div>
                                                      </div>
                                                    </button>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )}

                                  <div className="clear" />

                                  <div>
                                    {this.renderTags('all')}
                                  </div>
                                </div>

                              </div>
                            </div>
                          )}
                        </div>

                        {(this.state.goalType && this.state.goalType.name !== '') && (
                          <div>
                            <div>
                              <div className="row-15">
                                <label className="profile-label clear-padding clear-margin">Tag Supporters</label>
                                <p className="profile-descriptor top-margin">Supporters of your goal will be notified as you make progress, and can provide resources/advice.</p>

                                <div className="row-10">
                                  <div className="calc-column-offset-70">
                                    <input type="text" className="text-field" placeholder="Search members..." name="searchMembers" value={this.state.searchStringMembers} onChange={this.formChangeHandler}></input>
                                  </div>
                                  <div className="fixed-column-70 left-padding">
                                    <button className={(!this.state.searchStringMembers || this.state.searchStringMembers === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchStringMembers || this.state.searchStringMembers === '') ? true : false} onClick={() => this.addItem('member')}>Add</button>
                                  </div>
                                  <div className="clear" />
                                </div>

                                <div className="clear" />

                                {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="description-text-2 error-color row-5">{this.state.errorMessage}</p>}
                                {(this.state.successMessage && this.state.successMessage !== '') && <p className="description-text-2 cta-color row-5">{this.state.successMessage}</p>}

                                {(this.state.searchIsAnimatingMembers) ? (
                                  <div className="flex-container flex-center full-space">
                                    <div>
                                      <div className="super-spacer" />

                                      <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                      <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                      <p className="center-text cta-color bold-text">Searching...</p>

                                    </div>
                                  </div>
                                ) : (
                                  <div>
                                    <div>
                                      {(this.state.memberOptions && this.state.memberOptions.length > 0) && (
                                        <div className="card top-margin-15">
                                          {this.state.memberOptions.map((value, optionIndex) =>
                                            <div key={value._id} className="left-text bottom-margin-5 full-width">
                                              <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'member')}>
                                                <div className="full-width">
                                                  <div className="fixed-column-40">
                                                    <div className="mini-spacer" />
                                                    <img src={profileIconDark} alt="GC" className="image-auto-22" />
                                                  </div>
                                                  <div className="calc-column-offset-40">
                                                    <p className="cta-color">{value.firstName} {value.lastName}</p>
                                                  </div>
                                                </div>
                                              </button>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>

                                    <div>

                                      {this.renderTags('member')}
                                      <div className="clear" />

                                    </div>

                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="row-20">
                              <hr />
                            </div>

                            <div className="row-15 top-margin">
                              <p className="heading-text-5">Track Progress</p>
                            </div>
                          </div>
                        )}

                        {(this.state.goalType && this.state.goalType.name !== '') && (
                          <div className="row-15">
                            <div>
                              <div className="float-left">
                                <label className="profile-label">Checklist</label>
                              </div>
                              <div className="float-left left-padding top-padding">
                                <button className="background-button" onClick={() => this.addItem('checklist')}>
                                  <div className="padding-5 cta-border circle-corners">
                                    <img src={addIcon} alt="Compass target icon" className="image-auto-10" />
                                  </div>
                                </button>
                              </div>
                              <div className="clear" />
                            </div>

                            {(this.state.checklist && this.state.checklist.length > 0) ? (
                              <div>
                                {this.state.checklist.map((item, index) =>
                                  <div className="top-margin-15">
                                    <div>
                                      {(item.editMode) ? (
                                        <span className="calc-column-offset-80">
                                          <div className="relative-column-33 right-padding-5">
                                            <input type="text" className="text-field description-text-2" placeholder="Name this item" name={"checklist|name|" + index} value={item.name} onChange={this.formChangeHandler}></input>
                                          </div>
                                          <div className="relative-column-33 left-padding-5 right-padding-5">
                                            <input type="text" className="text-field description-text-2" placeholder="Add a link to your item" name={"checklist|url|" + index} value={item.url} onChange={this.formChangeHandler}></input>
                                            {(item.url && item.url !== '' && !item.url.startsWith('http')) && (
                                              <div className="top-padding-5">
                                                <p className="error-color description-text-2">Please add a valid link that starts with http</p>
                                              </div>
                                            )}
                                          </div>
                                          <div className="relative-column-33 left-padding-5">
                                            <select name={"checklist|category|" + index} value={item.category} onChange={this.formChangeHandler} className="white-background description-text-2">
                                              {this.state.checklistCategoryOptions.map(value =>
                                                <option key={value} value={value}>{value}</option>
                                              )}
                                            </select>
                                          </div>
                                        </span>
                                      ) : (
                                        <span>
                                          <div className="fixed-column-40 left-padding">
                                            <button className="background-button" onClick={() => this.editItem(index,'checklist','checked')}>
                                              <img src={(item.checked) ? checkboxChecked : checkboxEmpty} alt="GC" className="image-auto-22" />
                                            </button>
                                          </div>
                                          <div className="calc-column-offset-160 left-padding">
                                            {(item.url) ? (
                                              <a href={item.url} target="_blank" rel="nopener noreferrer">{item.name}</a>
                                            ) : (
                                              <p>{item.name}</p>
                                            )}
                                          </div>
                                          <div className="fixed-column-40" >
                                            <img src={this.renderChecklistIcon(item)} alt="GC" className="image-auto-20" data-tooltip-id="tooltip-placeholder-id" data-tooltip-content={"Item Type: " + item.category} />
                                            {/*<p className="description-text-2">[{item.category}]</p>*/}
                                          </div>
                                        </span>
                                      )}

                                      <div className={(item.editMode) ? "fixed-column-40 top-margin-7" : "fixed-column-40"} >
                                        <button className="background-button top-margin-negative-3" onClick={() => this.editItem(index,'checklist','editMode')}>
                                          <div className="padding-7 cta-border circle-radius" data-tooltip-id="tooltip-placeholder-id" data-tooltip-content={(item.editMode) ? "Close Edit Mode" : "Edit"}>
                                            <img src={(item.editMode) ? saveIconDark : editIconBlue} alt="GC" className="image-auto-9" />
                                          </div>
                                        </button>
                                      </div>
                                      <div className={(item.editMode) ? "fixed-column-40 top-margin-7" : "fixed-column-40"} >
                                        <button className="background-button top-margin-negative-3" onClick={() => this.addRemoveItems('Remove', index,'checklist')}>
                                          <div className="padding-7 error-border circle-radius" data-tooltip-id="tooltip-placeholder-id" data-tooltip-content="Delete">
                                            <img src={xIcon} alt="GC" className="image-auto-9" />
                                          </div>
                                        </button>
                                      </div>
                                      <div className="clear" />
                                    </div>
                                  </div>
                                )}
                                <ReactTooltip id="tooltip-placeholder-id" />
                              </div>
                            ) : (
                              <div className="row-10">
                                <p className="description-text-2 description-text-color">You haven't listed any checklist items yet.</p>
                              </div>
                            )}
                          </div>
                        )}

                        {(this.state.editExisting) && (
                          <div>

                            <div className="row-15">
                              <div>
                                <div className="float-left">
                                  <label className="profile-label">Add Progress</label>
                                </div>
                                <div className="float-left left-padding top-padding">
                                  <button className="background-button" onClick={() => this.addItem('progress')}>
                                    <div className="padding-5 cta-border circle-corners">
                                      <img src={addIcon} alt="Compass target icon" className="image-auto-10" />
                                    </div>
                                  </button>
                                </div>
                                <div className="clear" />
                              </div>

                              {(this.state.progress && this.state.progress.length > 0) ? (
                                <div>
                                  {this.state.progress.map((item, index) =>
                                    <div className="top-margin-15">
                                      <div>
                                        <div className="fixed-column-30 top-padding" >
                                          <button className="background-button" onClick={() => this.addRemoveItems('Remove', index,'progress')}>
                                            <img src={deniedIcon} alt="GC" className="image-auto-20" />
                                          </button>
                                        </div>
                                        <div className="fixed-column-170" >
                                          <input type="date" className="date-picker white-background" name={"progress|date|" + index} value={item.date} onChange={this.formChangeHandler}></input>
                                        </div>
                                        <div className="calc-column-offset-200 left-padding">
                                          <input type="text" className="text-field" placeholder="(e.g., I got an interview from Google!)" name={"progress|value|" + index} value={item.value} onChange={this.formChangeHandler}></input>
                                        </div>
                                        <div className="clear" />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div className="row-10">
                                  <p className="description-text-2 description-text-color">You haven't listed any progress yet.</p>
                                </div>
                              )}
                            </div>

                            {(this.state.goalType.description === 'Choose from alternatives') ? (
                              <div className="row-15">
                                <div>
                                  <div className="row-15">
                                    <label className="profile-label clear-padding">Decision</label>
                                    {(this.state.pollConnections) && (
                                      <label className="profile-descriptor error-color">Participants of the poll will automatically be notified of your decision at the deadline</label>
                                    )}
                                  </div>
                                  <select className="dropdown" name="goalDecision" value={this.state.goalDecision} onChange={this.formChangeHandler}>
                                      <option />
                                      <option value={"Option A: " + this.state.aName}>{"Option A: " + this.state.aName}</option>
                                      <option value={"Option B: " + this.state.bName}>{"Option B: " + this.state.bName}</option>
                                  </select>
                                </div>
                              </div>
                            ) : (
                              <div>
                                <div className="row-15">
                                  <div className="container-left">
                                    <label className="profile-label">Status</label>
                                    <select className="dropdown" name="goalStatus" value={this.state.goalStatus} onChange={this.formChangeHandler}>
                                        <option />
                                        <option value="Not Started">Not Started</option>
                                        <option value="In Progress">In Progress</option>
                                        <option value="Achieved">Achieved</option>
                                    </select>
                                  </div>
                                  {(this.state.goalStatus === 'Achieved') && (
                                    <div className="container-right">
                                      <label className="profile-label">Date Achieved</label>
                                      <div>
                                        <input type="datetime-local" className="date-picker white-background" name="dateAchieved" value={this.state.dateAchieved} min={this.state.goalStartDate} max={this.state.minTargetDate} onChange={this.formChangeHandler}></input>
                                      </div>
                                      {/*
                                      <div className="fixed-column-70 left-padding">
                                        <button className={(this.state.unready) ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={this.state.unready} onClick={() => this.addItem('goal')}>Add</button>
                                      </div>*/}
                                      <div className="clear" />
                                    </div>
                                  )}
                                  <div className="clear" />
                                </div>

                                {(this.state.goalStatus === 'Achieved') && (
                                  <div>
                                    <div className="row-15">
                                      <label className="profile-label">Details of How you Achieved your Goal<label className="error-color">*</label></label>
                                      <textarea className="text-field" type="text" placeholder="Describe how you achieved your goal..." name={"successDescription"} value={this.state.successDescription} onChange={this.formChangeHandler} />
                                    </div>

                                    <div className="row-15">
                                      <label className="profile-label">Permission to Share Your Success Story<label className="error-color">*</label></label>
                                      <Switch
                                        onChange={(change) => this.setState({ permissionToShare: change, formHasChanged: true })}
                                        checked={this.state.permissionToShare}
                                        id="normal-switch"
                                      />
                                      {(this.state.permissionToShare) && (
                                        <p className="description-text-2 cta-color top-margin-20">Thank you for being an inspiration for others!</p>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}

                            <div className="clear" />
                            <div className="spacer" />

                          </div>
                        )}

                        {(this.state.goalType && this.state.goalType.name !== '') && (
                          <div>
                            <div className="row-20">
                              <hr />
                            </div>

                            <div className="row-15 top-margin">
                              <div className="calc-column-offset-30">
                                <p className="heading-text-5">Auto-Generate a Plan</p>
                              </div>
                              <div className="fixed-column-30">
                                <div className="float-left noti-bubble-info-7-9">
                                  <a className="background-link" onClick={() => this.setState({ modalIsOpen: true, showAIPlanExplanation: true })}>
                                    <img src={questionMarkBlue} alt="GC" className="image-auto-14 center-item" />
                                  </a>
                                </div>
                              </div>

                              <div className="clear" />
                            </div>

                            <div className="row-15">
                              <p>Get an AI-generated plan for your goal sent to your email and saved as a document to your profile.</p>
                            </div>

                            <div className="row-15">
                              <div className="standard-border padding-20">
                                <div className="row-5 bottom-margin">
                                  <div className="float-left right-padding top-margin-3">
                                    <p>AI Credits</p>
                                  </div>
                                  <div className="float-left noti-bubble-info-7-9">
                                    <a className="background-link" onClick={() => this.setState({ modalIsOpen: true, showAICreditExplanation: true })}>
                                      <img src={questionMarkBlue} alt="GC" className="image-auto-14 center-item" />
                                    </a>
                                  </div>
                                  <div className="clear" />
                                </div>

                                <p className="row-5 description-text-2">Generate a plan for: <label className="bold-text cta-color">10</label> AI credits</p>
                                <p className="row-5 description-text-2">Available AI credits: <label className="bold-text cta-color">{this.state.startingCredits - this.state.creditsUsed}</label></p>
                              </div>
                            </div>

                            <div className="row-15">
                              <label className="profile-label">Would you like to auto-generate a plan to achieve this goal?</label>
                              <Switch
                                onChange={(change) => this.setState({ autoGeneratePlan: change, formHasChanged: true })}
                                checked={this.state.autoGeneratePlan}
                                id="normal-switch"
                              />
                            </div>

                            {(this.state.autoGeneratePlan) && (
                              <div className="row-15">
                                <p className="cta-color description-text-2">Great! Save your goal below to auto-generate your plan. An email will be sent to you when it is ready.</p>
                              </div>
                            )}

                          </div>
                        )}

                        {(this.state.goalType.description) && (
                          <div className="row-20">
                            <hr />
                          </div>
                        )}
                      </div>
                    )}

                    {(this.state.currentPage === 'Suggestions') && (
                      <div >
                        <div>
                          <p className="top-margin-20 bottom-margin-20"><label className="cta-color">Suggestions</label> include suggestions, resources, and other acts of help sent to help you achieve this goal</p>
                          <hr />
                        </div>

                        {(this.state.suggestions && this.state.suggestions.length > 0) ? (
                          <div className="top-margin-20">
                            {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="error-color description-text-2 row-5">{this.state.errorMessage}</p>}
                            {(this.state.successMessage && this.state.successMessage !== '') && <p className="cta-color description-text-2 row-5">{this.state.successMessage}</p>}

                            {this.state.suggestions.map((item, optionIndex) =>
                              <div key={item}>
                                <SubRenderSuggestion history={this.props.navigate}
                                  suggestion={item} index={optionIndex}
                                  inModal={null} sideNav={null} suggestions={this.state.suggestions}
                                  closeModal={this.closeModal}
                                />
                              </div>
                            )}
                            <div className="clear" />
                          </div>
                        ) : (
                          <div>
                            <div className="row-15">
                              <p className="error-color">You have not received suggestions yet.</p>
                            </div>

                            {(this.state.editExisting && !this.state.remoteAuth) && (
                              <div className="row-15">

                                {(this.state.publicProfile && this.state.publicProfileExtent && this.state.publicPreferences && this.state.publicPreferences[2] && (this.state.publicPreferences[2].value === 'All' || this.state.publicPreferences[2].value === 'Some')) ? (
                                  <div className="standard-border padding-20">
                                    <p className="description-text-1">Share this link to crowdsource resources for this goal: <a href={window.location.protocol + "//" + window.location.host + '/goals/' + this.state.goalId} target="_blank" rel="noopener noreferrer" className="wrap-word">{window.location.protocol + "//" + window.location.host + '/goals/' + this.state.goalId}</a>.</p><p>If you want to make your goal private, you can do so <Link to={this.state.prefix + "/edit-profile/public-preferences"}>here</Link>.</p>
                                  </div>
                                ) : (
                                  <div className="standard-border padding-20">
                                    <p className="description-text-1">To crowdsource resources for this goal, make it public <Link to={this.state.prefix + "/edit-profile/public-preferences"}>here</Link>, then share this link: <a href={window.location.protocol + "//" + window.location.host + '/goals/' + this.state.goalId} target="_blank" rel="noopener noreferrer" className="wrap-word">{window.location.protocol + "//" + window.location.host + '/goals/' + this.state.goalId}</a>.</p>
                                  </div>
                                )}
                              </div>
                            )}

                          </div>
                        )}
                      </div>
                    )}

                    {(this.state.currentPage === 'People') && (
                      <div>
                        <div>
                          <p className="top-margin-20 bottom-margin-20"><label className="cta-color">People</label> who have similar goals</p>
                          <hr />
                        </div>

                        <SubPeopleMatching history={this.props.navigate} userType={"Peers"} pageSource="Goal" selectedGoal={this.state.selectedGoal} />
                      </div>
                    )}

                    {(this.state.currentPage === 'Courses') && (
                      <div>
                        <div>
                          <p className="top-margin-20 bottom-margin-20"><label className="cta-color">Courses</label> that teach the relevant competencies tagged in your goal</p>
                          <hr />
                        </div>

                        {(this.state.competencies && this.state.competencies.length > 0) ? (
                          <SubCourses history={this.props.navigate} activeOrg={this.state.activeOrg} selectedGoal={this.state.selectedGoal} competencies={this.state.competencies} subNavSelected="Browse" pageSource="Goal"/>
                        ) : (
                          <div>
                            <p className="error-color top-margin-20">You have not tagged any competencies (skills & knowledge) in your goal</p>
                          </div>
                        )}

                      </div>
                    )}

                    {(this.state.currentPage === 'Careers') && (
                      <div>
                        <div>
                          <p className="top-margin-20 bottom-margin-20"><label className="cta-color">Careers</label> are any career paths that match this goal</p>
                          <hr />
                        </div>
                        <SubCareers history={this.props.navigate} calculateMatches={this.state.calculateMatches} pageSource="Goal" selectedGoal={this.state.selectedGoal} />
                      </div>
                    )}

                    {(this.state.currentPage === 'Events') && (
                      <div>
                        <div>
                          <p className="top-margin-20 bottom-margin-20"><label className="cta-color">Events</label> include any career events that align with this goal</p>
                          <hr />
                        </div>

                        <SubOpportunities calculateMatches={this.state.calculateMatches} activeOrg={this.state.activeOrg} passedSubNavSelected={"Events"} changeSubNavSelected={this.changeSubNavSelected} pageSource="Goal" selectedGoal={this.state.selectedGoal} />
                      </div>
                    )}

                    {(this.state.currentPage === 'Projects') && (
                      <div>
                        <div>
                          <p className="top-margin-20 bottom-margin-20"><label className="cta-color">Projects</label> include any project opportunities that align with this goal</p>
                          <hr />
                        </div>

                        <SubOpportunities calculateMatches={this.state.calculateMatches} activeOrg={this.state.activeOrg} passedSubNavSelected={"Projects"} changeSubNavSelected={this.changeSubNavSelected} pageSource="Goal" selectedGoal={this.state.selectedGoal} />
                      </div>
                    )}

                    {(this.state.currentPage === 'Work') && (
                      <div>
                        <div>
                          <p className="top-margin-20 bottom-margin-20"><label className="cta-color">Work</label> include any work opportunities that align with this goal</p>
                          <hr />
                        </div>

                        <SubOpportunities calculateMatches={this.state.calculateMatches} activeOrg={this.state.activeOrg} passedSubNavSelected={"Work"} changeSubNavSelected={this.changeSubNavSelected} pageSource="Goal" selectedGoal={this.state.selectedGoal} />
                      </div>
                    )}

                  </div>
                )}

                {(this.state.logType === 'Meeting') && (
                  <div>
                    <div>
                      <div className="spacer" />

                      <div className="row-10">
                        <div className="container-left">
                          <label className="profile-label">Starts<label className="error-color">*</label></label>
                          <input type="datetime-local" className="date-picker" placeholder="Start date" name="startTime" value={this.state.startTime} onChange={this.formChangeHandler}></input>
                        </div>
                        <div className="container-right">
                          <label className="profile-label">Ends<label className="error-color">*</label></label>
                          <input type="datetime-local" className="date-picker" placeholder="End date" name="endTime" value={this.state.endTime} onChange={this.formChangeHandler}></input>
                        </div>
                        <div className="clear" />
                      </div>

                      <div className="row-10">
                        <div className="container-left">
                          <label className="profile-label">Meeting Method<label className="error-color">*</label></label>
                          <select className="dropdown" name="method" value={this.state.method} onChange={this.formChangeHandler}>
                              <option />
                              <option value="In Person">In Person</option>
                              <option value="Remote">Remote</option>
                          </select>
                        </div>
                        <div className="container-right">
                          <label className="profile-label">{(this.state.method === "In Person") ? "Location" : "Meeting Link"}<label className="error-color">*</label></label>
                          <input type="text" className="text-field" placeholder={(this.state.method === "In Person") ? "Address..." : "Http..."} name="location"  value={this.state.location} onChange={this.formChangeHandler}></input>
                          {(this.state.method !== "In Person" && this.state.location && this.state.location !== '' && !this.state.location.startsWith('http')) && (
                            <div className="top-padding-5">
                              <p className="error-color description-text-2">Please add a valid link that starts with http</p>
                            </div>
                          )}
                        </div>
                        <div className="clear" />
                      </div>

                      <div className="row-10">
                        <div className="container-left">
                          <label className="profile-label">Repeats</label>
                          <select name="repeats" value={this.state.repeats} onChange={this.formChangeHandler} className="dropdown">
                            {this.state.repeatOptions.map(value =>
                              <option key={value} value={value}>{value}</option>
                            )}
                          </select>
                        </div>
                        {/*
                        <div className="container-right">
                          <label className="profile-label">Reminder</label>
                          <select name="reminder" value={this.state.reminder} onChange={this.formChangeHandler} className="dropdown">
                            {this.state.reminderOptions.map(value =>
                              <option key={value} value={value}>{value}</option>
                            )}
                          </select>
                        </div>*/}
                        <div className="clear" />
                      </div>

                      {(this.state.editExisting) && (
                        <div className="row-10">
                          <label className="profile-label">Tag Attendees</label>
                          <div>
                            <div className="calc-column-offset-70">
                              <input type="text" className="text-field" placeholder="Search members..." name="searchMembers" value={this.state.searchStringMembers} onChange={this.formChangeHandler}></input>
                            </div>
                            <div className="fixed-column-70 left-padding">
                              <button className={(!this.state.searchStringMembers || this.state.searchStringMembers === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchStringMembers || this.state.searchStringMembers === '') ? true : false} onClick={() => this.addItem('member')}>Add</button>
                            </div>
                            <div className="clear" />
                          </div>

                          {(this.state.searchIsAnimatingMembers) ? (
                            <div className="flex-container flex-center full-space">
                              <div>
                                <div className="super-spacer" />

                                <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                <p className="center-text cta-color bold-text">Searching...</p>

                              </div>
                            </div>
                          ) : (
                            <div>
                              <div>
                                {(this.state.memberOptions && this.state.memberOptions.length > 0) && (
                                  <div className="card top-margin">
                                    {this.state.memberOptions.map((value, optionIndex) =>
                                      <div key={value._id} className="left-text bottom-margin-5 full-width">
                                        <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'member')}>
                                          <div className="full-width">
                                            <div className="fixed-column-40">
                                              <div className="mini-spacer" />
                                              <img src={profileIconDark} alt="GC" className="image-auto-22" />
                                            </div>
                                            <div className="calc-column-offset-40">
                                              <p className="cta-color">{value.firstName} {value.lastName}</p>
                                            </div>
                                          </div>
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>

                              <div>

                                {this.renderTags('member')}
                                <div className="clear" />

                              </div>

                            </div>
                          )}
                        </div>
                      )}

                      <div className="row-10">
                        <label className="profile-label">Description<label className="error-color">*</label></label>
                        <textarea type="text" className="text-field" placeholder="Why are we having this meeting? What will we discuss?" name="description" value={this.state.description} onChange={this.formChangeHandler}></textarea>
                      </div>

                      <div className="row-10">
                        <div>
                          <div className="float-left">
                            <label className="profile-label">Links / Resources</label>
                          </div>
                          <div className="float-left left-padding top-padding">
                            <button className="background-button" onClick={() => this.addItem('link')}>
                              <div className="padding-5 cta-border circle-corners">
                                <img src={addIcon} alt="Compass target icon" className="image-auto-10" />
                              </div>
                            </button>
                          </div>
                          <div className="clear" />

                          {(this.state.links && this.state.links.length > 0) && (
                            <div>
                              {this.state.links.map((item, index) =>
                                <div className="top-margin">
                                  <div>
                                    <div className="fixed-column-35 top-padding" >
                                      <button className="background-button" onClick={() => this.addRemoveItems('Remove', index,'link')}>
                                        <img src={deniedIcon} alt="GC" className="image-auto-20" />
                                      </button>
                                    </div>
                                    <div className="calc-column-offset-35">
                                      <input type="text" className="text-field" placeholder="http..." name={"link|" + index} value={item} onChange={this.formChangeHandler}></input>
                                      {(item !== '' && !item.startsWith('http')) && (
                                        <div className="top-padding-5">
                                          <p className="error-color description-text-2">Please add a valid link that starts with http</p>
                                        </div>
                                      )}
                                    </div>
                                    <div className="clear" />
                                  </div>
                                </div>
                              )}
                            </div>
                          )}

                        </div>
                      </div>

                      {(this.state.editExisting) && (
                        <div>
                          <div className="row-10">
                            <label className="profile-label">Minutes</label>
                            <textarea type="text" className="text-field" placeholder="What did we did we discuss in this meeting? What are the action items?" name="notes" value={this.state.notes} onChange={this.formChangeHandler}></textarea>
                          </div>

                          <div className="row-10">
                            <div>
                              <div className="float-left">
                                <label className="profile-label">Action Items</label>
                              </div>
                              <div className="float-left left-padding top-padding">
                                <button className="background-button" onClick={() => this.addItem('actionItem')}>
                                  <img src={addIcon} alt="Compass target icon" className="image-auto-15" />
                                </button>
                              </div>
                              <div className="clear" />

                              {(this.state.actionItems && this.state.actionItems.length > 0) && (
                                <div>
                                  {this.state.actionItems.map((item, index) =>
                                    <div className="top-margin">
                                      <div>
                                        <div className="fixed-column-35 top-padding" >
                                          <button className="background-button" onClick={() => this.addRemoveItems('Remove', index,'actionItem')}>
                                            <img src={deniedIcon} alt="GC" className="image-auto-20" />
                                          </button>
                                        </div>
                                        <div className="calc-column-offset-35">
                                          <input type="text" className="text-field" placeholder="What should we do next..." name={"actionItem|" + index} value={item} onChange={this.formChangeHandler}></input>
                                        </div>
                                        <div className="clear" />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="spacer" />
                      <hr />
                      <div className="spacer" />
                    </div>
                  </div>
                )}

                {(this.state.logType === 'Session' || this.state.logType === 'Check In') && (
                  <div>
                    <div>
                      {(window.location.pathname.includes('/app')) && (
                        <div>
                          {(this.state.remoteAuth) ? (
                            <div className="row-10">
                              <label className="profile-label">Add a Career Advisor<label className="error-color">*</label></label>
                              <div>
                                <div className="calc-column-offset-70">
                                  <input type="text" className="text-field" placeholder="Search teachers, mentors, and advisors in this org..." name="searchAdvisors" value={this.state.searchStringMembers} onChange={this.formChangeHandler}></input>
                                </div>
                                <div className="fixed-column-70 left-padding">
                                  <button className={(!this.state.searchStringMembers || this.state.searchStringMembers === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchStringMembers || this.state.searchStringMembers === '') ? true : false} onClick={() => this.addItem('advisor')}>Add</button>
                                </div>
                                <div className="clear" />
                              </div>

                              {(this.state.searchIsAnimatingMembers) ? (
                                <div className="flex-container flex-center full-space">
                                  <div>
                                    <div className="super-spacer" />

                                    <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                    <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                    <p className="center-text cta-color bold-text">Searching...</p>

                                  </div>
                                </div>
                              ) : (
                                <div>
                                  <div>
                                    {(this.state.memberOptions && this.state.memberOptions.length > 0) && (
                                      <div className="card top-margin">
                                        {this.state.memberOptions.map((value, optionIndex) =>
                                          <div key={value._id} className="left-text bottom-margin-5 full-width">
                                            <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'member')}>
                                              <div className="full-width">
                                                <div className="fixed-column-40">
                                                  <div className="mini-spacer" />
                                                  <img src={profileIconDark} alt="GC" className="image-auto-22" />
                                                </div>
                                                <div className="calc-column-offset-40">
                                                  <p className="cta-color">{value.firstName} {value.lastName}</p>
                                                </div>
                                              </div>
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>

                                  <div>

                                    {this.renderTags('member')}
                                    <div className="clear" />

                                  </div>

                                </div>
                              )}
                            </div>
                          ) : (
                            <div>
                              <div className="row-10">
                                <div className="container-left">
                                  <label className="profile-label">Advisor First Name<label className="error-color">*</label></label>
                                  <input className="text-field" type="text" placeholder="e.g., Jon" name="advisorFirstName" value={this.state.advisorFirstName} onChange={this.formChangeHandler} />
                                </div>
                                <div className="container-right">
                                  <label className="profile-label">Advisor Last Name<label className="error-color">*</label></label>
                                  <input className="text-field" type="text" placeholder="e.g., Doe" name="advisorLastName" value={this.state.advisorLastName} onChange={this.formChangeHandler} />
                                </div>
                                <div className="clear" />
                              </div>

                              <div className="row-10">
                                <div className="container-left">
                                  <label className="profile-label">Advisor Email<label className="error-color">*</label></label>
                                  <input className="text-field" type="text" placeholder="e.g., jondoe@gmail.com" name="advisorEmail" value={this.state.advisorEmail} onChange={this.formChangeHandler} />
                                </div>
                                <div className="clear" />
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {(!window.location.pathname.includes('/app')) && (
                        <div>
                          {(this.state.forceSelection) ? (
                            <div>
                              <label className="profile-label">Add an Advisee <label className="error-color">*</label></label>
                              <div>
                                <div className="calc-column-offset-70">
                                  <input type="text" className="text-field" placeholder="Search career-seekers..." name="searchAdvisees" value={this.state.searchStringAdvisees} onChange={this.formChangeHandler}></input>
                                </div>
                                <div className="fixed-column-70 left-padding">
                                  <button className={(!this.state.searchStringAdvisees || this.state.searchStringAdvisees === '') ? "btn btn-squarish medium-background standard-border" : "btn btn-squarish"} disabled={(!this.state.searchStringAdvisees || this.state.searchStringAdvisees === '') ? true : false} onClick={() => this.addItem('advisee')}>Add</button>
                                </div>
                                <div className="clear" />
                              </div>

                              {(this.state.searchIsAnimatingAdvisees) ? (
                                <div className="flex-container flex-center full-space">
                                  <div>
                                    <div className="super-spacer" />

                                    <img src={loadingGIF} alt="Compass loading gif icon" className="image-auto-80 center-horizontally"/>
                                    <div className="spacer" /><div className="spacer" /><div className="spacer" />
                                    <p className="center-text cta-color bold-text">Searching...</p>

                                  </div>
                                </div>
                              ) : (
                                <div>
                                  <div>
                                    {(this.state.adviseeOptions && this.state.adviseeOptions.length > 0) && (
                                      <div className="card top-margin">
                                        {this.state.adviseeOptions.map((value, optionIndex) =>
                                          <div key={value._id} className="left-text bottom-margin-5 full-width">
                                            <button className="background-button full-width row-5 left-text" onClick={() => this.searchItemClicked(value, 'advisee')}>
                                              <div className="full-width">
                                                <div className="fixed-column-40">
                                                  <div className="mini-spacer" />
                                                  <img src={profileIconDark} alt="GC" className="image-auto-22" />
                                                </div>
                                                <div className="calc-column-offset-40">
                                                  <p className="cta-color">{value.firstName} {value.lastName}</p>
                                                </div>
                                              </div>
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>

                                  <div>

                                    {this.renderTags('advisee')}
                                    <div className="clear" />

                                  </div>

                                </div>
                              )}
                            </div>
                          ) : (
                            <div>
                              <div className="row-10">
                                <div className="container-left">
                                  <label className="profile-label">Advisee First Name<label className="error-color">*</label></label>
                                  <input className="text-field" type="text" placeholder="e.g., Jon" name="adviseeFirstName" value={this.state.adviseeFirstName} onChange={this.formChangeHandler} />
                                </div>
                                <div className="container-right">
                                  <label className="profile-label">Advisee Last Name<label className="error-color">*</label></label>
                                  <input className="text-field" type="text" placeholder="e.g., Doe" name="adviseeLastName" value={this.state.adviseeLastName} onChange={this.formChangeHandler} />
                                </div>
                                <div className="clear" />
                              </div>

                              <div className="row-10">
                                <div className="container-left">
                                  <label className="profile-label">Advisee Email<label className="error-color">*</label></label>
                                  <input className="text-field" type="text" placeholder="e.g., jondoe@gmail.com" name="adviseeEmail" value={this.state.adviseeEmail} onChange={this.formChangeHandler} />
                                </div>
                                <div className="clear" />
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                      {(!this.state.editExisting && !window.location.pathname.includes('/organizations/')) && (
                        <div>
                          <div className="row-10 description-text-1">
                            {(window.location.pathname.includes('/app')) ? (
                              <div>
                                {(this.state.remoteAuth) ? (
                                  <p><label className="error-color bold-text">Note:</label> The advisor will be notified. Additionally, the teacher, work-based learning coordinator, or mentor will be able to view / edit this session from their portal.</p>
                                ) : (
                                  <p><label className="error-color bold-text">Note:</label> The advisor will be notified. Additionally, if the advisor signs up as a teacher, work-based learning coordinator, or mentor, they will be able to view / edit this session from their portal.</p>
                                )}
                              </div>
                            ) : (
                              <div>
                                <p><label className="error-color bold-text">Note:</label> The advisee will be notified and will be able to edit details from their portal.</p>
                              </div>
                            )}
                          </div>
                          <hr />
                        </div>
                      )}

                      <div className="row-10">
                        <div className="container-left">
                          <label className="profile-label">Session Date<label className="error-color">*</label></label>
                          <input type="datetime-local" className="date-picker" placeholder="Session date" name="sessionDate" value={this.state.sessionDate} onChange={this.formChangeHandler}></input>
                        </div>

                        <div className="container-right">
                          <label className="profile-label">Meeting Method<label className="error-color">*</label></label>
                          <select className="dropdown" name="sessionMethod" value={this.state.sessionMethod} onChange={this.formChangeHandler}>
                              <option />
                              <option value="In Person">In Person</option>
                              <option value="Video Call">Video Call</option>
                              <option value="Phone Call">Phone Call</option>
                              <option value="Text Message / Chat">Messaging / Chat</option>
                              <option value="Email">Email</option>
                          </select>
                        </div>

                        <div className="clear" />
                      </div>

                      {(this.state.meetingPurposeOptions && this.state.meetingPurposeOptions.length > 0) ? (
                        <div className="row-10">
                          <div className="container-left">
                            <label className="profile-label">Meeting Purpose <label className="error-color">*</label></label>
                            <select className="dropdown" name="meetingPurpose" value={this.state.meetingPurpose} onChange={this.formChangeHandler}>
                              {this.state.meetingPurposeOptions.map(value => <option key={value.name} value={value.name}>{value.name}</option>)}
                            </select>
                          </div>

                          {(this.state.meetingPurpose && this.state.meetingOutcomeOptions && this.state.meetingOutcomeOptions.length > 0) && (
                            <div className="container-right">
                              <label className="profile-label">Meeting Outcome <label className="error-color">*</label></label>
                              <select className="dropdown" name="meetingOutcome" value={this.state.meetingOutcome} onChange={this.formChangeHandler}>
                                {this.state.meetingOutcomeOptions.map(value => <option key={value} value={value}>{value}</option>)}
                              </select>
                            </div>
                          )}

                          <div className="clear" />
                        </div>
                      ) : (
                        <div className="row-10">
                          <label className="profile-label">What category does this fall into?<label className="error-color">*</label></label>
                          <select className="dropdown" name="category" value={this.state.category} onChange={this.formChangeHandler}>
                            {this.state.meetingCategoryOptions.map(value => <option key={value} value={value}>{value}</option>)}
                          </select>
                        </div>
                      )}

                      {(this.state.meetingTagOptions && this.state.meetingTagOptions.length > 1) && (
                        <div className="row-10">
                          <label className="profile-label">Meeting Tags/Activity Codes <label className="error-color">*</label></label>
                          <select className="dropdown" name="meetingTags" value={this.state.meetingTags} onChange={this.formChangeHandler}>
                            {this.state.meetingTagOptions.map(value => <option key={value.name} value={value.name}>{value.name}</option>)}
                          </select>
                        </div>
                      )}

                      {(window.location.pathname.includes('/organizations')) && (
                        <div className="row-10">
                          <label className="profile-label">Hidden to Advisee (i.e., Not Visible)</label>
                          <Switch
                            onChange={(change) => this.setState({ hiddenToCareerSeeker: change, formHasChanged: true })}
                            checked={this.state.hiddenToCareerSeeker}
                            id="normal-switch"
                          />
                        </div>
                      )}
                      {/*
                      <div className="row-10">
                        <label className="profile-label">Tag a Goal</label>
                        <select className="dropdown" name="goalTags" value={this.state.goalTags} onChange={this.formChangeHandler}>
                          {this.state.goalOptions.map(value => <option key={value.title} value={value.title}>{value.title}</option>)}
                        </select>
                      </div>*/}

                      <div className="row-10">
                        <label className="profile-label">Notes<label className="error-color">*</label></label>
                        <textarea type="text" className="text-field" placeholder="Add notes" name="notes" value={this.state.notes} onChange={this.formChangeHandler}></textarea>
                      </div>
                    </div>
                  </div>
                )}

                {(this.state.logType === 'Application') && (
                  <div>
                    <div className="advisor-select-row">
                      <label className="profile-label">Employer Name<label className="error-color">*</label></label>
                      <input className="text-field" type="text" placeholder="employer name" name={"employerName"} value={this.state.employerName} onChange={this.formChangeHandler} />
                    </div>

                    <div className="advisor-select-row">
                      <label className="profile-label">Employer Main Website<label className="error-color">*</label></label>
                      <input className="text-field" type="text" placeholder="employer website" name={"employerURL"} value={this.state.employerURL} onChange={this.formChangeHandler} />
                    </div>

                    <div className="advisor-select-row">
                      <label className="profile-label">Employer Type<label className="error-color">*</label></label>
                      <select className="dropdown" name="employerType" value={this.state.employerType} onChange={this.formChangeHandler}>
                          {this.state.employerTypeOptions.map(value => <option key={value} value={value}>{value}</option>)}
                      </select>
                    </div>

                    <div className="advisor-select-row">
                      <label className="profile-label">Employer Industry<label className="error-color">*</label></label>
                      <select className="dropdown" name="industry" value={this.state.industry} onChange={this.formChangeHandler}>
                          {this.state.industryOptions.map(value => <option key={value} value={value}>{value}</option>)}
                      </select>
                    </div>

                    <div className="advisor-select-row">
                      <label className="profile-label">Employer Size<label className="error-color">*</label></label>
                      <select className="dropdown" name="employeeCount" value={this.state.employeeCount} onChange={this.formChangeHandler}>
                          {this.state.employeeCountOptions.map(value => <option key={value} value={value}>{value}</option>)}
                      </select>
                    </div>

                    <div className="advisor-select-row">
                      <label className="profile-label">Position Title<label className="error-color">*</label></label>
                      <input className="text-field" type="text" placeholder="position title" name={"positionTitle"} value={this.state.positionTitle} onChange={this.formChangeHandler} />
                    </div>

                    <div className="advisor-select-row">
                      <label className="profile-label">Position Link (Optional)</label>
                      <input className="text-field" type="text" placeholder="position link" name={"positionLink"} value={this.state.positionLink} onChange={this.formChangeHandler} />
                    </div>

                    <div className="advisor-select-row">
                      <label className="profile-label">Position Function<label className="error-color">*</label></label>
                      <select className="dropdown" name="jobFunction" value={this.state.jobFunction} onChange={this.formChangeHandler}>
                          {this.state.functionOptions.map(value => <option key={value} value={value}>{value}</option>)}
                      </select>
                    </div>

                    <div className="advisor-select-row">
                      <label className="profile-label">Work Type<label className="error-color">*</label></label>
                      <select className="dropdown" name="workType" value={this.state.workType} onChange={this.formChangeHandler}>
                          {this.state.workTypeOptions.map(value => <option key={value} value={value}>{value}</option>)}
                      </select>
                    </div>

                    <div className="advisor-select-row">
                      <label className="profile-label">Timeframe<label className="error-color">*</label></label>
                      <select className="dropdown" name="timeframe" value={this.state.timeframe} onChange={this.formChangeHandler}>
                          {this.state.timeframeOptions.map(value => <option key={value} value={value}>{value}</option>)}
                      </select>
                    </div>

                    <div className="advisor-select-row">
                      <label className="profile-label">Application Deadline<label className="error-color">*</label></label>
                      <input type="datetime-local" className="date-picker" placeholder="Goal Deadline" name="applicationDeadline" value={this.state.applicationDeadline} onChange={this.formChangeHandler}></input>
                    </div>

                    <label className="profile-label">Mentor Reviewed Materials?<label className="error-color">*</label></label>
                    <select className="dropdown" name="reviewedMaterials" value={this.state.reviewedMaterials} onChange={this.formChangeHandler}>
                        {this.state.binaryOptions.map(value => <option key={value} value={value}>{value}</option>)}
                    </select>

                  </div>
                )}

                {(this.state.logType === 'Interview') && (
                  <div>
                    <div className="advisor-select-row">
                      <label className="profile-label">Associated External Work Application<label className="error-color">*</label></label>
                      <select className="dropdown" name="associatedApplication" value={this.state.associatedApplication.name} onChange={this.formChangeHandler}>
                          {this.state.applicationOptions.map(value => <option key={value} value={value}>{value}</option>)}
                      </select>
                    </div>

                    {(this.state.associatedApplication.name !== 'Attach a Saved Application') && (
                      <div>
                        <div className="advisor-select-row">
                          <label className="profile-label">Date of Interview<label className="error-color">*</label></label>
                          <input type="datetime-local" className="date-picker" name="interviewDate" value={this.state.interviewDate} onChange={this.formChangeHandler}></input>
                        </div>

                        <div className="advisor-select-row">
                          <label className="profile-label">Interview Round<label className="error-color">*</label></label>
                          <select className="dropdown" name="interviewRound" value={this.state.interviewRound} onChange={this.formChangeHandler}>
                              {this.state.interviewRoundOptions.map(value => <option key={value} value={value}>{value}</option>)}
                          </select>
                        </div>
                        {/*
                        <div className="advisor-select-row">
                          <label className="profile-label">Number of Interviews in Round<label className="error-color">*</label></label>
                          <select className="dropdown" name="numberOfInterviews" value={this.state.numberOfInterviews} onChange={this.formChangeHandler}>
                              {this.state.numberOfInterviewsOptions.map(value => <option key={value} value={value}>{value}</option>)}
                          </select>
                        </div>*/}

                        <div className="advisor-select-row">
                          <label className="profile-label">{(Number(this.state.numberOfInterviews) === 1) ? 'Interview Length' : 'Interview Length'}<label className="error-color">*</label></label>
                          <select className="dropdown" name="interviewLength" value={this.state.interviewLength} onChange={this.formChangeHandler}>
                              {this.state.interviewLengthOptions.map(value => <option key={value} value={value}>{value}</option>)}
                          </select>
                        </div>

                        { (Number(this.state.numberOfInterviews) > 0 ) && (
                          <div className="advisor-select-row">
                            <label className="profile-label">Title of Interviewer(s) & Interview Rating(s)<label className="error-color">*</label></label>
                            <div className="spacer"/>
                            {this.renderInterviews()}
                          </div>
                        )}

                        <div className="advisor-select-row">
                          <div className="flex-container row-direction">
                            <div className="flex-50">
                              <label className="profile-label">Practiced Interviewing?</label>
                              <Switch
                                onChange={(change) => this.setState({ mcPracticedInterviewing: change, formHasChanged: true })}
                                checked={this.state.mcPracticedInterviewing}
                                id="normal-switch"
                              />
                            </div>
                            <div className="flex-50">
                              <label className="profile-label">Felt Prepared?</label>
                              <Switch
                                onChange={(change) => this.setState({ wasPrepared: change, formHasChanged: true })}
                                checked={this.state.wasPrepared}
                                id="normal-switch"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="advisor-select-row">
                          <div>
                            <div className="float-left right-padding-15">
                              <label className="profile-label">Questions Asked of You</label>
                            </div>
                            <div className="float-left top-padding-13">
                              <button className="background-button float-left" onClick={() => this.addRemoveItems('Add','','Answered')}>
                                <img src={addCircleOutlineIcon} alt="Compass add icon" className="image-auto-20"/>
                              </button>
                            </div>
                            <div className="clear" />
                          </div>
                          {this.renderItems('Answered')}
                        </div>

                        <div className="advisor-select-row">
                          <div>
                            <div className="float-left right-padding-15">
                              <label className="profile-label">Questions You Asked</label>
                            </div>
                            <div className="float-left top-padding-13">
                              <button className="background-button float-left" onClick={() => this.addRemoveItems('Add','','Asked')}>
                                <img src={addCircleOutlineIcon} alt="Compass add icon" className="image-auto-20"/>
                              </button>
                            </div>
                            <div className="clear" />
                          </div>
                          {this.renderItems('Asked')}
                        </div>
                        {/*
                        <div className="advisor-select-row">
                          <label className="profile-label">Tag topics, unrelated to the position, discussed during the interview.</label>
                          <input className="text-field" type="text" placeholder="Tag the topics, separated by commas ..." name="unrelatedTopics" value={this.state.unrelatedTopics} onChange={this.formChangeHandler} />
                        </div>*/}

                        <div className="advisor-select-row">
                          <label className="profile-label">Rate your interest in the position, and share your thoughts.</label>
                          <select className="dropdown" name="positionRating" value={this.state.positionRating} onChange={this.formChangeHandler}>
                              {this.state.ratingOptions.map(value => <option key={value} value={value}>{value}</option>)}
                          </select>
                          <div className="half-spacer"/>
                          <textarea className="text-field" type="text" placeholder="Write thoughts on the position..." name="thoughtsOnPosition" value={this.state.thoughtsOnPosition} onChange={this.formChangeHandler} />
                        </div>

                        <div className="advisor-select-row">
                          <label className="profile-label">Rate your interest in the company, and share your thoughts.</label>
                          <select className="dropdown" name="companyRating" value={this.state.companyRating} onChange={this.formChangeHandler}>
                              {this.state.ratingOptions.map(value => <option key={value} value={value}>{value}</option>)}
                          </select>
                          <div className="half-spacer"/>
                          <textarea className="text-field" type="text" placeholder="Write thoughts on the company..." name="thoughtsOnCompany" value={this.state.thoughtsOnCompany} onChange={this.formChangeHandler} />
                        </div>

                        <div className="advisor-select-row">
                          <label className="profile-label">Rate your overall fit for the position, and share your thoughts.<label className="error-color">*</label></label>
                          <select className="dropdown" name="fitRating" value={this.state.fitRating} onChange={this.formChangeHandler}>
                              {this.state.ratingOptions.map(value => <option key={value} value={value}>{value}</option>)}
                          </select>
                          <div className="half-spacer"/>
                          <textarea className="text-field" type="text" placeholder="Write thoughts on fit..." name="thoughtsOnFit" value={this.state.thoughtsOnFit} onChange={this.formChangeHandler} />
                        </div>

                        <div className="advisor-select-row">
                          <label className="profile-label">Employer Feedback</label>
                          <textarea className="text-field" type="text" placeholder="Add any feedback from employer..." name="employerFeedback" value={this.state.employerFeedback} onChange={this.formChangeHandler} />
                        </div>

                        <div className="advisor-select-row">
                          <label className="profile-label">Did you pass to the next round?<label className="error-color">*</label></label>
                          <Switch
                            onChange={(change) => this.setState({ passed: change, formHasChanged: true })}
                            checked={this.state.passed}
                            id="normal-switch"
                          />
                        </div>

                        <div className="spacer"/>

                      </div>
                    )}
                  </div>
                )}

                {(this.state.logType === 'Offer') && (
                  <div>

                    <div className="advisor-select-row">
                      <label className="profile-label">Associated External Work Application<label className="error-color">*</label></label>
                      <select className="dropdown" name="offerAssociatedApplication" value={this.state.offerAssociatedApplication.name} onChange={this.formChangeHandler}>
                          {this.state.applicationOptions.map(value => <option key={value} value={value}>{value}</option>)}
                      </select>
                    </div>

                    {(this.state.offerAssociatedApplication.name !== 'Attach a Saved Application') && (
                      <div>
                        <div className="advisor-select-row">
                          <label className="profile-label">Pay Type<label className="error-color">*</label></label>
                          <select className="dropdown" name="offerPayType" value={this.state.offerPayType} onChange={this.formChangeHandler}>
                              {this.state.payTypeOptions.map(value => <option key={value} value={value}>{value}</option>)}
                          </select>
                        </div>

                        <div className="advisor-select-row">
                          <label className="profile-label">Pay<label className="error-color">*</label></label>
                          {(this.state.offerPayType === 'Hourly') ? (
                            <select className="dropdown" name="offerPay" value={this.state.offerPay} onChange={this.formChangeHandler}>
                                {this.state.hourlyPayOptions.map(value => <option key={value} value={value}>{value}</option>)}
                            </select>
                          ) : (
                            <select className="dropdown" name="offerPay" value={this.state.offerPay} onChange={this.formChangeHandler}>
                                {this.state.annualPayOptions.map(value => <option key={value} value={value}>{value}</option>)}
                            </select>
                          )}
                        </div>

                        <div className="advisor-select-row">
                          <label className="profile-label">Do you have a bonus?</label>
                          <Switch
                            onChange={(change) => this.setState({ hasBonus: change, formHasChanged: true })}
                            checked={this.state.hasBonus}
                            id="normal-switch"
                          />
                        </div>

                        {(this.state.hasBonus) && (
                          <div className="advisor-select-row">
                            <label className="profile-label">Bonus Description</label>
                            <textarea className="text-field" type="text" placeholder="Describe your bonus and the estimated amount..." name="bonusDescription" value={this.state.bonusDescription} onChange={this.formChangeHandler} />
                          </div>
                        )}

                        <div className="advisor-select-row">
                          <label className="profile-label">Were you offered equity?</label>
                          <Switch
                            onChange={(change) => this.setState({ offeredEquity: change, formHasChanged: true })}
                            checked={this.state.offeredEquity}
                            id="normal-switch"
                          />
                        </div>

                        {(this.state.offeredEquity) && (
                          <div>
                            <div className="advisor-select-row">
                              <label className="profile-label">Equity Percentage</label>
                              <select className="dropdown" name="equityPercentage" value={this.state.equityPercentage} onChange={this.formChangeHandler}>
                                  {this.state.equityPercentageOptions.map(value => <option key={value} value={value}>{value}</option>)}
                              </select>
                            </div>

                            <div className="advisor-select-row">
                              <label className="profile-label">Company Valuation</label>
                              <select className="dropdown" name="companyValuation" value={this.state.companyValuation} onChange={this.formChangeHandler}>
                                  {this.state.valuationOptions.map(value => <option key={value} value={value}>{value}</option>)}
                              </select>
                            </div>
                          </div>
                        )}

                        <div className="advisor-select-row">
                          <label className="profile-label">Start Date<label className="error-color">*</label></label>
                          <input type="datetime-local" className="date-picker" placeholder="Offer Start Date" name="offerStartDate" value={this.state.offerStartDate} onChange={this.formChangeHandler}></input>
                        </div>

                        <div className="advisor-select-row">
                          <label className="profile-label">Have you accepted?<label className="error-color">*</label></label>
                          <select className="dropdown" name="offerDecision" value={this.state.offerDecision} onChange={this.formChangeHandler}>
                              {this.state.binaryOptions.map(value => <option key={value} value={value}>{value}</option>)}
                          </select>
                        </div>

                        <div className="advisor-select-row">
                          <label className="profile-label">Reason for Decision<label className="error-color">*</label></label>
                          <textarea className="text-field" type="text" placeholder="Why you did you make this decision..." name="decisionReason" value={this.state.decisionReason} onChange={this.formChangeHandler} />
                        </div>
                      </div>
                    )}

                  </div>
                )}

                {(this.state.logType === 'Passion') && (
                  <div>
                    <div className="advisor-select-row">
                      <label className="profile-label">Passion Title<label className="error-color">*</label></label>
                      <input className="text-field" type="text" placeholder="Write the title of your passion..." name="passionTitle" value={this.state.passionTitle} onChange={this.formChangeHandler} />
                    </div>
                    <div className="advisor-select-row">
                      <label className="profile-label">Passion Reason<label className="error-color">*</label></label>
                      <textarea className="text-field" type="text" placeholder="Why are you passionate about this..." name="passionReason" value={this.state.passionReason} onChange={this.formChangeHandler} />
                    </div>
                  </div>
                )}

                {(this.state.logType === 'Notes') && (
                  <div>
                    <div className="row-10">
                      <textarea className="text-field min-height-35-percent" maxlength="5000" type="text" placeholder="Write anything you want..." name="generalNotes" value={this.state.generalNotes} onChange={this.formChangeHandler} />
                      <p className="description-text-2 row-5 description-text-color">Character Limit: 5,000</p>
                    </div>
                  </div>
                )}

                {(this.state.isSaving) && (
                  <div className="flex-container flex-center full-space">
                    <div className="row-20">
                      <img src={loadingGIF} alt="GC" className="image-auto-50 center-horizontally"/>
                      <div className="spacer" /><div className="spacer" />
                      <p className="center-text cta-color bold-text description-text-2">Please wait as the app performs required operations...</p>
                    </div>
                  </div>
                )}

                {(this.state.clientErrorMessage!== '') && <p className="error-color row-15 description-text-2">{this.state.clientErrorMessage}</p> }
                {(this.state.serverPostSuccess) ? (
                  <p className="cta-color row-15 description-text-2">{this.state.serverSuccessMessage}</p>
                ) : (
                  <p className="error-color row-15 description-text-2">{this.state.serverErrorMessage}</p>
                )}

                {(this.state.logType === 'Goal' && this.state.currentPage !== 'Details') ? (
                  <div />
                ) : (
                  <div>
                    {(this.state.confirmDelete) ? (
                      <div>
                        <label className="profile-label">Are you sure you want to delete this {(this.state.logType && this.state.logType !== '') ? (this.state.logType === 'Notes') ? this.state.logType.toLowerCase() + ' Entry' :  this.state.logType.toLowerCase() : 'Log'}?</label>
                        <button className="btn btn-squarish error-background-color left-margin clear-border" onClick={() => this.deleteLog()}>Delete {(this.state.logType && this.state.logType !== '') ? (this.state.logType === 'Notes') ? this.state.logType + ' Entry' :  this.state.logType : 'Log'}</button>
                        <button className="btn btn-squarish white-background cta-color left-margin" onClick={() => this.setState({ confirmDelete: false })}>Cancel</button>
                      </div>
                    ) : (
                      <div>
                        {(this.state.showModule && this.state.logType === 'Goal' && this.state.autoGeneratePlan) ? (
                          <button className={(this.state.isSaving) ? "btn btn-primary medium-background standard-border" : "btn btn-primary"} disabled={(this.state.isSaving) ? true : false} onClick={() => this.saveLog()}>Save Goal & Auto-Generate Goal Plan</button>
                        ) : (
                          <button className={(this.state.isSaving) ? "btn btn-primary medium-background standard-border" : "btn btn-primary"} disabled={(this.state.isSaving) ? true : false} onClick={() => this.saveLog()}>Save {(this.state.logType && this.state.logType !== '') ? (this.state.logType === 'Notes') ? this.state.logType + ' Entry' : this.state.logType : 'Log'}</button>
                        )}
                        {(this.state.editExisting) && (
                          <button className="btn btn-quaternary left-margin" disabled={(this.state.isSaving) ? true : false} onClick={() => this.setState({ confirmDelete: true })}>Delete {(this.state.logType && this.state.logType !== '') ? (this.state.logType === 'Notes') ? this.state.logType + ' Entry' :  this.state.logType : 'Log'}</button>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          {(!this.props.modalView && window.innerWidth > 768 && this.state.editExisting && this.state.logType === 'Goal') && (
            <div className="relative-column-30 horizontal-padding top-margin-40">
              <div className="left-padding-20">

                {(this.state.showModule2) && (
                  <div className="card-clear-padding min-width-100 max-width-310 bottom-margin-20">
                    <div className="full-width height-5 senary-background" />
                    <div className="padding-20">
                      <p className="heading-text-5">Actions</p>

                      <div className="spacer" /><div className="half-spacer" />

                      <button onClick={() =>  console.log('')} className="background-button full-width left-text row-15">
                        <div className="fixed-column-40 top-margin-3">
                          <img src={saveIconDark} alt="GC" className="image-20-fit"/>
                        </div>
                        <div className="calc-column-offset-40">
                          <p className="heading-text-6">Save Goal</p>
                        </div>
                        {/*
                        <div className="fixed-column-30 top-margin-3">
                          <img src={arrowIndicatorIcon} alt="GC" className="image-auto-20"/>
                        </div>*/}
                        <div className="clear" />
                      </button>

                      <hr />

                      <button onClick={() =>  console.log('')} className="background-button full-width left-text row-15">
                        <div className="fixed-column-40 top-margin-3">
                          <img src={trashIconDark} alt="GC" className="image-20-fit"/>
                        </div>
                        <div className="calc-column-offset-40">
                          <p className="heading-text-6">Delete Goal</p>
                        </div>
                        {/*
                        <div className="fixed-column-30 top-margin-3">
                          <img src={arrowIndicatorIcon} alt="GC" className="image-auto-20"/>
                        </div>*/}
                        <div className="clear" />
                      </button>

                      <hr />

                      <button onClick={() =>  console.log('')} className="background-button full-width left-text row-15">
                        <div className="fixed-column-40 top-margin-3">
                          <img src={newsFeedIconDark} alt="GC" className="image-20-fit"/>
                        </div>
                        <div className="calc-column-offset-40">
                          <p className="heading-text-6">Post Goal</p>
                        </div>
                        {/*
                        <div className="fixed-column-30 top-margin-3">
                          <img src={arrowIndicatorIcon} alt="GC" className="image-auto-20"/>
                        </div>*/}
                        <div className="clear" />
                      </button>

                      <hr />

                      <button onClick={() =>  console.log('')} className="background-button full-width left-text row-15">
                        <div className="fixed-column-40 top-margin-3">
                          <img src={shareIconDark} alt="GC" className="image-20-fit"/>
                        </div>
                        <div className="calc-column-offset-40">
                          <p className="heading-text-6">Share Goal</p>
                        </div>
                        {/*
                        <div className="fixed-column-30 top-margin-3">
                          <img src={arrowIndicatorIcon} alt="GC" className="image-auto-20"/>
                        </div>*/}
                        <div className="clear" />
                      </button>

                      <hr />

                      <button onClick={() =>  console.log('')} className="background-button full-width left-text row-15">
                        <div className="fixed-column-40 top-margin-3">
                          <img src={sendIconDark} alt="GC" className="image-20-fit"/>
                        </div>
                        <div className="calc-column-offset-40">
                          <p className="heading-text-6">Send Goal</p>
                        </div>
                        {/*
                        <div className="fixed-column-30 top-margin-3">
                          <img src={arrowIndicatorIcon} alt="GC" className="image-auto-20"/>
                        </div>*/}
                        <div className="clear" />
                      </button>

                    </div>
                  </div>
                )}

                {(this.state.showCompassAssistant && !this.state.disableChatbotPrompts && this.state.goalCommands && this.state.goalCommands.length > 0) && (
                  <div>
                    <SubAssistantWidget commands={this.state.goalCommands} commandClicked={this.commandClicked} />
                  </div>
                )}

                {(this.state.plans && this.state.plans.length > 0) && (
                  <div>
                    <div className="card-clear-padding min-width-100 max-width-310 bottom-margin-20">
                      <div className="full-width height-5 senary-background" />
                      <div className="padding-20">
                        <p className="heading-text-5">Plans</p>

                        <div className="spacer" /><div className="spacer" />

                        {(this.state.plans && this.state.plans.length > 0) ? (
                          <div>
                            {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="error-color description-text-2 row-5">{this.state.errorMessage}</p>}
                            {(this.state.successMessage && this.state.successMessage !== '') && <p className="cta-color description-text-2 row-5">{this.state.successMessage}</p>}

                            {this.state.plans.map((item, optionIndex) =>
                              <div key={item}>
                                {(optionIndex < 3) && (
                                  <div>
                                    <Link to={this.state.prefix + "/documents/" + item._id} className="background-button full-width">
                                      <div className="calc-column-offset-30">
                                        <p className="heading-text-6">{item.fileName}</p>
                                        <p className="standard-color top-margin-5 description-text-1">AI-Generated Plan</p>
                                      </div>
                                      <div className="fixed-column-30 top-margin-3">
                                        <img src={arrowIndicatorIcon} alt="GC" className="image-auto-20"/>
                                      </div>
                                      <div className="clear" />
                                    </Link>

                                    <div className="row-10">
                                      <hr />
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                            <div className="clear" />

                            {(this.state.plans.length > 0) && (
                              <button className="background-button full-width right-text" onClick={() => this.props.navigate(this.state.prefix + '/documents')}>
                                <p className="description-text-2">See All <label className="description-text-2 left-padding-5">></label></p>
                              </button>
                            )}
                          </div>
                        ) : (
                          <div>
                            <div className="row-10">
                              <p className="error-color">You have not received suggestions yet.</p>
                            </div>

                            {(this.state.editExisting && !this.state.remoteAuth) && (
                              <div className="row-10">
                                {(this.state.publicProfile && this.state.publicProfileExtent && this.state.publicPreferences && this.state.publicPreferences[2] && (this.state.publicPreferences[2].value === 'All' || this.state.publicPreferences[2].value === 'Some')) ? (
                                  <div className="standard-border padding-20">
                                    <p className="description-text-1">Share this link to crowdsource resources for this goal: <a href={window.location.protocol + "//" + window.location.host + '/goals/' + this.state.goalId} target="_blank" rel="noopener noreferrer" className="wrap-word">{window.location.protocol + "//" + window.location.host + '/goals/' + this.state.goalId}</a>. If you want to make your goal private, you can do so <Link to={this.state.prefix + "/edit-profile/public-preferences"}>here</Link>.</p>
                                  </div>
                                ) : (
                                  <div className="standard-border padding-20">
                                    <p className="description-text-1">To crowdsource resources for this goal, make it public <Link to={this.state.prefix + "/edit-profile/public-preferences"}>here</Link>, then share this link: <a href={window.location.protocol + "//" + window.location.host + '/goals/' + this.state.goalId} target="_blank" rel="noopener noreferrer">{window.location.protocol + "//" + window.location.host + '/goals/' + this.state.goalId}</a>.</p>
                                  </div>
                                )}
                              </div>
                            )}

                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="card-clear-padding min-width-100 max-width-310 bottom-margin-20">
                  <div className="full-width height-5 senary-background" />
                  <div className="padding-20">
                    <p className="heading-text-5">Suggestions</p>

                    <div className="spacer" /><div className="spacer" />

                    {(this.state.suggestions && this.state.suggestions.length > 0) ? (
                      <div>
                        {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="error-color description-text-2 row-5">{this.state.errorMessage}</p>}
                        {(this.state.successMessage && this.state.successMessage !== '') && <p className="cta-color description-text-2 row-5">{this.state.successMessage}</p>}

                        {this.state.suggestions.map((item, optionIndex) =>
                          <div key={item}>
                            {(optionIndex < 3) && (
                              <div>
                                <SubRenderSuggestion history={this.props.navigate}
                                  suggestion={item} index={optionIndex}
                                  inModal={false} sideNav={true} suggestions={this.state.suggestions}
                                  closeModal={this.closeModal}
                                />

                                <div className="row-10">
                                  <hr />
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        <div className="clear" />

                        {(this.state.suggestions.length > 0) && (
                          <button className="background-button full-width right-text" onClick={() => this.setState({ modalIsOpen: true, showSuggestions: true })}>
                            <p className="description-text-2">See All <label className="description-text-2 left-padding-5">></label></p>
                          </button>
                        )}
                      </div>
                    ) : (
                      <div>
                        <div className="row-10 bottom-margin">
                          <p className="error-color description-text-1">You have not received suggestions yet.</p>
                        </div>

                        {(this.state.editExisting && !this.state.remoteAuth) && (
                          <div className="row-10">
                            {(this.state.publicProfile && this.state.publicProfileExtent && this.state.publicPreferences && this.state.publicPreferences[2] && (this.state.publicPreferences[2].value === 'All' || this.state.publicPreferences[2].value === 'Some')) ? (
                              <div className="standard-border padding-20">
                                <p className="description-text-1">Share this link to crowdsource resources for this goal:</p><p><a href={window.location.protocol + "//" + window.location.host + '/goals/' + this.state.goalId} target="_blank" rel="noopener noreferrer" className="wrap-word">{window.location.protocol + "//" + window.location.host + '/goals/' + this.state.goalId}</a>.</p>
                              </div>
                            ) : (
                              <div className="standard-border padding-20">
                                <p className="description-text-1">To crowdsource resources for this goal, make it public <Link to={this.state.prefix + "/edit-profile/public-preferences"}>here</Link>, then share this link: <a href={window.location.protocol + "//" + window.location.host + '/goals/' + this.state.goalId} target="_blank" rel="noopener noreferrer">{window.location.protocol + "//" + window.location.host + '/goals/' + this.state.goalId}</a>.</p>
                              </div>
                            )}
                          </div>
                        )}

                      </div>
                    )}
                  </div>
                </div>

                {(this.state.relatedMembers && this.state.relatedMembers.length > 0) && (
                  <div className="card-clear-padding min-width-100 max-width-310 bottom-margin-20">
                    <div className="full-width height-5 senary-background" />
                    <div className="padding-20">
                      <p className="heading-text-5">People w/ Similar Goals</p>

                      <div className="spacer" /><div className="half-spacer" />

                      {this.state.relatedMembers.map((item, index) =>
                        <div key={item}>
                          {(index < 3 && item.email !== this.state.emailId) && (
                            <div className="bottom-padding">
                              <div className="spacer" />
                              <Link to={(this.state.pageSource === 'landingPage') ? '/' + item.username + '/profile' : this.state.prefix + '/profile/' + item.username} className="background-link">
                                <div className="fixed-column-50">
                                  <img src={(item.pictureURL) ? item.pictureURL : profileIconDark} alt="GC" className="profile-thumbnail-1" />
                                </div>
                                <div className="calc-column-offset-90 left-padding-5">
                                  <p>{item.firstName} {item.lastName}</p>
                                  <p className="description-text-2 standard-color">{item.title}</p>
                                </div>
                              </Link>
                              <div className="float-left left-padding">
                                <span className="float-right">
                                  <div className="spacer"/>
                                  <Link to={(this.state.pageSource === 'landingPage') ? '/opportunities/organizations/' + this.state.activeOrg + '/' + item._id : this.state.prefix + '/opportunities/' + item._id} state={{ selectedOpportunity: item }} className="background-link">
                                    <img src={arrowIndicatorIcon} alt="Compass arrow indicator icon" className="image-auto-22"/>
                                  </Link>
                                </span>
                              </div>
                              <div className="clear"/>

                              <div className="spacer" /><div className="spacer" />
                              <hr />
                              <div className="clear"/>
                              <div className="spacer" />
                            </div>
                          )}
                        </div>
                      )}

                      {(this.state.relatedMembers.length > 0) && (
                        <div>
                          <Link className="background-button full-width right-text" to={(this.state.pageSource === 'landingPage') ? '/profiles/organizations/' + this.state.activeOrg : this.state.prefix + '/browse-goals'}>
                            <p className="description-text-2">See More <label className="description-text-2 left-padding-5">></label></p>
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {(this.state.relatedOpportunities && this.state.relatedOpportunities.length > 0) && (
                  <div className="card-clear-padding min-width-100 max-width-310 bottom-margin-20">
                    <div className="full-width height-5 senary-background" />
                    <div className="padding-20">
                      <p className="heading-text-5">Related Opportunities</p>

                      <div className="spacer" /><div className="half-spacer" />

                      {this.state.relatedOpportunities.map((item, index) =>
                        <div key={item}>
                          {(index < 3) && (
                            <div className="bottom-padding">
                              <div className="spacer" />
                              <Link to={(this.state.pageSource === 'landingPage') ? '/opportunities/organizations/' + this.state.activeOrg + '/' + item._id : this.state.prefix + '/opportunities/' + item._id} state={{ selectedOpportunity: item }} className="background-link">
                                <div className="fixed-column-50">
                                  <img src={(item.imageURL) ? item.imageURL : (item.postType === 'Work' || item.postType === 'Internship') ? opportunitiesIconDark : (item.postType === "Project") ? projectsIconDark : calendarIconDark} alt="GC" className="image-35-fit" />
                                </div>
                                <div className="calc-column-offset-90 left-padding-5">
                                  <p>{(item.name) ? item.name : item.title}</p>
                                  <p className="description-text-2 standard-color">{item.postType}{(item.employerName) && " @ " + item.employerName}</p>
                                </div>
                              </Link>
                              <div className="float-left left-padding">
                                <span className="float-right">
                                  <div className="spacer"/>
                                  <Link to={(this.state.pageSource === 'landingPage') ? '/opportunities/organizations/' + this.state.activeOrg + '/' + item._id : this.state.prefix + '/opportunities/' + item._id} state={{ selectedOpportunity: item }} className="background-link">
                                    <img src={arrowIndicatorIcon} alt="Compass arrow indicator icon" className="image-auto-22"/>
                                  </Link>
                                </span>
                              </div>
                              <div className="clear"/>

                              <div className="spacer" /><div className="spacer" />
                              <hr />
                              <div className="clear"/>
                              <div className="spacer" />
                            </div>
                          )}
                        </div>
                      )}

                      {(this.state.relatedOpportunities.length > 0) && (
                        <div>
                          <Link className="background-button full-width right-text" to={(this.state.pageSource === 'landingPage') ? '/opportunities/organizations/' + this.state.activeOrg : this.state.prefix + '/opportunities' + this.state.activeOrg}>
                            <p className="description-text-2">See More <label className="description-text-2 left-padding-5">></label></p>
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {(this.state.relatedCourses && this.state.relatedCourses.length > 0) && (
                  <div className="card-clear-padding min-width-100 max-width-310 bottom-margin-20">
                    <div className="full-width height-5 senary-background" />
                    <div className="padding-20">
                      <p className="heading-text-5">Related Courses</p>

                      <div className="spacer" /><div className="half-spacer" />

                      {this.state.relatedCourses.map((item, index) =>
                        <div key={item}>

                          {(index < 3) && (
                            <div className="bottom-padding">
                              <div className="spacer" />
                              <a href={'https://www.udemy.com' + item.url} target="_blank" rel="noopener noreferrer">
                                <div>
                                  <div className="calc-column-offset-40">
                                    <img src={item.image_125_H} alt="GC" className="image-70-auto" />
                                  </div>
                                  <div className="fixed-column-40">
                                    <span className="float-right">
                                      <div className="spacer"/>
                                      <img src={linkIcon} alt="Compass arrow indicator icon" className="image-auto-22"/>
                                    </span>
                                  </div>
                                  <div className="clear"/>
                                </div>

                                <div className="full-width top-padding">
                                  <p>{item.title}</p>
                                  <p className="description-text-2 standard-color">{item.headline}</p>
                                </div>
                              </a>

                              <div className="spacer" /><div className="spacer" />
                              <hr />
                              <div className="clear"/>
                              <div className="spacer" />
                            </div>
                          )}
                        </div>
                      )}

                      {(this.state.relatedCourses.length > 0) && (
                        <div>
                          <Link className="background-button full-width right-text" to={(this.state.pageSource === 'landingPage') ? '/courses' : this.state.prefix + '/courses'} state={{ subNavSelected: 'Courses' }}>
                            <p className="description-text-2">See More <label className="description-text-2 left-padding-5">></label></p>
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          <div className="clear" />
        </div>
      )
    }

    renderShareButtons() {
      console.log('renderShareButtons called')

      return (
        <div key="renderShareButtons">
          <EmailShareButton url={this.state.shareURL} subject={this.state.shareTitle} body={this.state.shareBody} className="horizontal-margin-5" data-tooltip-id="tooltip-placeholder-id" data-tooltip-content="Email">
            <EmailIcon size={32} round />
          </EmailShareButton>

          <FacebookShareButton url={this.state.shareURL} quote={this.state.shareTitle} className="horizontal-margin-5" data-tooltip-id="tooltip-placeholder-id" data-tooltip-content="Facebook">
            <FacebookIcon size={32} round />
          </FacebookShareButton>

          <LinkedinShareButton url={this.state.shareURL} title={this.state.shareTitle} summary={(this.state.selectedGoal.description) ? this.state.selectedGoal.description : ''} source={window.location.protocol + "//" + window.location.host} className="horizontal-margin-5" data-tooltip-id="tooltip-placeholder-id" data-tooltip-content="LinkedIn">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>

          <PinterestShareButton url={this.state.shareURL} description={this.state.shareTitle} className="horizontal-margin-5" data-tooltip-id="tooltip-placeholder-id" data-tooltip-content="Pinterest">
            <PinterestIcon size={32} round />
          </PinterestShareButton>

          <WhatsappShareButton url={this.state.shareURL} title={this.state.shareTitle} className="horizontal-margin-5" data-tooltip-id="tooltip-placeholder-id" data-tooltip-content="Whatsapp">
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>

          <WorkplaceShareButton url={this.state.shareURL} quote={this.state.shareTitle} className="horizontal-margin-5"  data-tooltip-id="tooltip-placeholder-id" data-tooltip-content="Workplace by Facebook">
            <WorkplaceIcon size={32} round />
          </WorkplaceShareButton>

          <TwitterShareButton url={this.state.shareURL} title={this.state.shareTitle} className="horizontal-margin-5"  data-tooltip-id="tooltip-placeholder-id" data-tooltip-content="Twitter">
            <TwitterIcon size={32} round />
          </TwitterShareButton>

          <RedditShareButton url={this.state.shareURL} title={this.state.shareTitle} className="horizontal-margin-5" data-tooltip-id="tooltip-placeholder-id" data-tooltip-content="Reddit">
            <RedditIcon size={32} round />
          </RedditShareButton>

          <div className="clear" />

          <ReactTooltip id="tooltip-placeholder-id" />

        </div>
      )
    }

    editItem(index,itemType,editType) {
      console.log('editItem called')


      let checklist = this.state.checklist
      if (editType === 'checked') {
        if (checklist[index].checked) {
          checklist[index]['checked'] = false
        } else {
          checklist[index]['checked'] = true
        }
      } else {
        if (checklist[index].editMode) {
          checklist[index]['editMode'] = false
        } else {
          checklist[index]['editMode'] = true
        }
      }

      this.setState({ checklist })
    }

    renderChecklistIcon(item) {
      console.log('renderChecklistIcon called', item.category)
      // resume, cover letter
      if (item.category === 'Advising Session') {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/mentoring-icon-dark.png';
      } else if (item.category === 'Article') {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/news-feed-icon-dark.png';
      } else if (item.category === 'Course') {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/course-icon-dark.png';
      } else if (item.category === 'Cover Letter') {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/cover-letter-icon-dark.png';
      } else if (item.category === 'Endorsement') {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/endorsement-icon-dark.png';
      } else if (item.category === 'Event') {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/event-icon-dark.png';
      } else if (item.category === 'Interview') {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/mentoring-icon-dark.png';
      } else if (item.category === 'Lesson Module') {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/course-icon-dark.png';
      } else if (item.category === 'News Source') {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/news-feed-icon-dark.png';
      } else if (item.category === 'Project') {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/projects-icon-dark.png';
      } else if (item.category === 'Resume') {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/resume-icon-dark.png';
      } else if (item.category === 'Training Program') {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/course-icon-dark.png';
      } else if (item.category === 'Video') {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/video-icon-dark.png';
      } else if (item.category === 'Work') {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/opportunities-icon-dark.png';
      } else {
        return 'https://guidedcompass-bucket.s3.us-west-2.amazonaws.com/appImages/opportunities-icon-dark.png';
      }
    }

    commandClicked(command) {
      console.log('commandClicked called')

      this.props.commandClicked(command)

    }

    render() {
      console.log('rendered SubEditLog', this.state.modalIsOpen)

      return (
          <div>
            {(this.state.modalIsOpen && this.props.modalView) ? (
                <Modal
                 isOpen={this.state.modalIsOpen}
                 onAfterOpen={this.afterOpenModal}
                 onRequestClose={this.closeModal}
                 className="modal"
                 overlayClassName="modal-overlay"
                 contentLabel="Example Modal"
               >
                 <div key="info" className={(window.innerWidth < 768 && window.location.pathname.includes('/walkthrough')) ? "full-width" : "full-width padding-40"}>
                  {this.renderDetails()}
                 </div>
              </Modal>
            ) : (
              <div>
                {this.renderDetails()}
              </div>
            )}

            {(!this.props.modalView) && (
              <Modal
               isOpen={this.state.modalIsOpen}
               onAfterOpen={this.afterOpenModal}
               onRequestClose={this.closeModal}
               className="modal"
               overlayClassName="modal-overlay"
               contentLabel="Example Modal"
             >

              {(this.state.showSmartDefinition) && (
                <div key="info" className="full-width padding-40">
                  <div>
                      <div className="calc-column-offset-40">
                        <p className="heading-text-2">S.M.A.R.T. Goals Defined</p>
                      </div>
                      <div className="fixed-column-40">
                        <button className="background-button top-margin" onClick={() => this.closeModal()}>
                          <img src={closeIcon} alt="GC" className="image-auto-20" />
                        </button>
                      </div>
                      <div className="clear" />
                  </div>

                  <div className="spacer" /><div className="spacer" />

                  <p className="heading-text-6">All goals should be:</p>

                  <div className="row-10 heading-text-6">
                    <p className="top-margin-20"><label className="bold-text heading-text-4">S</label>pecific</p>
                    <p className="top-margin-20"><label className="bold-text heading-text-4">M</label>easurable</p>
                    <p className="top-margin-20"><label className="bold-text heading-text-4">A</label>chievable</p>
                    <p className="top-margin-20"><label className="bold-text heading-text-4">R</label>elevant</p>
                    <p className="top-margin-20"><label className="bold-text heading-text-4">T</label>ime-Bound</p>
                  </div>

                </div>
              )}

              {(this.state.showStrategyDefinition) && (
                <div key="info" className="full-width padding-40">
                  <div>
                    <div className="calc-column-offset-40">
                      <p className="heading-text-2">Strategies & Tactics Defined</p>
                    </div>
                    <div className="fixed-column-40">
                      <button className="background-button top-margin" onClick={() => this.closeModal()}>
                        <img src={closeIcon} alt="GC" className="image-auto-20" />
                      </button>
                    </div>
                    <div className="clear" />
                  </div>

                  <div className="spacer" /><div className="spacer" />

                  <p>In order to achieve your goal, we recommend you implement strategies & tactics. Tactics are a subset of a strategy. Here are definitions:</p>

                  <div className="row-10">
                    <div className="top-margin-20">
                      <p><label className="bold-text cta-color">Strategy</label> is defined as a plan of action or policy designed to achieve a major or overall aim. For example, in order to achieve my goal of landing a software engineering job, I need to code everyday.</p>
                    </div>
                    <div className="top-margin-20">
                      <p><label className="bold-text cta-color">Tactic</label> is defined as an action carefully planned to achieve a specific end. For example, since my strategy is to code everyday, one of my tactics may be to code for 30 minutes after I exercise in the morning; another tactic may be to set a daily alarm.</p>
                    </div>
                  </div>

                </div>
              )}

              {(this.state.showAIPlanExplanation) && (
                <div key="info" className="full-width padding-40">
                  <div>
                    <div className="calc-column-offset-40">
                      <p className="heading-text-2">How Your AI-Generated Goal Plan Works</p>
                    </div>
                    <div className="fixed-column-40">
                      <button className="background-button top-margin" onClick={() => this.closeModal()}>
                        <img src={closeIcon} alt="GC" className="image-auto-20" />
                      </button>
                    </div>
                    <div className="clear" />
                  </div>

                  <div className="spacer" /><div className="spacer" /><div className="spacer" />

                  <div className="row-15">
                    <p>Guided Compass uses AI technology to create a personalized plan for your goals, taking into account your unique profile details like interests, skills, values, personality, education, and experiences. Here’s how it helps you:</p>
                  </div>

                  <div className="row-15">
                    <ul className="left-padding-20">
                      <li className="row-10"><label className="bold-text">Get Your Plan:</label> Once generated, your plan is emailed to you and saved in the documents section of your profile for easy access.</li>
                      <li className="row-10"><label className="bold-text">Edit and Collaborate:</label> You can edit your plan and share it with friends or mentors for feedback.</li>
                      <li className="row-10"><label className="bold-text">Stay Updated:</label> As you make progress or update your profile, regenerate your plan to reflect new milestones and keep on track.</li>
                      <li className="row-10"><label className="bold-text">Need Help?:</label> If you need more support, don’t hesitate to contact your community administrator or the Guided Compass team. We're here to help you succeed!</li>
                    </ul>
                  </div>

                </div>
              )}

              {(this.state.showAICreditExplanation) && (
                <div key="info" className="full-width padding-40">
                  <div>
                    <div className="calc-column-offset-40">
                      <p className="heading-text-2">How AI Credits Work</p>
                    </div>
                    <div className="fixed-column-40">
                      <button className="background-button top-margin" onClick={() => this.closeModal()}>
                        <img src={closeIcon} alt="GC" className="image-auto-20" />
                      </button>
                    </div>
                    <div className="clear" />
                  </div>

                  <div className="spacer" /><div className="spacer" /><div className="spacer" />

                  <div className="row-15">
                    <p>Since AI capabilities are costly, users must expend AI credits to use AI capabilities. Users all receive {this.state.startingCredits} credits for free. Additional credits may be purchased for $1 per credit or sponsored by your community administrator.</p>
                  </div>

                  <div className="row-15">
                    <p>Email <label className="bold-text cta-color">help@guidedcompass.com</label> if you have any questions.</p>
                  </div>

                </div>
              )}
              {/*
              {(this.state.showFeedback) && (
                <div key="info" className="full-width padding-40">
                  <div>
                    <div className="calc-column-offset-40">
                      <p className="heading-text-2">Was This Useful?</p>
                    </div>
                    <div className="fixed-column-40">
                      <button className="background-button top-margin" onClick={() => this.closeModal()}>
                        <img src={closeIcon} alt="GC" className="image-auto-20" />
                      </button>
                    </div>
                    <div className="clear" />
                  </div>

                  <div className="spacer" /><div className="spacer" />

                  {this.renderSuggestion(this.state.selectedSuggestion,this.state.selectedIndex,true)}

                  <div className="row-10">

                    <button className="background-button" onClick={() => this.itemClicked(this.state.selectedSuggestion,this.state.selectedIndex,'up')}>
                      <img src={(this.state.selectedSuggestion.liked) ? thumbsUpBlueIcon : thumbsUpIcon} alt="GC" className="image-auto-30" data-tooltip-id="tooltip-placeholder-id" data-tooltip-content="Like this suggestion" />
                    </button>
                    <button className="background-button left-margin-15" onClick={() => this.itemClicked(this.state.selectedSuggestion,this.state.selectedIndex,'down')}>
                      <img src={(this.state.selectedSuggestion.disliked) ? thumbsDownOrangeIcon : thumbsDownIcon} alt="GC" className="image-auto-30" data-tooltip-id="tooltip-placeholder-id" data-tooltip-content="Dislike this suggestion" />
                    </button>

                    <div className="row-10">
                      <textarea className="text-field" type="text" placeholder="How were you able to use their suggstion(s)/resource(s)?" name="feedback" value={this.state.selectedSuggestion.feedback} onChange={this.formChangeHandler} />
                    </div>
                  </div>

                  {(this.state.errorMessage && this.state.errorMessage !== '') && <p className="error-color description-text-2 row-5">{this.state.errorMessage}</p>}
                  {(this.state.successMessage && this.state.successMessage !== '') && <p className="cta-color description-text-2 row-5">{this.state.successMessage}</p>}

                  {(this.state.selectedSuggestion.feedback) && (
                    <div className="top-margin-20">
                      <button className="btn btn-primary" onClick={() => this.saveSuggestion(this.state.selectedSuggestion,true)}>Send Feedback</button>
                    </div>
                  )}

                </div>
              )}*/}

              {(this.state.showShareButtons) && (
                <div key="showDescription" className="full-width padding-20 center-text">
                   <p className="heading-text-2">Share Your {this.state.selectedGoal.title} Goal with Friends!</p>

                   {(this.state.publicProfile && this.state.publicProfileExtent && this.state.publicPreferences && this.state.publicPreferences[2] && (this.state.publicPreferences[2].value === 'All' || this.state.publicPreferences[2].value === 'Some')) ? (
                     <div>
                       <div className="top-padding-20">
                         <p>Share this link:</p>
                         <a href={this.state.shareURL} target="_blank">{this.state.shareURL}</a>
                       </div>

                       <div className="spacer" />

                       <div className="top-padding-20">
                         {this.renderShareButtons()}
                       </div>
                     </div>
                   ) : (
                     <div>
                       <p className="top-margin">To crowdsource resources for this goal, make it public <Link to={this.state.prefix + "/edit-profile/public-preferences"}>here</Link>, then share this link: <a href={window.location.protocol + "//" + window.location.host + '/goals/' + this.state.goalId} target="_blank" rel="noopener noreferrer">{window.location.protocol + "//" + window.location.host + '/goals/' + this.state.goalId}</a>.</p>
                     </div>
                   )}

                 </div>
              )}

              {(this.state.showPost) && (
                <div key="showPost" className="full-width padding-20">
                   <SubCreatePost sharePosting={this.state.sharePosting} originalPost={this.state.originalPost} posts={this.state.posts} closeModal={this.closeModal} pictureURL={this.state.pictureURL} selectedGoal={this.state.selectedGoal} passPosts={() => this.setState({ successMessage: 'Successfully posted!'})}/>
                 </div>
              )}

              {(this.state.showSuggestions) && (
                <div key="showPost" className="full-width padding-20">
                  {(this.state.selectedSuggestion) ? (
                    <div>
                      <SubRenderSuggestion history={this.props.navigate}
                        suggestion={this.state.selectedSuggestion} index={null}
                        inModal={true} sideNav={null} suggestions={this.state.suggestions}
                        closeModal={this.closeModal}
                      />
                    </div>
                  ) : (
                    <div>
                      {this.state.suggestions.map((item, optionIndex) =>
                        <div key={item}>
                          <SubRenderSuggestion history={this.props.navigate}
                            suggestion={item} index={optionIndex}
                            inModal={true} sideNav={null} suggestions={this.state.suggestions}
                            closeModal={this.closeModal}
                          />
                        </div>
                      )}
                    </div>
                  )}

                  <button className="btn btn-secondary" onClick={() => this.closeModal()}>Close View</button>
                 </div>
              )}

            </Modal>
            )}
          </div>

      )
    }
}

export default withRouter(EditLog);
// If you want to make your goal private, you can do so <Link to={this.state.prefix + "/edit-profile/public-preferences"}>here</Link>.
